import { jsx as l, jsxs as b, Fragment as Pe } from "react/jsx-runtime";
import * as qt from "react";
import q, { useState as G, useRef as Ae, useCallback as ge, createContext as wr, useMemo as Te, forwardRef as nt, useContext as nr, useEffect as J, createElement as yn, Children as Yn, cloneElement as Fo, isValidElement as Ho, useImperativeHandle as Wr, useId as Ur, useLayoutEffect as da, memo as wn } from "react";
import { twJoin as _, twMerge as le } from "tailwind-merge";
import * as fa from "react-dom";
import { createPortal as ha } from "react-dom";
function St({
  value: e,
  defaultValue: t,
  onStateChange: r
} = {}) {
  const [n, i] = G(t), { current: o } = Ae(e != null), s = o ? e : n, a = ge(
    (c) => {
      o || i(c), r == null || r(c);
    },
    [o, r, i]
  );
  return [s, a];
}
const ai = wr({
  disabled: !1,
  expanded: !1
});
function dd({
  expanded: e,
  defaultExpanded: t,
  onChange: r,
  className: n,
  disabled: i = !1,
  fluid: o = !1,
  children: s
}) {
  const [a = !1, c] = St({
    value: e,
    defaultValue: t,
    onStateChange: r
  }), d = ge(() => {
    c(!a);
  }, [c, a]), u = Te(
    () => ({
      defaultExpanded: t,
      disabled: i,
      expanded: a && !i,
      toggle: i ? void 0 : d
    }),
    [t, a, i, d]
  );
  return /* @__PURE__ */ l(ai.Provider, { value: u, children: /* @__PURE__ */ l("div", { className: _("bbn-accordion", i && "bbn-accordion-disabled", o && "bbn-accordion-fluid", n), children: s }) });
}
const Me = nt(
  ({
    variant: e = "contained",
    size: t = "large",
    color: r = "primary",
    fluid: n = !1,
    rounded: i = !1,
    className: o,
    disabled: s,
    ...a
  }, c) => /* @__PURE__ */ l(
    "button",
    {
      ...a,
      disabled: s,
      ref: c,
      className: _(
        "bbn-btn",
        `bbn-btn-${e}`,
        `bbn-btn-${r}`,
        `bbn-btn-${t}`,
        n && "bbn-btn-fluid",
        i && "bbn-btn-rounded",
        o
      )
    }
  )
);
Me.displayName = "Button";
const li = nt(
  ({ variant: e = "outlined", size: t = "large", className: r, ...n }, i) => /* @__PURE__ */ l(
    "button",
    {
      ...n,
      ref: i,
      className: _(
        "bbn-btn-icon",
        `bbn-btn-icon-${e}`,
        `bbn-btn-icon-${t}`,
        r
      )
    }
  )
), Io = nt(
  ({ className: e, ...t }, r) => /* @__PURE__ */ l(
    Me,
    {
      ...t,
      ref: r,
      variant: "contained",
      className: _(
        "!bg-error-main text-white font-medium !text-sm hover:!bg-error-main/90 transition-colors",
        e
      )
    }
  )
);
Io.displayName = "WalletDisconnectButton";
function fd({
  className: e,
  iconClassName: t,
  iconProps: r,
  children: n,
  renderIcon: i = () => null
}) {
  const { expanded: o, toggle: s } = nr(ai), a = i(o);
  return /* @__PURE__ */ b("div", { className: _("bbn-accordion-summary", e), onClick: s, children: [
    n,
    a && /* @__PURE__ */ l(li, { className: _("bbn-accordion-icon", t), ...r, children: a })
  ] });
}
function ci(e, t) {
  return typeof e != "number" ? typeof t == "number" ? ci(t) : t : `${e}px`;
}
function ma(e = !0) {
  const [t, r] = G("0px"), [n, i] = G(), o = Ae(null);
  return J(() => {
    const s = new ResizeObserver((a) => {
      const [c] = a;
      r(ci(c.target.clientHeight) ?? "0px");
    });
    i(s);
  }, []), J(
    function() {
      const { current: a } = o;
      if (!(!e || !a))
        return n == null || n.observe(a), () => {
          n == null || n.unobserve(a);
        };
    },
    [e, n]
  ), { height: t, ref: o };
}
function hd({
  unmountOnExit: e = !1,
  animationDuration: t = 200,
  className: r,
  wrapperClassName: n,
  children: i
}) {
  const { expanded: o } = nr(ai), [s, a] = G(o), c = s || !e, { height: d, ref: u } = ma(c);
  return J(
    function() {
      if (o === s)
        return;
      if (o) {
        a(!0);
        return;
      }
      const p = setTimeout(a, t, !1);
      return () => {
        clearTimeout(p);
      };
    },
    [o, s, t]
  ), /* @__PURE__ */ l(
    "div",
    {
      className: _("bbn-accordion-details", n),
      style: {
        height: o ? d : "0px",
        visibility: s ? "visible" : "hidden",
        transitionDuration: `${t}ms`
      },
      children: c ? /* @__PURE__ */ l("div", { ref: u, className: _("bbn-accordion-content", r), children: i }) : null
    }
  );
}
const Z = nt(
  ({ variant: e = "body1", as: t = "p", children: r, className: n, ...i }, o) => yn(
    t,
    {
      ...i,
      ref: o,
      className: _(`bbn-text-${e}`, n)
    },
    r
  )
);
Z.displayName = "Text";
const ui = nt(
  ({ variant: e, as: t = e, children: r, className: n, ...i }, o) => yn(
    t,
    {
      ...i,
      ref: o,
      className: _(`bbn-${e}`, n)
    },
    r
  )
);
ui.displayName = "Heading";
function Jt({ className: e, style: t, size: r = "large", variant: n = "circular", alt: i, url: o, children: s }) {
  return /* @__PURE__ */ l("div", { style: t, className: _("bbn-avatar", `bbn-avatar-${r}`, `bbn-avatar-${n}`, e), children: o ? /* @__PURE__ */ l("img", { className: "bbn-avatar-img", src: o, alt: i }) : s });
}
const pa = ({
  max: e = 1 / 0,
  className: t,
  children: r,
  avatarClassName: n,
  variant: i,
  ...o
}) => {
  const s = Yn.count(r);
  return /* @__PURE__ */ b("div", { className: _("bbn-avatar-group", t), children: [
    Yn.map(
      r,
      (a, c) => Ho(a) && c + 1 <= e ? Fo(a, {
        ...o,
        className: le(n, a.props.className),
        variant: i
      }) : null
    ),
    s > e && /* @__PURE__ */ b(Jt, { size: o.size, variant: i, className: n, children: [
      "+",
      s - e
    ] })
  ] });
};
function md({ url: e, name: t, variant: r = "rounded", size: n = "large", ...i }) {
  return /* @__PURE__ */ l(Jt, { ...i, url: e, alt: t, variant: r, size: n, children: /* @__PURE__ */ l(Z, { as: "span", className: "inline-flex h-full w-full items-center justify-center bg-secondary-main text-xs text-accent-contrast", children: (t == null ? void 0 : t.charAt(0).toUpperCase()) || "?" }) });
}
const $o = nt(function({
  label: t,
  checked: r,
  defaultChecked: n = !1,
  inputProps: i,
  orientation: o = "left",
  disabled: s = !1,
  className: a,
  inputType: c,
  labelClassName: d,
  renderIcon: u,
  onChange: f,
  ...p
}, h) {
  const [m = !1, g] = St({
    value: r,
    defaultValue: n,
    onStateChange: f
  });
  function y(w) {
    var L;
    g(w.currentTarget.checked), (L = i == null ? void 0 : i.onChange) == null || L.call(i, w);
  }
  const A = /* @__PURE__ */ b("span", { className: _("bbn-switcher", s && "bbn-switcher-disabled", a), children: [
    u(m),
    /* @__PURE__ */ l(
      "input",
      {
        ref: h,
        type: c,
        disabled: s,
        className: "bbn-switcher-input",
        "data-testid": c === "checkbox" ? "checkbox-input" : "radio-input",
        ...p,
        ...i,
        checked: m,
        onChange: y
      }
    )
  ] });
  return t ? /* @__PURE__ */ b(
    Z,
    {
      as: "label",
      variant: "body1",
      className: _(
        "bbn-switcher-label",
        o === "left" ? "bbn-switcher-left" : "bbn-switcher-right",
        d
      ),
      children: [
        A,
        t
      ]
    }
  ) : A;
}), va = {
  default: {
    color: "fill-current",
    contrastColor: "fill-accent-contrast"
  },
  primary: {
    color: "fill-primary-main",
    contrastColor: "fill-white"
  },
  secondary: {
    color: "fill-secondary-main",
    contrastColor: "fill-black"
  }
}, ga = (e) => {
  const t = va[e];
  return {
    uncheckedBorderClass: "fill-[#8C8C8C]",
    checkedBorderClass: t.color,
    checkedBackgroundClass: t.color,
    checkmarkClass: t.contrastColor
  };
}, ba = (e) => {
  const t = ga(e);
  return {
    false: /* @__PURE__ */ l("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", children: /* @__PURE__ */ l(
      "path",
      {
        className: t.uncheckedBorderClass,
        d: "M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z"
      }
    ) }),
    true: /* @__PURE__ */ b("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", children: [
      /* @__PURE__ */ l(
        "path",
        {
          className: t.checkedBorderClass,
          d: "M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z"
        }
      ),
      /* @__PURE__ */ l(
        "rect",
        {
          className: t.checkedBackgroundClass,
          x: "3",
          y: "3",
          width: "18",
          height: "18",
          rx: "2"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          className: t.checkmarkClass,
          d: "M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"
        }
      )
    ] })
  };
}, ya = nt(function({ variant: t = "default", showLabel: r = !0, label: n, ...i }, o) {
  const s = ba(t);
  return /* @__PURE__ */ l(
    $o,
    {
      ref: o,
      ...i,
      label: r ? n : void 0,
      inputType: "checkbox",
      renderIcon: (a) => s[a.toString()]
    }
  );
}), wa = {
  true: /* @__PURE__ */ l("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", children: /* @__PURE__ */ l(
    "path",
    {
      d: "M12 7C9.24 7 7 9.24 7 12C7 14.76 9.24 17 12 17C14.76 17 17 14.76 17 12C17 9.24 14.76 7 12 7ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z",
      fill: "currentColor"
    }
  ) }),
  false: /* @__PURE__ */ l("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", children: /* @__PURE__ */ l(
    "path",
    {
      d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z",
      fill: "currentColor"
    }
  ) })
}, xa = nt(function(t, r) {
  return /* @__PURE__ */ l($o, { ref: r, ...t, inputType: "radio", renderIcon: (n) => wa[n.toString()] });
});
var Po = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, Pi = q.createContext && /* @__PURE__ */ q.createContext(Po), Ca = ["attr", "size", "title"];
function Na(e, t) {
  if (e == null) return {};
  var r = ka(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      n = o[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function ka(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function ln() {
  return ln = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ln.apply(this, arguments);
}
function ji(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function cn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ji(Object(r), !0).forEach(function(n) {
      Sa(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ji(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Sa(e, t, r) {
  return t = La(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function La(e) {
  var t = Aa(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Aa(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function jo(e) {
  return e && e.map((t, r) => /* @__PURE__ */ q.createElement(t.tag, cn({
    key: r
  }, t.attr), jo(t.child)));
}
function we(e) {
  return (t) => /* @__PURE__ */ q.createElement(Ea, ln({
    attr: cn({}, e.attr)
  }, t), jo(e.child));
}
function Ea(e) {
  var t = (r) => {
    var {
      attr: n,
      size: i,
      title: o
    } = e, s = Na(e, Ca), a = i || r.size || "1em", c;
    return r.className && (c = r.className), e.className && (c = (c ? c + " " : "") + e.className), /* @__PURE__ */ q.createElement("svg", ln({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, r.attr, n, s, {
      className: c,
      style: cn(cn({
        color: e.color || r.color
      }, r.style), e.style),
      height: a,
      width: a,
      xmlns: "http://www.w3.org/2000/svg"
    }), o && /* @__PURE__ */ q.createElement("title", null, o), e.children);
  };
  return Pi !== void 0 ? /* @__PURE__ */ q.createElement(Pi.Consumer, null, (r) => t(r)) : t(Po);
}
function Oa(e) {
  return we({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M12 16L6 10H18L12 16Z" }, child: [] }] })(e);
}
function zo(e) {
  return we({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M11.9999 13.1714L16.9497 8.22168L18.3639 9.63589L11.9999 15.9999L5.63599 9.63589L7.0502 8.22168L11.9999 13.1714Z" }, child: [] }] })(e);
}
function _a(e) {
  return we({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M12 8L18 14H6L12 8Z" }, child: [] }] })(e);
}
function Va(e) {
  return we({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M18.031 16.6168L22.3137 20.8995L20.8995 22.3137L16.6168 18.031C15.0769 19.263 13.124 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20 13.124 19.263 15.0769 18.031 16.6168ZM16.0247 15.8748C17.2475 14.6146 18 12.8956 18 11C18 7.1325 14.8675 4 11 4C7.1325 4 4 7.1325 4 11C4 14.8675 7.1325 18 11 18C12.8956 18 14.6146 17.2475 15.8748 16.0247L16.0247 15.8748Z" }, child: [] }] })(e);
}
var zi = function(t) {
  return t.reduce(function(r, n) {
    var i = n[0], o = n[1];
    return r[i] = o, r;
  }, {});
}, Wi = typeof window < "u" && window.document && window.document.createElement ? qt.useLayoutEffect : qt.useEffect, Xe = "top", ct = "bottom", ut = "right", Ke = "left", di = "auto", Zr = [Xe, ct, ut, Ke], mr = "start", Hr = "end", Ta = "clippingParents", Wo = "viewport", _r = "popper", Ma = "reference", Ui = /* @__PURE__ */ Zr.reduce(function(e, t) {
  return e.concat([t + "-" + mr, t + "-" + Hr]);
}, []), Uo = /* @__PURE__ */ [].concat(Zr, [di]).reduce(function(e, t) {
  return e.concat([t, t + "-" + mr, t + "-" + Hr]);
}, []), Da = "beforeRead", Ra = "read", Ba = "afterRead", Fa = "beforeMain", Ha = "main", Ia = "afterMain", $a = "beforeWrite", Pa = "write", ja = "afterWrite", za = [Da, Ra, Ba, Fa, Ha, Ia, $a, Pa, ja];
function Lt(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function rt(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Qt(e) {
  var t = rt(e).Element;
  return e instanceof t || e instanceof Element;
}
function lt(e) {
  var t = rt(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function fi(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = rt(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function Wa(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(r) {
    var n = t.styles[r] || {}, i = t.attributes[r] || {}, o = t.elements[r];
    !lt(o) || !Lt(o) || (Object.assign(o.style, n), Object.keys(i).forEach(function(s) {
      var a = i[s];
      a === !1 ? o.removeAttribute(s) : o.setAttribute(s, a === !0 ? "" : a);
    }));
  });
}
function Ua(e) {
  var t = e.state, r = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, r.popper), t.styles = r, t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow), function() {
    Object.keys(t.elements).forEach(function(n) {
      var i = t.elements[n], o = t.attributes[n] || {}, s = Object.keys(t.styles.hasOwnProperty(n) ? t.styles[n] : r[n]), a = s.reduce(function(c, d) {
        return c[d] = "", c;
      }, {});
      !lt(i) || !Lt(i) || (Object.assign(i.style, a), Object.keys(o).forEach(function(c) {
        i.removeAttribute(c);
      }));
    });
  };
}
const Za = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Wa,
  effect: Ua,
  requires: ["computeStyles"]
};
function Nt(e) {
  return e.split("-")[0];
}
var Kt = Math.max, un = Math.min, pr = Math.round;
function Gn() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function Zo() {
  return !/^((?!chrome|android).)*safari/i.test(Gn());
}
function vr(e, t, r) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  var n = e.getBoundingClientRect(), i = 1, o = 1;
  t && lt(e) && (i = e.offsetWidth > 0 && pr(n.width) / e.offsetWidth || 1, o = e.offsetHeight > 0 && pr(n.height) / e.offsetHeight || 1);
  var s = Qt(e) ? rt(e) : window, a = s.visualViewport, c = !Zo() && r, d = (n.left + (c && a ? a.offsetLeft : 0)) / i, u = (n.top + (c && a ? a.offsetTop : 0)) / o, f = n.width / i, p = n.height / o;
  return {
    width: f,
    height: p,
    top: u,
    right: d + f,
    bottom: u + p,
    left: d,
    x: d,
    y: u
  };
}
function hi(e) {
  var t = vr(e), r = e.offsetWidth, n = e.offsetHeight;
  return Math.abs(t.width - r) <= 1 && (r = t.width), Math.abs(t.height - n) <= 1 && (n = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: r,
    height: n
  };
}
function qo(e, t) {
  var r = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (r && fi(r)) {
    var n = t;
    do {
      if (n && e.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function Dt(e) {
  return rt(e).getComputedStyle(e);
}
function qa(e) {
  return ["table", "td", "th"].indexOf(Lt(e)) >= 0;
}
function Pt(e) {
  return ((Qt(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function xn(e) {
  return Lt(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (fi(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Pt(e)
  );
}
function Zi(e) {
  return !lt(e) || // https://github.com/popperjs/popper-core/issues/837
  Dt(e).position === "fixed" ? null : e.offsetParent;
}
function Xa(e) {
  var t = /firefox/i.test(Gn()), r = /Trident/i.test(Gn());
  if (r && lt(e)) {
    var n = Dt(e);
    if (n.position === "fixed")
      return null;
  }
  var i = xn(e);
  for (fi(i) && (i = i.host); lt(i) && ["html", "body"].indexOf(Lt(i)) < 0; ) {
    var o = Dt(i);
    if (o.transform !== "none" || o.perspective !== "none" || o.contain === "paint" || ["transform", "perspective"].indexOf(o.willChange) !== -1 || t && o.willChange === "filter" || t && o.filter && o.filter !== "none")
      return i;
    i = i.parentNode;
  }
  return null;
}
function qr(e) {
  for (var t = rt(e), r = Zi(e); r && qa(r) && Dt(r).position === "static"; )
    r = Zi(r);
  return r && (Lt(r) === "html" || Lt(r) === "body" && Dt(r).position === "static") ? t : r || Xa(e) || t;
}
function mi(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Mr(e, t, r) {
  return Kt(e, un(t, r));
}
function Ka(e, t, r) {
  var n = Mr(e, t, r);
  return n > r ? r : n;
}
function Xo() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Ko(e) {
  return Object.assign({}, Xo(), e);
}
function Yo(e, t) {
  return t.reduce(function(r, n) {
    return r[n] = e, r;
  }, {});
}
var Ya = function(t, r) {
  return t = typeof t == "function" ? t(Object.assign({}, r.rects, {
    placement: r.placement
  })) : t, Ko(typeof t != "number" ? t : Yo(t, Zr));
};
function Ga(e) {
  var t, r = e.state, n = e.name, i = e.options, o = r.elements.arrow, s = r.modifiersData.popperOffsets, a = Nt(r.placement), c = mi(a), d = [Ke, ut].indexOf(a) >= 0, u = d ? "height" : "width";
  if (!(!o || !s)) {
    var f = Ya(i.padding, r), p = hi(o), h = c === "y" ? Xe : Ke, m = c === "y" ? ct : ut, g = r.rects.reference[u] + r.rects.reference[c] - s[c] - r.rects.popper[u], y = s[c] - r.rects.reference[c], A = qr(o), w = A ? c === "y" ? A.clientHeight || 0 : A.clientWidth || 0 : 0, L = g / 2 - y / 2, N = f[h], k = w - p[u] - f[m], S = w / 2 - p[u] / 2 + L, E = Mr(N, S, k), V = c;
    r.modifiersData[n] = (t = {}, t[V] = E, t.centerOffset = E - S, t);
  }
}
function Ja(e) {
  var t = e.state, r = e.options, n = r.element, i = n === void 0 ? "[data-popper-arrow]" : n;
  i != null && (typeof i == "string" && (i = t.elements.popper.querySelector(i), !i) || qo(t.elements.popper, i) && (t.elements.arrow = i));
}
const Qa = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Ga,
  effect: Ja,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function gr(e) {
  return e.split("-")[1];
}
var el = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function tl(e, t) {
  var r = e.x, n = e.y, i = t.devicePixelRatio || 1;
  return {
    x: pr(r * i) / i || 0,
    y: pr(n * i) / i || 0
  };
}
function qi(e) {
  var t, r = e.popper, n = e.popperRect, i = e.placement, o = e.variation, s = e.offsets, a = e.position, c = e.gpuAcceleration, d = e.adaptive, u = e.roundOffsets, f = e.isFixed, p = s.x, h = p === void 0 ? 0 : p, m = s.y, g = m === void 0 ? 0 : m, y = typeof u == "function" ? u({
    x: h,
    y: g
  }) : {
    x: h,
    y: g
  };
  h = y.x, g = y.y;
  var A = s.hasOwnProperty("x"), w = s.hasOwnProperty("y"), L = Ke, N = Xe, k = window;
  if (d) {
    var S = qr(r), E = "clientHeight", V = "clientWidth";
    if (S === rt(r) && (S = Pt(r), Dt(S).position !== "static" && a === "absolute" && (E = "scrollHeight", V = "scrollWidth")), S = S, i === Xe || (i === Ke || i === ut) && o === Hr) {
      N = ct;
      var I = f && S === k && k.visualViewport ? k.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        S[E]
      );
      g -= I - n.height, g *= c ? 1 : -1;
    }
    if (i === Ke || (i === Xe || i === ct) && o === Hr) {
      L = ut;
      var H = f && S === k && k.visualViewport ? k.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        S[V]
      );
      h -= H - n.width, h *= c ? 1 : -1;
    }
  }
  var W = Object.assign({
    position: a
  }, d && el), O = u === !0 ? tl({
    x: h,
    y: g
  }, rt(r)) : {
    x: h,
    y: g
  };
  if (h = O.x, g = O.y, c) {
    var T;
    return Object.assign({}, W, (T = {}, T[N] = w ? "0" : "", T[L] = A ? "0" : "", T.transform = (k.devicePixelRatio || 1) <= 1 ? "translate(" + h + "px, " + g + "px)" : "translate3d(" + h + "px, " + g + "px, 0)", T));
  }
  return Object.assign({}, W, (t = {}, t[N] = w ? g + "px" : "", t[L] = A ? h + "px" : "", t.transform = "", t));
}
function rl(e) {
  var t = e.state, r = e.options, n = r.gpuAcceleration, i = n === void 0 ? !0 : n, o = r.adaptive, s = o === void 0 ? !0 : o, a = r.roundOffsets, c = a === void 0 ? !0 : a, d = {
    placement: Nt(t.placement),
    variation: gr(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: i,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, qi(Object.assign({}, d, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: s,
    roundOffsets: c
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, qi(Object.assign({}, d, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: c
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const nl = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: rl,
  data: {}
};
var rn = {
  passive: !0
};
function il(e) {
  var t = e.state, r = e.instance, n = e.options, i = n.scroll, o = i === void 0 ? !0 : i, s = n.resize, a = s === void 0 ? !0 : s, c = rt(t.elements.popper), d = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return o && d.forEach(function(u) {
    u.addEventListener("scroll", r.update, rn);
  }), a && c.addEventListener("resize", r.update, rn), function() {
    o && d.forEach(function(u) {
      u.removeEventListener("scroll", r.update, rn);
    }), a && c.removeEventListener("resize", r.update, rn);
  };
}
const ol = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: il,
  data: {}
};
var sl = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function sn(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return sl[t];
  });
}
var al = {
  start: "end",
  end: "start"
};
function Xi(e) {
  return e.replace(/start|end/g, function(t) {
    return al[t];
  });
}
function pi(e) {
  var t = rt(e), r = t.pageXOffset, n = t.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: n
  };
}
function vi(e) {
  return vr(Pt(e)).left + pi(e).scrollLeft;
}
function ll(e, t) {
  var r = rt(e), n = Pt(e), i = r.visualViewport, o = n.clientWidth, s = n.clientHeight, a = 0, c = 0;
  if (i) {
    o = i.width, s = i.height;
    var d = Zo();
    (d || !d && t === "fixed") && (a = i.offsetLeft, c = i.offsetTop);
  }
  return {
    width: o,
    height: s,
    x: a + vi(e),
    y: c
  };
}
function cl(e) {
  var t, r = Pt(e), n = pi(e), i = (t = e.ownerDocument) == null ? void 0 : t.body, o = Kt(r.scrollWidth, r.clientWidth, i ? i.scrollWidth : 0, i ? i.clientWidth : 0), s = Kt(r.scrollHeight, r.clientHeight, i ? i.scrollHeight : 0, i ? i.clientHeight : 0), a = -n.scrollLeft + vi(e), c = -n.scrollTop;
  return Dt(i || r).direction === "rtl" && (a += Kt(r.clientWidth, i ? i.clientWidth : 0) - o), {
    width: o,
    height: s,
    x: a,
    y: c
  };
}
function gi(e) {
  var t = Dt(e), r = t.overflow, n = t.overflowX, i = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + i + n);
}
function Go(e) {
  return ["html", "body", "#document"].indexOf(Lt(e)) >= 0 ? e.ownerDocument.body : lt(e) && gi(e) ? e : Go(xn(e));
}
function Dr(e, t) {
  var r;
  t === void 0 && (t = []);
  var n = Go(e), i = n === ((r = e.ownerDocument) == null ? void 0 : r.body), o = rt(n), s = i ? [o].concat(o.visualViewport || [], gi(n) ? n : []) : n, a = t.concat(s);
  return i ? a : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    a.concat(Dr(xn(s)))
  );
}
function Jn(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function ul(e, t) {
  var r = vr(e, !1, t === "fixed");
  return r.top = r.top + e.clientTop, r.left = r.left + e.clientLeft, r.bottom = r.top + e.clientHeight, r.right = r.left + e.clientWidth, r.width = e.clientWidth, r.height = e.clientHeight, r.x = r.left, r.y = r.top, r;
}
function Ki(e, t, r) {
  return t === Wo ? Jn(ll(e, r)) : Qt(t) ? ul(t, r) : Jn(cl(Pt(e)));
}
function dl(e) {
  var t = Dr(xn(e)), r = ["absolute", "fixed"].indexOf(Dt(e).position) >= 0, n = r && lt(e) ? qr(e) : e;
  return Qt(n) ? t.filter(function(i) {
    return Qt(i) && qo(i, n) && Lt(i) !== "body";
  }) : [];
}
function fl(e, t, r, n) {
  var i = t === "clippingParents" ? dl(e) : [].concat(t), o = [].concat(i, [r]), s = o[0], a = o.reduce(function(c, d) {
    var u = Ki(e, d, n);
    return c.top = Kt(u.top, c.top), c.right = un(u.right, c.right), c.bottom = un(u.bottom, c.bottom), c.left = Kt(u.left, c.left), c;
  }, Ki(e, s, n));
  return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}
function Jo(e) {
  var t = e.reference, r = e.element, n = e.placement, i = n ? Nt(n) : null, o = n ? gr(n) : null, s = t.x + t.width / 2 - r.width / 2, a = t.y + t.height / 2 - r.height / 2, c;
  switch (i) {
    case Xe:
      c = {
        x: s,
        y: t.y - r.height
      };
      break;
    case ct:
      c = {
        x: s,
        y: t.y + t.height
      };
      break;
    case ut:
      c = {
        x: t.x + t.width,
        y: a
      };
      break;
    case Ke:
      c = {
        x: t.x - r.width,
        y: a
      };
      break;
    default:
      c = {
        x: t.x,
        y: t.y
      };
  }
  var d = i ? mi(i) : null;
  if (d != null) {
    var u = d === "y" ? "height" : "width";
    switch (o) {
      case mr:
        c[d] = c[d] - (t[u] / 2 - r[u] / 2);
        break;
      case Hr:
        c[d] = c[d] + (t[u] / 2 - r[u] / 2);
        break;
    }
  }
  return c;
}
function Ir(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, i = n === void 0 ? e.placement : n, o = r.strategy, s = o === void 0 ? e.strategy : o, a = r.boundary, c = a === void 0 ? Ta : a, d = r.rootBoundary, u = d === void 0 ? Wo : d, f = r.elementContext, p = f === void 0 ? _r : f, h = r.altBoundary, m = h === void 0 ? !1 : h, g = r.padding, y = g === void 0 ? 0 : g, A = Ko(typeof y != "number" ? y : Yo(y, Zr)), w = p === _r ? Ma : _r, L = e.rects.popper, N = e.elements[m ? w : p], k = fl(Qt(N) ? N : N.contextElement || Pt(e.elements.popper), c, u, s), S = vr(e.elements.reference), E = Jo({
    reference: S,
    element: L,
    placement: i
  }), V = Jn(Object.assign({}, L, E)), I = p === _r ? V : S, H = {
    top: k.top - I.top + A.top,
    bottom: I.bottom - k.bottom + A.bottom,
    left: k.left - I.left + A.left,
    right: I.right - k.right + A.right
  }, W = e.modifiersData.offset;
  if (p === _r && W) {
    var O = W[i];
    Object.keys(H).forEach(function(T) {
      var $ = [ut, ct].indexOf(T) >= 0 ? 1 : -1, X = [Xe, ct].indexOf(T) >= 0 ? "y" : "x";
      H[T] += O[X] * $;
    });
  }
  return H;
}
function hl(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, i = r.boundary, o = r.rootBoundary, s = r.padding, a = r.flipVariations, c = r.allowedAutoPlacements, d = c === void 0 ? Uo : c, u = gr(n), f = u ? a ? Ui : Ui.filter(function(m) {
    return gr(m) === u;
  }) : Zr, p = f.filter(function(m) {
    return d.indexOf(m) >= 0;
  });
  p.length === 0 && (p = f);
  var h = p.reduce(function(m, g) {
    return m[g] = Ir(e, {
      placement: g,
      boundary: i,
      rootBoundary: o,
      padding: s
    })[Nt(g)], m;
  }, {});
  return Object.keys(h).sort(function(m, g) {
    return h[m] - h[g];
  });
}
function ml(e) {
  if (Nt(e) === di)
    return [];
  var t = sn(e);
  return [Xi(e), t, Xi(t)];
}
function pl(e) {
  var t = e.state, r = e.options, n = e.name;
  if (!t.modifiersData[n]._skip) {
    for (var i = r.mainAxis, o = i === void 0 ? !0 : i, s = r.altAxis, a = s === void 0 ? !0 : s, c = r.fallbackPlacements, d = r.padding, u = r.boundary, f = r.rootBoundary, p = r.altBoundary, h = r.flipVariations, m = h === void 0 ? !0 : h, g = r.allowedAutoPlacements, y = t.options.placement, A = Nt(y), w = A === y, L = c || (w || !m ? [sn(y)] : ml(y)), N = [y].concat(L).reduce(function(Se, Oe) {
      return Se.concat(Nt(Oe) === di ? hl(t, {
        placement: Oe,
        boundary: u,
        rootBoundary: f,
        padding: d,
        flipVariations: m,
        allowedAutoPlacements: g
      }) : Oe);
    }, []), k = t.rects.reference, S = t.rects.popper, E = /* @__PURE__ */ new Map(), V = !0, I = N[0], H = 0; H < N.length; H++) {
      var W = N[H], O = Nt(W), T = gr(W) === mr, $ = [Xe, ct].indexOf(O) >= 0, X = $ ? "width" : "height", K = Ir(t, {
        placement: W,
        boundary: u,
        rootBoundary: f,
        altBoundary: p,
        padding: d
      }), U = $ ? T ? ut : Ke : T ? ct : Xe;
      k[X] > S[X] && (U = sn(U));
      var te = sn(U), ie = [];
      if (o && ie.push(K[O] <= 0), a && ie.push(K[U] <= 0, K[te] <= 0), ie.every(function(Se) {
        return Se;
      })) {
        I = W, V = !1;
        break;
      }
      E.set(W, ie);
    }
    if (V)
      for (var oe = m ? 3 : 1, se = function(Oe) {
        var xe = N.find(function(Fe) {
          var F = E.get(Fe);
          if (F)
            return F.slice(0, Oe).every(function(re) {
              return re;
            });
        });
        if (xe)
          return I = xe, "break";
      }, pe = oe; pe > 0; pe--) {
        var de = se(pe);
        if (de === "break") break;
      }
    t.placement !== I && (t.modifiersData[n]._skip = !0, t.placement = I, t.reset = !0);
  }
}
const vl = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: pl,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Yi(e, t, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - r.y,
    right: e.right - t.width + r.x,
    bottom: e.bottom - t.height + r.y,
    left: e.left - t.width - r.x
  };
}
function Gi(e) {
  return [Xe, ut, ct, Ke].some(function(t) {
    return e[t] >= 0;
  });
}
function gl(e) {
  var t = e.state, r = e.name, n = t.rects.reference, i = t.rects.popper, o = t.modifiersData.preventOverflow, s = Ir(t, {
    elementContext: "reference"
  }), a = Ir(t, {
    altBoundary: !0
  }), c = Yi(s, n), d = Yi(a, i, o), u = Gi(c), f = Gi(d);
  t.modifiersData[r] = {
    referenceClippingOffsets: c,
    popperEscapeOffsets: d,
    isReferenceHidden: u,
    hasPopperEscaped: f
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": f
  });
}
const bl = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: gl
};
function yl(e, t, r) {
  var n = Nt(e), i = [Ke, Xe].indexOf(n) >= 0 ? -1 : 1, o = typeof r == "function" ? r(Object.assign({}, t, {
    placement: e
  })) : r, s = o[0], a = o[1];
  return s = s || 0, a = (a || 0) * i, [Ke, ut].indexOf(n) >= 0 ? {
    x: a,
    y: s
  } : {
    x: s,
    y: a
  };
}
function wl(e) {
  var t = e.state, r = e.options, n = e.name, i = r.offset, o = i === void 0 ? [0, 0] : i, s = Uo.reduce(function(u, f) {
    return u[f] = yl(f, t.rects, o), u;
  }, {}), a = s[t.placement], c = a.x, d = a.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += c, t.modifiersData.popperOffsets.y += d), t.modifiersData[n] = s;
}
const xl = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: wl
};
function Cl(e) {
  var t = e.state, r = e.name;
  t.modifiersData[r] = Jo({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
const Nl = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: Cl,
  data: {}
};
function kl(e) {
  return e === "x" ? "y" : "x";
}
function Sl(e) {
  var t = e.state, r = e.options, n = e.name, i = r.mainAxis, o = i === void 0 ? !0 : i, s = r.altAxis, a = s === void 0 ? !1 : s, c = r.boundary, d = r.rootBoundary, u = r.altBoundary, f = r.padding, p = r.tether, h = p === void 0 ? !0 : p, m = r.tetherOffset, g = m === void 0 ? 0 : m, y = Ir(t, {
    boundary: c,
    rootBoundary: d,
    padding: f,
    altBoundary: u
  }), A = Nt(t.placement), w = gr(t.placement), L = !w, N = mi(A), k = kl(N), S = t.modifiersData.popperOffsets, E = t.rects.reference, V = t.rects.popper, I = typeof g == "function" ? g(Object.assign({}, t.rects, {
    placement: t.placement
  })) : g, H = typeof I == "number" ? {
    mainAxis: I,
    altAxis: I
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, I), W = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, O = {
    x: 0,
    y: 0
  };
  if (S) {
    if (o) {
      var T, $ = N === "y" ? Xe : Ke, X = N === "y" ? ct : ut, K = N === "y" ? "height" : "width", U = S[N], te = U + y[$], ie = U - y[X], oe = h ? -V[K] / 2 : 0, se = w === mr ? E[K] : V[K], pe = w === mr ? -V[K] : -E[K], de = t.elements.arrow, Se = h && de ? hi(de) : {
        width: 0,
        height: 0
      }, Oe = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : Xo(), xe = Oe[$], Fe = Oe[X], F = Mr(0, E[K], Se[K]), re = L ? E[K] / 2 - oe - F - xe - H.mainAxis : se - F - xe - H.mainAxis, De = L ? -E[K] / 2 + oe + F + Fe + H.mainAxis : pe + F + Fe + H.mainAxis, Ce = t.elements.arrow && qr(t.elements.arrow), it = Ce ? N === "y" ? Ce.clientTop || 0 : Ce.clientLeft || 0 : 0, ft = (T = W == null ? void 0 : W[N]) != null ? T : 0, Ye = U + re - ft - it, or = U + De - ft, He = Mr(h ? un(te, Ye) : te, U, h ? Kt(ie, or) : ie);
      S[N] = He, O[N] = He - U;
    }
    if (a) {
      var Rt, v = N === "x" ? Xe : Ke, x = N === "x" ? ct : ut, C = S[k], R = k === "y" ? "height" : "width", D = C + y[v], M = C - y[x], z = [Xe, Ke].indexOf(A) !== -1, ee = (Rt = W == null ? void 0 : W[k]) != null ? Rt : 0, he = z ? D : C - E[R] - V[R] - ee + H.altAxis, ce = z ? C + E[R] + V[R] - ee - H.altAxis : M, Ie = h && z ? Ka(he, C, ce) : Mr(h ? he : D, C, h ? ce : M);
      S[k] = Ie, O[k] = Ie - C;
    }
    t.modifiersData[n] = O;
  }
}
const Ll = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Sl,
  requiresIfExists: ["offset"]
};
function Al(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function El(e) {
  return e === rt(e) || !lt(e) ? pi(e) : Al(e);
}
function Ol(e) {
  var t = e.getBoundingClientRect(), r = pr(t.width) / e.offsetWidth || 1, n = pr(t.height) / e.offsetHeight || 1;
  return r !== 1 || n !== 1;
}
function _l(e, t, r) {
  r === void 0 && (r = !1);
  var n = lt(t), i = lt(t) && Ol(t), o = Pt(t), s = vr(e, i, r), a = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = {
    x: 0,
    y: 0
  };
  return (n || !n && !r) && ((Lt(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  gi(o)) && (a = El(t)), lt(t) ? (c = vr(t, !0), c.x += t.clientLeft, c.y += t.clientTop) : o && (c.x = vi(o))), {
    x: s.left + a.scrollLeft - c.x,
    y: s.top + a.scrollTop - c.y,
    width: s.width,
    height: s.height
  };
}
function Vl(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), n = [];
  e.forEach(function(o) {
    t.set(o.name, o);
  });
  function i(o) {
    r.add(o.name);
    var s = [].concat(o.requires || [], o.requiresIfExists || []);
    s.forEach(function(a) {
      if (!r.has(a)) {
        var c = t.get(a);
        c && i(c);
      }
    }), n.push(o);
  }
  return e.forEach(function(o) {
    r.has(o.name) || i(o);
  }), n;
}
function Tl(e) {
  var t = Vl(e);
  return za.reduce(function(r, n) {
    return r.concat(t.filter(function(i) {
      return i.phase === n;
    }));
  }, []);
}
function Ml(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(r) {
      Promise.resolve().then(function() {
        t = void 0, r(e());
      });
    })), t;
  };
}
function Dl(e) {
  var t = e.reduce(function(r, n) {
    var i = r[n.name];
    return r[n.name] = i ? Object.assign({}, i, n, {
      options: Object.assign({}, i.options, n.options),
      data: Object.assign({}, i.data, n.data)
    }) : n, r;
  }, {});
  return Object.keys(t).map(function(r) {
    return t[r];
  });
}
var Ji = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Qi() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return !t.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function Rl(e) {
  e === void 0 && (e = {});
  var t = e, r = t.defaultModifiers, n = r === void 0 ? [] : r, i = t.defaultOptions, o = i === void 0 ? Ji : i;
  return function(a, c, d) {
    d === void 0 && (d = o);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Ji, o),
      modifiersData: {},
      elements: {
        reference: a,
        popper: c
      },
      attributes: {},
      styles: {}
    }, f = [], p = !1, h = {
      state: u,
      setOptions: function(A) {
        var w = typeof A == "function" ? A(u.options) : A;
        g(), u.options = Object.assign({}, o, u.options, w), u.scrollParents = {
          reference: Qt(a) ? Dr(a) : a.contextElement ? Dr(a.contextElement) : [],
          popper: Dr(c)
        };
        var L = Tl(Dl([].concat(n, u.options.modifiers)));
        return u.orderedModifiers = L.filter(function(N) {
          return N.enabled;
        }), m(), h.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!p) {
          var A = u.elements, w = A.reference, L = A.popper;
          if (Qi(w, L)) {
            u.rects = {
              reference: _l(w, qr(L), u.options.strategy === "fixed"),
              popper: hi(L)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(H) {
              return u.modifiersData[H.name] = Object.assign({}, H.data);
            });
            for (var N = 0; N < u.orderedModifiers.length; N++) {
              if (u.reset === !0) {
                u.reset = !1, N = -1;
                continue;
              }
              var k = u.orderedModifiers[N], S = k.fn, E = k.options, V = E === void 0 ? {} : E, I = k.name;
              typeof S == "function" && (u = S({
                state: u,
                options: V,
                name: I,
                instance: h
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Ml(function() {
        return new Promise(function(y) {
          h.forceUpdate(), y(u);
        });
      }),
      destroy: function() {
        g(), p = !0;
      }
    };
    if (!Qi(a, c))
      return h;
    h.setOptions(d).then(function(y) {
      !p && d.onFirstUpdate && d.onFirstUpdate(y);
    });
    function m() {
      u.orderedModifiers.forEach(function(y) {
        var A = y.name, w = y.options, L = w === void 0 ? {} : w, N = y.effect;
        if (typeof N == "function") {
          var k = N({
            state: u,
            name: A,
            instance: h,
            options: L
          }), S = function() {
          };
          f.push(k || S);
        }
      });
    }
    function g() {
      f.forEach(function(y) {
        return y();
      }), f = [];
    }
    return h;
  };
}
var Bl = [ol, Nl, nl, Za, xl, vl, Ll, Qa, bl], Fl = /* @__PURE__ */ Rl({
  defaultModifiers: Bl
}), nn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function bi(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var In, eo;
function Hl() {
  if (eo) return In;
  eo = 1;
  var e = typeof Element < "u", t = typeof Map == "function", r = typeof Set == "function", n = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
  function i(o, s) {
    if (o === s) return !0;
    if (o && s && typeof o == "object" && typeof s == "object") {
      if (o.constructor !== s.constructor) return !1;
      var a, c, d;
      if (Array.isArray(o)) {
        if (a = o.length, a != s.length) return !1;
        for (c = a; c-- !== 0; )
          if (!i(o[c], s[c])) return !1;
        return !0;
      }
      var u;
      if (t && o instanceof Map && s instanceof Map) {
        if (o.size !== s.size) return !1;
        for (u = o.entries(); !(c = u.next()).done; )
          if (!s.has(c.value[0])) return !1;
        for (u = o.entries(); !(c = u.next()).done; )
          if (!i(c.value[1], s.get(c.value[0]))) return !1;
        return !0;
      }
      if (r && o instanceof Set && s instanceof Set) {
        if (o.size !== s.size) return !1;
        for (u = o.entries(); !(c = u.next()).done; )
          if (!s.has(c.value[0])) return !1;
        return !0;
      }
      if (n && ArrayBuffer.isView(o) && ArrayBuffer.isView(s)) {
        if (a = o.length, a != s.length) return !1;
        for (c = a; c-- !== 0; )
          if (o[c] !== s[c]) return !1;
        return !0;
      }
      if (o.constructor === RegExp) return o.source === s.source && o.flags === s.flags;
      if (o.valueOf !== Object.prototype.valueOf && typeof o.valueOf == "function" && typeof s.valueOf == "function") return o.valueOf() === s.valueOf();
      if (o.toString !== Object.prototype.toString && typeof o.toString == "function" && typeof s.toString == "function") return o.toString() === s.toString();
      if (d = Object.keys(o), a = d.length, a !== Object.keys(s).length) return !1;
      for (c = a; c-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(s, d[c])) return !1;
      if (e && o instanceof Element) return !1;
      for (c = a; c-- !== 0; )
        if (!((d[c] === "_owner" || d[c] === "__v" || d[c] === "__o") && o.$$typeof) && !i(o[d[c]], s[d[c]]))
          return !1;
      return !0;
    }
    return o !== o && s !== s;
  }
  return In = function(s, a) {
    try {
      return i(s, a);
    } catch (c) {
      if ((c.message || "").match(/stack|recursion/i))
        return console.warn("react-fast-compare cannot handle circular refs"), !1;
      throw c;
    }
  }, In;
}
var Il = Hl();
const $l = /* @__PURE__ */ bi(Il);
var Pl = [], jl = function(t, r, n) {
  n === void 0 && (n = {});
  var i = qt.useRef(null), o = {
    onFirstUpdate: n.onFirstUpdate,
    placement: n.placement || "bottom",
    strategy: n.strategy || "absolute",
    modifiers: n.modifiers || Pl
  }, s = qt.useState({
    styles: {
      popper: {
        position: o.strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), a = s[0], c = s[1], d = qt.useMemo(function() {
    return {
      name: "updateState",
      enabled: !0,
      phase: "write",
      fn: function(h) {
        var m = h.state, g = Object.keys(m.elements);
        fa.flushSync(function() {
          c({
            styles: zi(g.map(function(y) {
              return [y, m.styles[y] || {}];
            })),
            attributes: zi(g.map(function(y) {
              return [y, m.attributes[y]];
            }))
          });
        });
      },
      requires: ["computeStyles"]
    };
  }, []), u = qt.useMemo(function() {
    var p = {
      onFirstUpdate: o.onFirstUpdate,
      placement: o.placement,
      strategy: o.strategy,
      modifiers: [].concat(o.modifiers, [d, {
        name: "applyStyles",
        enabled: !1
      }])
    };
    return $l(i.current, p) ? i.current || p : (i.current = p, p);
  }, [o.onFirstUpdate, o.placement, o.strategy, o.modifiers, d]), f = qt.useRef();
  return Wi(function() {
    f.current && f.current.setOptions(u);
  }, [u]), Wi(function() {
    if (!(t == null || r == null)) {
      var p = n.createPopper || Fl, h = p(t, r, u);
      return f.current = h, function() {
        h.destroy(), f.current = null;
      };
    }
  }, [t, r, n.createPopper]), {
    state: f.current ? f.current.state : null,
    styles: a.styles,
    attributes: a.attributes,
    update: f.current ? f.current.update : null,
    forceUpdate: f.current ? f.current.forceUpdate : null
  };
};
const Qo = wr({
  portalContainer: null
}), zl = () => nr(Qo);
function pd({
  children: e,
  portalContainer: t = null
}) {
  return /* @__PURE__ */ l(Qo.Provider, { value: { portalContainer: t }, children: e });
}
function Cn({
  children: e,
  mounted: t = !1,
  rootClassName: r = "portal-root",
  inheritViewport: n = !0,
  pointerEvents: i = "auto"
}) {
  const [o, s] = G(null), { portalContainer: a } = zl(), c = i === "none";
  return J(() => {
    if (!t) {
      s(null);
      return;
    }
    const d = document.createElement("div");
    if (d.className = r, n)
      if (r.includes("popover"))
        d.style.zIndex = "9999", d.style.pointerEvents = c ? "none" : "auto";
      else {
        const f = {
          position: "fixed",
          top: "0",
          left: "0",
          width: "100vw",
          height: "100vh",
          zIndex: "9999",
          pointerEvents: c ? "none" : "auto"
        };
        Object.assign(d.style, f);
      }
    const u = a || document.body;
    return u.appendChild(d), s(d), () => {
      u.contains(d) && u.removeChild(d);
    };
  }, [t, r, n, c, a]), o ? ha(e, o) : null;
}
function Wl(e, t) {
  if (e === t)
    return !0;
  if (e.length !== t.length)
    return !1;
  for (let r = 0; r < e.length; r++)
    if (e[r] !== t[r])
      return !1;
  return !0;
}
function Ul(e) {
  const t = Ae(e);
  return Wl(t.current, e) || (t.current = e), t.current;
}
function Zl(e, t = () => null, { enabled: r = !0 } = {}) {
  const n = Array.isArray(e) ? e : [e], i = Ul(n);
  J(() => {
    function o(s) {
      r && i.every((a) => !(a != null && a.contains(s.target))) && t();
    }
    return document.addEventListener("mousedown", o), () => {
      document.removeEventListener("mousedown", o);
    };
  }, [i, r, t]);
}
function Nn({
  open: e = !1,
  className: t,
  anchorEl: r,
  placement: n = "bottom-start",
  offset: i = [0, 0],
  children: o,
  style: s,
  onClickOutside: a
}) {
  const [c, d] = G(null), { styles: u } = jl(r, c, {
    placement: n,
    modifiers: [{ name: "offset", options: { offset: i } }]
  });
  return Zl([c, r], a, { enabled: e }), /* @__PURE__ */ l(Cn, { mounted: e, rootClassName: "popover-portal", children: /* @__PURE__ */ l(
    "div",
    {
      ref: d,
      style: { ...u.popper, ...s, pointerEvents: "auto" },
      className: _("bbn-popover", t),
      children: o
    }
  ) });
}
function es(e) {
  const [t, r] = G({ width: 0, height: 0 });
  return J(() => {
    if (!e) {
      r({ width: 0, height: 0 });
      return;
    }
    const n = new ResizeObserver(([i]) => {
      r({
        width: i.target.clientWidth,
        height: i.target.clientHeight
      });
    });
    return n.observe(e), () => {
      n.unobserve(e);
    };
  }, [e]), t;
}
const ql = (e) => e.label, yi = nt(
  ({
    disabled: e,
    className: t,
    value: r,
    defaultValue: n,
    placeholder: i = "Select option",
    open: o,
    defaultOpen: s,
    options: a = [],
    optionClassName: c,
    popoverClassName: d,
    state: u = "default",
    onOpen: f,
    onSelect: p,
    onClose: h,
    renderSelectedOption: m = ql,
    ...g
  }, y) => {
    const A = Ae(null);
    Wr(y, () => A.current, []);
    const { width: w } = es(A.current), L = (O) => {
      if (!O) return i || "";
      const T = m(O);
      return typeof T == "string" ? T : O.label;
    }, [N, k] = St({
      value: o,
      defaultValue: s,
      onStateChange: (O) => void (O ? f == null ? void 0 : f() : h == null ? void 0 : h())
    }), [S, E] = St({
      value: r,
      defaultValue: n,
      onStateChange: p
    }), V = Te(
      () => a.find((O) => O.value === S),
      [a, S]
    ), I = ge(
      (O) => {
        E(O.value), k(!1);
      },
      [E, k]
    ), H = ge(() => {
      k(!1);
    }, [k]), W = ge(() => {
      e || k(!N);
    }, [N, e, k]);
    return /* @__PURE__ */ b(Pe, { children: [
      /* @__PURE__ */ b(
        "div",
        {
          ref: A,
          className: _("bbn-select", e && "bbn-select-disabled", `bbn-select-${u}`, t),
          onClick: W,
          tabIndex: e ? -1 : 0,
          ...g,
          children: [
            /* @__PURE__ */ l("div", { className: "bbn-select-text-container", children: /* @__PURE__ */ l(
              "span",
              {
                className: "bbn-select-text",
                title: L(V),
                children: V ? m(V) : i
              }
            ) }),
            /* @__PURE__ */ l(zo, { className: _("bbn-select-icon", N && "bbn-select-icon-open"), size: 20 })
          ]
        }
      ),
      /* @__PURE__ */ l(
        Nn,
        {
          anchorEl: A.current,
          className: _("bbn-select-menu custom-scrollbar", d),
          open: N && !e,
          onClickOutside: H,
          offset: [0, 4],
          placement: "bottom-start",
          style: { width: w },
          children: a.map((O) => /* @__PURE__ */ l(
            "div",
            {
              className: _(
                "bbn-select-option",
                (V == null ? void 0 : V.value) === O.value && "bbn-select-option-selected",
                c
              ),
              onClick: () => I(O),
              children: O.label
            },
            O.value
          ))
        }
      )
    ] });
  }
);
yi.displayName = "Select";
const Xl = nt(
  ({
    disabled: e,
    className: t,
    value: r,
    defaultValue: n,
    placeholder: i = "Select option",
    open: o,
    defaultOpen: s,
    options: a = [],
    optionClassName: c,
    popoverClassName: d,
    state: u = "default",
    onOpen: f,
    onSelect: p,
    onClose: h,
    ...m
  }, g) => {
    const y = Ae(null);
    Wr(g, () => y.current, []);
    const { width: A } = es(y.current), [w, L] = St({
      value: o,
      defaultValue: s,
      onStateChange: (T) => void (T ? f == null ? void 0 : f() : h == null ? void 0 : h())
    }), [N, k] = St({
      value: r,
      defaultValue: n,
      onStateChange: p
    }), S = Te(
      () => a.find((T) => T.value === N),
      [a, N]
    ), [E, V] = G(-1);
    J(() => {
      if (w) {
        const T = a.findIndex(($) => $.value === N);
        V(T >= 0 ? T : 0);
      } else
        V(-1);
    }, [w, a, N]);
    const I = ge(
      (T) => {
        k(T.value), L(!1);
      },
      [k, L]
    ), H = ge(() => {
      L(!1);
    }, [L]), W = ge(() => {
      e || L(!w);
    }, [w, e, L]), O = ge(
      (T) => {
        if (!e)
          switch (T.key) {
            case "ArrowDown":
              T.preventDefault(), w ? E < a.length - 1 && V(E + 1) : L(!0);
              break;
            case "ArrowUp":
              T.preventDefault(), w ? E > 0 && V(E - 1) : L(!0);
              break;
            case "Home":
              T.preventDefault(), w && a.length > 0 && V(0);
              break;
            case "End":
              T.preventDefault(), w && a.length > 0 && V(a.length - 1);
              break;
            case "Enter":
            case " ":
              T.preventDefault(), w ? E >= 0 && E < a.length && I(a[E]) : L(!0);
              break;
            case "Escape":
              T.preventDefault(), w && L(!1);
              break;
            case "Tab":
              w && L(!1);
              break;
          }
      },
      [e, w, E, a, L, I]
    );
    return /* @__PURE__ */ b(Pe, { children: [
      /* @__PURE__ */ b(
        "div",
        {
          ref: y,
          className: _(
            "bbn-select-with-icon",
            e && "bbn-select-with-icon-disabled",
            `bbn-select-with-icon-${u}`,
            t
          ),
          role: "combobox",
          "aria-expanded": w,
          "aria-haspopup": "listbox",
          "aria-label": S ? S.label : i,
          "aria-disabled": e,
          onClick: W,
          onKeyDown: O,
          tabIndex: e ? -1 : 0,
          ...m,
          children: [
            /* @__PURE__ */ b("div", { className: "bbn-select-with-icon-content", children: [
              (S == null ? void 0 : S.icon) && /* @__PURE__ */ l("div", { className: "bbn-select-with-icon-image", children: S.icon }),
              /* @__PURE__ */ l("span", { className: "bbn-select-with-icon-text", title: (S == null ? void 0 : S.label) || i, children: S ? S.label : i })
            ] }),
            /* @__PURE__ */ l(
              zo,
              {
                className: _("bbn-select-with-icon-arrow", w && "bbn-select-with-icon-arrow-open"),
                size: 35
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ l(
        Nn,
        {
          anchorEl: y.current,
          className: _("bbn-select-with-icon-menu custom-scrollbar", d),
          open: w && !e,
          onClickOutside: H,
          offset: [0, 4],
          placement: "bottom-start",
          style: { width: A },
          children: /* @__PURE__ */ l("div", { role: "listbox", children: a.map((T, $) => /* @__PURE__ */ b(
            "div",
            {
              role: "option",
              "aria-selected": (S == null ? void 0 : S.value) === T.value,
              className: _(
                "bbn-select-with-icon-option",
                (S == null ? void 0 : S.value) === T.value && "bbn-select-with-icon-option-selected",
                E === $ && "bbn-select-with-icon-option-focused",
                c
              ),
              onClick: () => I(T),
              children: [
                T.icon && /* @__PURE__ */ l("div", { className: "bbn-select-with-icon-option-image", children: T.icon }),
                /* @__PURE__ */ l("span", { className: "bbn-select-with-icon-option-text", children: T.label })
              ]
            },
            T.value
          )) })
        }
      )
    ] });
  }
);
Xl.displayName = "SelectWithIcon";
const kn = nt(
  ({ className: e, prefix: t, suffix: r, wrapperClassName: n, disabled: i = !1, state: o = "default", ...s }, a) => /* @__PURE__ */ b("div", { className: _("bbn-input", `bbn-input-${o}`, i && "bbn-input-disabled", r && "bbn-input-has-suffix", n), children: [
    t && /* @__PURE__ */ l("div", { className: "bbn-input-prefix", children: t }),
    /* @__PURE__ */ l("input", { ref: a, className: _("bbn-input-field", e), disabled: i, ...s }),
    r && /* @__PURE__ */ l("div", { className: "bbn-input-suffix", children: r })
  ] })
);
kn.displayName = "Input";
function Sn({ children: e, label: t, hint: r, state: n = "default", className: i }) {
  return /* @__PURE__ */ b("div", { className: _("bbn-form-control", i), children: [
    t ? /* @__PURE__ */ b("label", { className: "bbn-form-control-label", children: [
      /* @__PURE__ */ l("div", { className: "bbn-form-control-title", children: t }),
      e
    ] }) : e,
    r && /* @__PURE__ */ l("div", { className: _("bbn-form-control-hint", `bbn-form-control-hint-${n}`), children: r })
  ] });
}
const ts = wr({
  removeDialog: () => null,
  updateDialog: () => null
});
function vd({ children: e }) {
  const [t, r] = G({}), n = Te(() => Object.values(t).some((a) => a), [t]);
  J(
    function() {
      if (n) {
        const c = document.body.offsetWidth;
        document.body.style.overflow = "hidden", document.body.style.paddingRight = document.body.offsetWidth - c >= 1 ? ci(document.body.offsetWidth - c) ?? "" : document.body.style.paddingRight;
      } else
        document.body.style.overflow = "", document.body.style.paddingRight = "";
    },
    [n]
  );
  const i = ge((a) => {
    r((c) => Reflect.deleteProperty(c, a) ? { ...c } : c);
  }, []), o = ge((a, c) => {
    r((d) => ({ ...d, [a]: c }));
  }, []), s = Te(() => ({ removeDialog: i, updateDialog: o }), [i, o]);
  return /* @__PURE__ */ l(ts.Provider, { value: s, children: e });
}
function rs({ open: e = !1 } = {}) {
  const t = Ur(), [r, n] = G(e), { updateDialog: i, removeDialog: o } = nr(ts), s = e || r;
  J(
    () => () => {
      o(t);
    },
    [t]
  ), J(() => {
    i(t, s);
  }, [t, s, i]), J(() => {
    e && n(!0);
  }, [e]);
  const a = ge(() => {
    e || n(!1);
  }, [e]);
  return {
    mounted: r,
    unmount: a
  };
}
const ns = ({ open: e = !1, ...t }) => /* @__PURE__ */ l(
  "div",
  {
    ...t,
    className: _("bbn-backdrop", e ? "animate-backdrop-in" : "animate-backdrop-out", t.className)
  }
), Xr = ({
  children: e,
  open: t = !1,
  className: r,
  onClose: n,
  hasBackdrop: i = !0,
  backdropClassName: o,
  dialogClassName: s,
  ...a
}) => {
  const { mounted: c, unmount: d } = rs({ open: t });
  return /* @__PURE__ */ b(Cn, { mounted: c, children: [
    /* @__PURE__ */ l("div", { ...a, className: _("bbn-dialog-wrapper", r), "data-testid": "dialog-wrapper", children: /* @__PURE__ */ l(
      "div",
      {
        className: _("bbn-dialog", t ? "animate-modal-in" : "animate-modal-out", s),
        onAnimationEnd: d,
        role: "dialog",
        "data-testid": "dialog",
        children: e
      }
    ) }),
    i && /* @__PURE__ */ l(ns, { className: o, open: t, onClick: n })
  ] });
}, Rr = ({
  children: e,
  className: t = "",
  size: r = 40,
  variant: n = "default",
  background: i = !1,
  rounded: o = !1
}) => {
  const s = {
    default: "text-accent-secondary",
    primary: "text-primary-light",
    secondary: "text-accent-secondary",
    error: "text-error-main",
    success: "text-success-main",
    "accent-primary": "text-accent-primary",
    "accent-secondary": "text-accent-secondary"
  };
  return /* @__PURE__ */ l(
    "div",
    {
      className: _(
        "flex items-center justify-center",
        i && {
          default: "bg-accent-secondary/10",
          primary: "bg-primary-light/10 dark:bg-[#47484A]",
          secondary: "bg-accent-secondary/10",
          error: "bg-error-main/10",
          success: "bg-success-main/10",
          "accent-primary": "bg-accent-primary/10",
          "accent-secondary": "bg-accent-secondary/10"
        }[n],
        o && "rounded-full",
        i ? "[&_svg]:h-4 [&_svg]:w-auto" : "[&_svg]:w-full [&_svg]:h-full",
        "[&_svg_path]:fill-current",
        i && "dark:[&_svg_path]:fill-white",
        s[n],
        t
      ),
      style: { width: r, height: r },
      children: e
    }
  );
}, is = ({
  className: e = "",
  size: t = 24,
  variant: r = "default",
  color: n
}) => {
  const i = n || je[r];
  return /* @__PURE__ */ l(
    "svg",
    {
      style: { width: t, height: t * 0.545 },
      viewBox: "0 0 22 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: _("transition-opacity duration-200", i, e),
      children: /* @__PURE__ */ l("path", { d: "M20 4H11.65C10.83 1.67 8.61 0 6 0C2.69 0 0 2.69 0 6C0 9.31 2.69 12 6 12C8.61 12 10.83 10.33 11.65 8H12L14 10L16 8L18 10L22 5.96L20 4ZM6 9C4.35 9 3 7.65 3 6C3 4.35 4.35 3 6 3C7.65 3 9 4.35 9 6C9 7.65 7.65 9 6 9Z", fill: "currentColor" })
    }
  );
}, Kl = ({
  className: e = "",
  size: t = 24,
  variant: r = "default",
  color: n
}) => {
  const i = n || je[r];
  return /* @__PURE__ */ l(
    "svg",
    {
      style: { width: t, height: t * 0.5 },
      viewBox: "0 0 20 10",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: _("transition-opacity duration-200", i, e),
      children: /* @__PURE__ */ l("path", { d: "M15 0H11V2H15C16.65 2 18 3.35 18 5C18 6.65 16.65 8 15 8H11V10H15C17.76 10 20 7.76 20 5C20 2.24 17.76 0 15 0ZM9 8H5C3.35 8 2 6.65 2 5C2 3.35 3.35 2 5 2H9V0H5C2.24 0 0 2.24 0 5C0 7.76 2.24 10 5 10H9V8ZM6 4H14V6H6V4Z", fill: "currentColor" })
    }
  );
}, os = ({
  className: e = "",
  size: t = 24,
  variant: r = "default",
  color: n
}) => {
  const i = n || je[r];
  return /* @__PURE__ */ b(
    "svg",
    {
      style: { width: t, height: t * 1 },
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: _("transition-opacity duration-200", i, e),
      children: [
        /* @__PURE__ */ l("path", { d: "M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18Z", fill: "currentColor" }),
        /* @__PURE__ */ l("path", { d: "M10 15C12.7614 15 15 12.7614 15 10C15 7.23858 12.7614 5 10 5C7.23858 5 5 7.23858 5 10C5 12.7614 7.23858 15 10 15Z", fill: "currentColor" })
      ]
    }
  );
}, Ln = ({
  className: e = "",
  size: t = 16,
  variant: r = "default",
  color: n
}) => {
  const i = n || je[r];
  return /* @__PURE__ */ l(
    "svg",
    {
      style: { width: t, height: t * 1.143 },
      viewBox: "0 0 14 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: _("transition-opacity duration-200", i, e),
      children: /* @__PURE__ */ l(
        "path",
        {
          d: "M9.99984 0.666626H1.99984C1.2665 0.666626 0.666504 1.26663 0.666504 1.99996V11.3333H1.99984V1.99996H9.99984V0.666626ZM11.9998 3.33329H4.6665C3.93317 3.33329 3.33317 3.93329 3.33317 4.66663V14C3.33317 14.7333 3.93317 15.3333 4.6665 15.3333H11.9998C12.7332 15.3333 13.3332 14.7333 13.3332 14V4.66663C13.3332 3.93329 12.7332 3.33329 11.9998 3.33329ZM11.9998 14H4.6665V4.66663H11.9998V14Z",
          fill: "currentColor"
        }
      )
    }
  );
}, An = ({
  className: e = "",
  size: t = 14,
  variant: r = "default",
  color: n
}) => {
  const i = n || je[r];
  return /* @__PURE__ */ l(
    "svg",
    {
      style: { width: t, height: t },
      viewBox: "0 0 14 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: _("transition-opacity duration-200", i, e),
      children: /* @__PURE__ */ l(
        "path",
        {
          d: "M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z",
          fill: "currentColor"
        }
      )
    }
  );
}, Yl = ({
  className: e = "",
  size: t = 22,
  variant: r = "default",
  color: n
}) => {
  const i = n || je[r], o = 22 / 20;
  return /* @__PURE__ */ l(
    "svg",
    {
      style: { width: t, height: t * o },
      viewBox: "0 0 22 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: _("transition-opacity duration-200", i, e),
      children: /* @__PURE__ */ l(
        "path",
        {
          d: "M0 19.5H22L11 0.5L0 19.5ZM12 16.5H10V14.5H12V16.5ZM12 12.5H10V8.5H12V12.5Z",
          fill: "currentColor"
        }
      )
    }
  );
}, Gl = ({
  className: e = "",
  size: t = 20,
  variant: r = "default",
  color: n
}) => {
  const i = n || je[r];
  return /* @__PURE__ */ b(
    "svg",
    {
      style: { width: t, height: t },
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: _("transition-opacity duration-200", i, e),
      children: [
        /* @__PURE__ */ l(
          "rect",
          {
            x: "0.5",
            y: "0.5",
            width: "19",
            height: "19",
            rx: "3.5",
            stroke: "currentColor"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M14.0832 10.5846H5.9165V9.41797H14.0832V10.5846Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}, Jl = ({
  className: e = "",
  size: t = 20,
  variant: r = "default",
  color: n
}) => {
  const i = n || je[r];
  return /* @__PURE__ */ b(
    "svg",
    {
      style: { width: t, height: t },
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: _("transition-opacity duration-200", i, e),
      children: [
        /* @__PURE__ */ l(
          "rect",
          {
            x: "0.5",
            y: "0.5",
            width: "19",
            height: "19",
            rx: "3.5",
            stroke: "currentColor"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M14 10.5714H10.5714V14H9.42857V10.5714H6V9.42857H9.42857V6H10.5714V9.42857H14V10.5714Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}, gd = ({
  className: e = "",
  size: t = 16,
  variant: r = "default",
  color: n
}) => {
  const i = n || je[r];
  return /* @__PURE__ */ l(
    "svg",
    {
      style: { width: t, height: t },
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: _("transition-opacity duration-200", i, e),
      children: /* @__PURE__ */ l(
        "path",
        {
          d: "M10 12L6 8L10 4",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  );
}, bd = ({
  className: e = "",
  size: t = 16,
  variant: r = "default",
  color: n
}) => {
  const i = n || je[r];
  return /* @__PURE__ */ l(
    "svg",
    {
      style: { width: t, height: t },
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: _(
        "transition-opacity duration-200",
        i,
        e
      ),
      children: /* @__PURE__ */ l(
        "path",
        {
          d: "M6 4L10 8L6 12",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  );
}, yd = ({
  className: e = "",
  size: t = 16,
  variant: r = "default",
  color: n
}) => {
  const i = n || je[r];
  return /* @__PURE__ */ l(
    "svg",
    {
      style: { width: t, height: t },
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: _("transition-opacity duration-200", i, e),
      children: /* @__PURE__ */ l("path", { d: "M12.73 0H5.27L0 5.27V12.73L5.27 18H12.73L18 12.73V5.27L12.73 0ZM9 14.3C8.28 14.3 7.7 13.72 7.7 13C7.7 12.28 8.28 11.7 9 11.7C9.72 11.7 10.3 12.28 10.3 13C10.3 13.72 9.72 14.3 9 14.3ZM10 10H8V4H10V10Z", fill: "currentColor" })
    }
  );
}, Ql = ({
  className: e = "",
  size: t = 40,
  variant: r = "default",
  color: n
}) => {
  const i = n || je[r];
  return /* @__PURE__ */ b(
    "svg",
    {
      style: { width: t, height: t },
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: _("transition-opacity duration-200", e),
      children: [
        /* @__PURE__ */ l("rect", { width: "40", height: "40", rx: "20", fill: "currentColor", fillOpacity: "0.12" }),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M20 30C25.52 30 30 25.52 30 20C30 14.48 25.52 10 20 10C14.48 10 10 14.48 10 20C10 25.52 14.48 30 20 30ZM21 12.07C24.94 12.56 28 15.92 28 20C28 24.08 24.95 27.44 21 27.93V12.07Z",
            fill: "currentColor",
            className: i
          }
        )
      ]
    }
  );
}, ec = ({
  className: e = "",
  size: t = 20,
  variant: r = "default",
  color: n
}) => {
  const i = n || je[r];
  return /* @__PURE__ */ l(
    "svg",
    {
      style: { width: t, height: t },
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: _(
        "transition-opacity duration-200",
        i,
        e
      ),
      children: /* @__PURE__ */ l(
        "path",
        {
          d: "M4.99967 8.33203C4.08301 8.33203 3.33301 9.08203 3.33301 9.9987C3.33301 10.9154 4.08301 11.6654 4.99967 11.6654C5.91634 11.6654 6.66634 10.9154 6.66634 9.9987C6.66634 9.08203 5.91634 8.33203 4.99967 8.33203ZM14.9997 8.33203C14.083 8.33203 13.333 9.08203 13.333 9.9987C13.333 10.9154 14.083 11.6654 14.9997 11.6654C15.9163 11.6654 16.6663 10.9154 16.6663 9.9987C16.6663 9.08203 15.9163 8.33203 14.9997 8.33203ZM9.99967 8.33203C9.08301 8.33203 8.33301 9.08203 8.33301 9.9987C8.33301 10.9154 9.08301 11.6654 9.99967 11.6654C10.9163 11.6654 11.6663 10.9154 11.6663 9.9987C11.6663 9.08203 10.9163 8.33203 9.99967 8.33203Z",
          fill: "currentColor"
        }
      )
    }
  );
}, ss = ({
  className: e = "",
  size: t = 14,
  variant: r = "default",
  color: n
}) => {
  const i = n || je[r];
  return /* @__PURE__ */ l(
    "svg",
    {
      style: { width: t, height: t * 1 },
      viewBox: "0 0 14 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: _("transition-opacity duration-200", i, e),
      children: /* @__PURE__ */ l(
        "path",
        {
          d: "M6.33325 3.66634H7.66659V4.99967H6.33325V3.66634ZM6.33325 6.33301H7.66659V10.333H6.33325V6.33301ZM6.99992 0.333008C3.31992 0.333008 0.333252 3.31967 0.333252 6.99967C0.333252 10.6797 3.31992 13.6663 6.99992 13.6663C10.6799 13.6663 13.6666 10.6797 13.6666 6.99967C13.6666 3.31967 10.6799 0.333008 6.99992 0.333008ZM6.99992 12.333C4.05992 12.333 1.66659 9.93967 1.66659 6.99967C1.66659 4.05967 4.05992 1.66634 6.99992 1.66634C9.93992 1.66634 12.3333 4.05967 12.3333 6.99967C12.3333 9.93967 9.93992 12.333 6.99992 12.333Z",
          fill: "currentColor"
        }
      )
    }
  );
}, wd = ({
  className: e = "",
  size: t = 16,
  variant: r = "default",
  color: n
}) => {
  const i = n || je[r];
  return /* @__PURE__ */ l(
    "svg",
    {
      width: t,
      height: t,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: _("transition-opacity duration-200", i, e),
      children: /* @__PURE__ */ l(
        "path",
        {
          d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z",
          fill: "currentColor"
        }
      )
    }
  );
}, xd = ({
  className: e = "",
  size: t = 18,
  variant: r = "default",
  color: n
}) => {
  const i = n || je[r];
  return /* @__PURE__ */ l(
    "svg",
    {
      width: t,
      height: t,
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: _("transition-opacity duration-200", i, e),
      children: /* @__PURE__ */ l(
        "path",
        {
          d: "M0 14V16H6V14H0ZM0 2V4H10V2H0ZM10 18V16H18V14H10V12H8V18H10ZM4 6V8H0V10H4V12H6V6H4ZM18 10V8H8V10H18ZM12 6H14V4H18V2H14V0H12V6Z",
          fill: "currentColor"
        }
      )
    }
  );
}, je = {
  default: "text-accent-primary",
  primary: "text-primary-light",
  secondary: "text-accent-secondary",
  error: "text-error-main",
  success: "text-success-main",
  "accent-primary": "text-accent-primary",
  "accent-secondary": "text-accent-secondary"
}, ir = ({ children: e, open: t = !1, className: r, onClose: n, ...i }) => {
  const { mounted: o, unmount: s } = rs({ open: t });
  return /* @__PURE__ */ b(Cn, { mounted: o, children: [
    /* @__PURE__ */ b(
      "div",
      {
        ...i,
        className: _(
          "bbn-dialog-mobile",
          t ? "animate-mobile-modal-in" : "animate-mobile-modal-out",
          r
        ),
        onAnimationEnd: s,
        children: [
          n && /* @__PURE__ */ l(
            "button",
            {
              onClick: n,
              className: "absolute top-4 left-4 z-10 p-1.5 rounded-full bg-surface-tertiary hover:bg-surface-quaternary transition-colors",
              "aria-label": "Close",
              children: /* @__PURE__ */ l(An, { size: 14, variant: "accent-primary" })
            }
          ),
          e
        ]
      }
    ),
    /* @__PURE__ */ l(ns, { open: t, onClick: n })
  ] });
};
var $n, to;
function tc() {
  if (to) return $n;
  to = 1;
  var e = "Expected a function", t = NaN, r = "[object Symbol]", n = /^\s+|\s+$/g, i = /^[-+]0x[0-9a-f]+$/i, o = /^0b[01]+$/i, s = /^0o[0-7]+$/i, a = parseInt, c = typeof nn == "object" && nn && nn.Object === Object && nn, d = typeof self == "object" && self && self.Object === Object && self, u = c || d || Function("return this")(), f = Object.prototype, p = f.toString, h = Math.max, m = Math.min, g = function() {
    return u.Date.now();
  };
  function y(S, E, V) {
    var I, H, W, O, T, $, X = 0, K = !1, U = !1, te = !0;
    if (typeof S != "function")
      throw new TypeError(e);
    E = k(E) || 0, w(V) && (K = !!V.leading, U = "maxWait" in V, W = U ? h(k(V.maxWait) || 0, E) : W, te = "trailing" in V ? !!V.trailing : te);
    function ie(F) {
      var re = I, De = H;
      return I = H = void 0, X = F, O = S.apply(De, re), O;
    }
    function oe(F) {
      return X = F, T = setTimeout(de, E), K ? ie(F) : O;
    }
    function se(F) {
      var re = F - $, De = F - X, Ce = E - re;
      return U ? m(Ce, W - De) : Ce;
    }
    function pe(F) {
      var re = F - $, De = F - X;
      return $ === void 0 || re >= E || re < 0 || U && De >= W;
    }
    function de() {
      var F = g();
      if (pe(F))
        return Se(F);
      T = setTimeout(de, se(F));
    }
    function Se(F) {
      return T = void 0, te && I ? ie(F) : (I = H = void 0, O);
    }
    function Oe() {
      T !== void 0 && clearTimeout(T), X = 0, I = $ = H = T = void 0;
    }
    function xe() {
      return T === void 0 ? O : Se(g());
    }
    function Fe() {
      var F = g(), re = pe(F);
      if (I = arguments, H = this, $ = F, re) {
        if (T === void 0)
          return oe($);
        if (U)
          return T = setTimeout(de, E), ie($);
      }
      return T === void 0 && (T = setTimeout(de, E)), O;
    }
    return Fe.cancel = Oe, Fe.flush = xe, Fe;
  }
  function A(S, E, V) {
    var I = !0, H = !0;
    if (typeof S != "function")
      throw new TypeError(e);
    return w(V) && (I = "leading" in V ? !!V.leading : I, H = "trailing" in V ? !!V.trailing : H), y(S, E, {
      leading: I,
      maxWait: E,
      trailing: H
    });
  }
  function w(S) {
    var E = typeof S;
    return !!S && (E == "object" || E == "function");
  }
  function L(S) {
    return !!S && typeof S == "object";
  }
  function N(S) {
    return typeof S == "symbol" || L(S) && p.call(S) == r;
  }
  function k(S) {
    if (typeof S == "number")
      return S;
    if (N(S))
      return t;
    if (w(S)) {
      var E = typeof S.valueOf == "function" ? S.valueOf() : S;
      S = w(E) ? E + "" : E;
    }
    if (typeof S != "string")
      return S === 0 ? S : +S;
    S = S.replace(n, "");
    var V = o.test(S);
    return V || s.test(S) ? a(S.slice(2), V ? 2 : 8) : i.test(S) ? t : +S;
  }
  return $n = A, $n;
}
var rc = tc();
const as = /* @__PURE__ */ bi(rc);
function jt(e = 768, t = 100) {
  const [r, n] = G(() => typeof window < "u" ? window.innerWidth < e : !1), i = Ae(), o = ge(() => {
    n(window.innerWidth < e);
  }, [e]);
  return J(() => (i.current = as(o, t), o(), window.addEventListener("resize", i.current), () => {
    i.current && (window.removeEventListener("resize", i.current), i.current.cancel());
  }), [o, t]), r;
}
const wi = 8, nc = 5, Kr = 640, ic = 500;
function Cd({ className: e, ...t }) {
  const n = jt(Kr) ? ir : Xr;
  return /* @__PURE__ */ l(n, { ...t, className: le("w-[41.25rem] max-w-full", e) });
}
const En = ({ className: e, children: t, title: r, onClose: n }) => /* @__PURE__ */ b("div", { className: _("bbn-dialog-header", e), "data-testid": "dialog-header", children: [
  /* @__PURE__ */ b("div", { className: "bbn-dialog-title", children: [
    /* @__PURE__ */ l(ui, { variant: "h5", children: r }),
    !!n && /* @__PURE__ */ l(li, { className: "shrink-0", onClick: n, "data-testid": "dialog-close-button", children: /* @__PURE__ */ l("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", children: /* @__PURE__ */ l(
      "path",
      {
        d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z",
        fill: "currentColor"
      }
    ) }) })
  ] }),
  t
] }), On = (e) => /* @__PURE__ */ l("div", { ...e, className: _("bbn-dialog-body", e.className) }), _n = (e) => /* @__PURE__ */ l("div", { ...e, className: _("bbn-dialog-footer", e.className) });
function Nd({ attributes: e, className: t }) {
  return /* @__PURE__ */ l("div", { className: t, children: e.map((r, n) => /* @__PURE__ */ b(
    "div",
    {
      className: "flex items-center justify-between border-b border-surface-secondary py-4 first:pt-0 last:border-0",
      children: [
        /* @__PURE__ */ l("span", { className: "text-sm text-accent-secondary", children: r.label }),
        /* @__PURE__ */ l("span", { className: "text-sm text-accent-primary font-medium", children: r.value })
      ]
    },
    n
  )) });
}
function kd({ className: e, ...t }) {
  return /* @__PURE__ */ l("span", { ...t, className: _("bbn-chip", e) });
}
function ls({ size: e = 40, className: t }) {
  return /* @__PURE__ */ l("span", { className: le("bbn-loader text-current", t), style: { width: e, height: e }, children: /* @__PURE__ */ l("svg", { viewBox: "22 22 44 44", children: /* @__PURE__ */ l("circle", { cx: "44", cy: "44", r: "20.2", fill: "none", stroke: "currentColor", strokeWidth: "3.6" }) }) });
}
function oc(e, { onLoadMore: t, hasMore: r = !1, loading: n = !1 } = {}) {
  const [i, o] = G(!1);
  return J(() => {
    const s = as((c) => {
      const d = c.target;
      o(d.scrollTop > 0), !n && r && d.scrollHeight - d.scrollTop <= d.clientHeight + 100 && (t == null || t());
    }, 100), a = e.current;
    if (a)
      return a.addEventListener("scroll", s), () => a.removeEventListener("scroll", s);
  }, [n, r, t, e]), {
    isScrolledTop: i
  };
}
function sc(e) {
  const [t, r] = G(!1), [n, i] = G(!1);
  return J(() => {
    const o = e.current;
    if (!o) return;
    const s = () => {
      const { scrollLeft: a, scrollWidth: c, clientWidth: d } = o;
      r(a > 0);
      const u = c - d;
      i(u > 0 && a < u);
    };
    return s(), o.addEventListener("scroll", s), () => o.removeEventListener("scroll", s);
  }, [e]), { isLeftScrolled: t, isRightScrolled: n };
}
const cs = wr({
  data: [],
  columns: [],
  sortStates: {},
  onColumnSort: void 0,
  onRowSelect: void 0,
  onRowClick: void 0,
  selectable: !1,
  selectedRows: [],
  onSelectAll: void 0,
  renderCheckbox: void 0,
  isRowSelectable: void 0,
  checkboxPosition: "left",
  showSelectAll: !0
});
function ac({
  name: e,
  className: t,
  children: r,
  sorter: n,
  frozen: i,
  showFrozenShadow: o,
  ...s
}) {
  const { columns: a, sortStates: c, onColumnSort: d } = nr(cs), u = c[e ?? ""], f = u == null ? void 0 : u.direction, p = i ? `bbn-table-frozen bbn-table-frozen-${i}` : "";
  return /* @__PURE__ */ l(
    Z,
    {
      variant: "caption",
      as: "th",
      className: _("bbn-cell-left", n && "bbn-table-sortable", p, i && o ? "bbn-frozen-shadow" : "", t),
      onClick: () => {
        if (n && e) {
          const m = a.find((g) => g.key === e);
          d == null || d(e, m == null ? void 0 : m.sorter);
        }
      },
      "data-column": e,
      ...s,
      children: /* @__PURE__ */ b("div", { className: "flex items-center justify-between gap-1", children: [
        /* @__PURE__ */ l("span", { children: r }),
        n && /* @__PURE__ */ b("span", { className: "bbn-table-sort-icons", children: [
          /* @__PURE__ */ l(
            _a,
            {
              className: _(
                "bbn-sort-icon bbn-sort-icon-up",
                f === "asc" ? "bbn-sort-icon-active" : "bbn-sort-icon-inactive"
              )
            }
          ),
          /* @__PURE__ */ l(
            Oa,
            {
              className: _(
                "bbn-sort-icon bbn-sort-icon-down",
                f === "desc" ? "bbn-sort-icon-active" : "bbn-sort-icon-inactive"
              )
            }
          )
        ] })
      ] })
    }
  );
}
const lc = {
  /**
   * Default table style - alternating colors, hover effects, standard header
   */
  default: {},
  /**
   * Card style - transparent header, card-like rows with gaps
   * Ideal for dashboard cards and modern interfaces
   */
  card: {
    layout: {
      fullWidth: !0,
      rowGap: !0
    },
    header: {
      background: !1
    },
    rows: {
      alternateColors: !1,
      hoverEffect: !1,
      rounded: !0,
      border: !1
    }
  }
};
function cc(e, t) {
  const [r, n] = G({}), i = ge((s, a) => {
    a && n((c) => {
      var p;
      const d = ((p = c[s]) == null ? void 0 : p.direction) ?? null, u = d === null ? "asc" : d === "asc" ? "desc" : null;
      if (u === null)
        return Object.fromEntries(
          Object.entries(c).filter(([h]) => h !== s).map(([h, m]) => [
            h,
            { ...m, priority: m.priority > c[s].priority ? m.priority - 1 : m.priority }
          ])
        );
      const f = Math.max(0, ...Object.values(c).map((h) => h.priority));
      return {
        ...c,
        [s]: { direction: u, priority: f + 1 }
      };
    });
  }, []), o = Te(() => {
    const s = Object.entries(r).filter(([, a]) => a.direction !== null).toSorted((a, c) => c[1].priority - a[1].priority).map(([a, c]) => ({
      column: t.find((d) => d.key === a),
      direction: c.direction
    })).filter(({ column: a }) => a == null ? void 0 : a.sorter);
    return s.length === 0 ? e : e.toSorted((a, c) => {
      for (const { column: d, direction: u } of s) {
        const f = d.sorter(a, c);
        if (f !== 0) return u === "asc" ? f : -f;
      }
      return 0;
    });
  }, [e, t, r]);
  return { sortStates: r, handleColumnSort: i, sortedData: o };
}
function uc({
  className: e,
  render: t,
  value: r,
  columnName: n,
  frozen: i,
  showFrozenShadow: o,
  ...s
}) {
  const a = i ? `bbn-table-frozen bbn-table-frozen-${i}` : "";
  return /* @__PURE__ */ l(
    Z,
    {
      variant: "body2",
      as: "td",
      className: _("bbn-cell-left", a, i && o ? "bbn-frozen-shadow" : "", e),
      "data-column": n,
      ...s,
      children: t ? t(r) : r
    }
  );
}
function dc({
  row: e,
  columns: t,
  isSelected: r,
  isSelectable: n,
  onSelect: i,
  onRowClick: o,
  isLeftScrolled: s,
  isRightScrolled: a,
  selectable: c = !1,
  renderCheckbox: d,
  checkboxPosition: u = "left"
}) {
  const f = () => {
    o ? o(e) : i && !c && i(e);
  }, h = c ? /* @__PURE__ */ l("td", { className: "bbn-table-cell-checkbox", children: /* @__PURE__ */ l("div", { className: "flex items-center justify-center", onClick: (m) => {
    m.stopPropagation(), n && i && i(e);
  }, children: d ? d(r, e) : /* @__PURE__ */ l(
    "input",
    {
      type: "checkbox",
      checked: r,
      onChange: () => {
      },
      disabled: !n,
      "aria-label": `Select row ${e.id}`
    }
  ) }) }) : null;
  return /* @__PURE__ */ b(
    "tr",
    {
      className: _(
        r && "selected",
        (!!i || !!o) && n && "cursor-pointer",
        !n && "opacity-50"
      ),
      onClick: f,
      children: [
        u === "left" && h,
        t.map((m) => /* @__PURE__ */ l(
          uc,
          {
            value: e[m.key],
            columnName: m.key,
            className: m.cellClassName,
            frozen: m.frozen,
            showFrozenShadow: m.frozen === "left" && s || m.frozen === "right" && a,
            render: m.render ? (g) => m.render(g, e) : void 0
          },
          m.key
        )),
        u === "right" && h
      ]
    }
  );
}
const fc = {
  // Layout
  fullWidth: !1,
  rowGap: !1,
  rowGapSize: void 0,
  // Header
  background: !0,
  backgroundColor: void 0,
  // Rows
  alternateColors: !0,
  hoverEffect: !0,
  rounded: !1,
  border: !1,
  borderRadius: void 0,
  borderColor: void 0,
  rowBackgroundColor: void 0,
  hoverColor: void 0,
  clickable: !1
};
function hc(e, t) {
  return {
    layout: { ...e.layout ?? {}, ...t.layout ?? {} },
    header: { ...e.header ?? {}, ...t.header ?? {} },
    rows: { ...e.rows ?? {}, ...t.rows ?? {} }
  };
}
function mc(e, t) {
  const r = e ? lc[e] ?? {} : {}, n = hc(r, t ?? {});
  return {
    ...fc,
    ...n.layout,
    ...n.header,
    ...n.rows
  };
}
function pc({
  data: e,
  columns: t,
  className: r,
  wrapperClassName: n,
  fluid: i = !1,
  hasMore: o = !1,
  loading: s = !1,
  onLoadMore: a,
  onRowSelect: c,
  onRowClick: d,
  isRowSelectable: u,
  stylePreset: f,
  styleConfig: p,
  selectedRow: h,
  defaultSelectedRow: m,
  onSelectedRowChange: g,
  // Multi-select props
  selectable: y = !1,
  selectedRows: A,
  onSelectedRowsChange: w,
  renderCheckbox: L,
  checkboxPosition: N = "left",
  showSelectAll: k = !0,
  ...S
}, E) {
  const V = Te(() => mc(f, p), [f, p]), I = Ae(null);
  Wr(E, () => I.current, []);
  const { sortStates: H, handleColumnSort: W, sortedData: O } = cc(e, t), { isScrolledTop: T } = oc(I, { onLoadMore: a, hasMore: o, loading: s }), { isLeftScrolled: $, isRightScrolled: X } = sc(I), [K, U] = St({
    value: h,
    defaultValue: m ?? null,
    onStateChange: g
  }), [te, ie] = St({
    value: A,
    defaultValue: [],
    onStateChange: w
  }), oe = te ?? [], se = ge(
    (F) => {
      if (!c || u && !u(F)) return;
      const re = K === F.id ? null : F.id;
      U(re), c(re === null ? null : F);
    },
    [c, u, K, U]
  ), pe = ge(
    (F) => {
      if (u && !u(F)) return;
      const De = oe.includes(F.id) ? oe.filter((Ce) => Ce !== F.id) : [...oe, F.id];
      ie(De);
    },
    [oe, ie, u]
  ), de = ge(() => {
    if (oe.length === O.length)
      ie([]);
    else {
      const F = O.filter((re) => !u || u(re)).map((re) => re.id);
      ie(F);
    }
  }, [O, oe.length, ie, u]), Se = Te(
    () => ({
      data: O,
      columns: t,
      sortStates: H,
      onColumnSort: W,
      onRowSelect: y ? pe : se,
      onRowClick: d,
      // Multi-select
      selectable: y,
      selectedRows: oe,
      onSelectAll: de,
      renderCheckbox: L,
      isRowSelectable: u,
      checkboxPosition: N,
      showSelectAll: k
    }),
    [
      O,
      t,
      H,
      W,
      se,
      pe,
      d,
      y,
      oe,
      de,
      L,
      u,
      N,
      k
    ]
  ), Oe = Te(() => t.some((F) => F.header && F.header !== ""), [t]), xe = Te(() => {
    const F = O.filter((re) => !u || u(re));
    return F.length > 0 && F.every((re) => oe.includes(re.id));
  }, [O, oe, u]), Fe = Te(() => {
    const F = {};
    return V.rowGapSize && (F["--bbn-table-row-gap"] = V.rowGapSize), V.backgroundColor && (F["--bbn-table-header-bg"] = V.backgroundColor), V.borderRadius && (F["--bbn-table-row-radius"] = V.borderRadius), V.borderColor && (F["--bbn-table-row-border-color"] = V.borderColor), V.rowBackgroundColor && (F["--bbn-table-row-bg"] = V.rowBackgroundColor), V.hoverColor && (F["--bbn-table-row-hover-bg"] = V.hoverColor), Object.keys(F).length > 0 ? F : void 0;
  }, [V]);
  return /* @__PURE__ */ l(cs.Provider, { value: Se, children: /* @__PURE__ */ l("div", { ref: I, className: _("bbn-table-wrapper", i && "bbn-table-wrapper-fluid", n), children: /* @__PURE__ */ b(
    "table",
    {
      className: _(
        "bbn-table",
        i && "bbn-table-fluid",
        V.rounded && "bbn-table-rounded",
        V.fullWidth && "bbn-table-fullrow",
        V.rowGap && "bbn-table-row-gap",
        r
      ),
      style: Fe,
      ...S,
      children: [
        /* @__PURE__ */ l("thead", { className: _("bbn-table-header", !V.background && "bbn-table-header-transparent", T && "scrolled-top", !Oe && "hidden"), children: /* @__PURE__ */ b("tr", { children: [
          y && N === "left" && /* @__PURE__ */ l("th", { className: "bbn-table-cell-checkbox", children: k && /* @__PURE__ */ l("div", { className: "flex items-center justify-center", children: L ? /* @__PURE__ */ l("div", { onClick: de, children: L(xe, {}) }) : /* @__PURE__ */ l(
            "input",
            {
              type: "checkbox",
              checked: xe,
              onChange: de,
              "aria-label": "Select all rows"
            }
          ) }) }),
          t.map((F) => /* @__PURE__ */ l(
            ac,
            {
              className: F.headerClassName,
              name: F.key,
              sorter: F.sorter,
              frozen: F.frozen,
              showFrozenShadow: F.frozen === "left" && $ || F.frozen === "right" && X,
              children: F.header
            },
            F.key
          )),
          y && N === "right" && /* @__PURE__ */ l("th", { className: "bbn-table-cell-checkbox", children: k && /* @__PURE__ */ l("div", { className: "flex items-center justify-center", children: L ? /* @__PURE__ */ l("div", { onClick: de, children: L(xe, {}) }) : /* @__PURE__ */ l(
            "input",
            {
              type: "checkbox",
              checked: xe,
              onChange: de,
              "aria-label": "Select all rows"
            }
          ) }) })
        ] }) }),
        /* @__PURE__ */ l(
          "tbody",
          {
            className: _(
              "bbn-table-body",
              V.fullWidth && "bbn-table-body-full",
              !V.alternateColors && "bbn-table-body-no-alternate",
              !V.hoverEffect && "bbn-table-body-no-hover",
              V.border ? "bbn-table-body-row-border" : !V.alternateColors && "bbn-table-body-no-border",
              V.clickable && "bbn-table-body-clickable"
            ),
            children: O.map((F) => /* @__PURE__ */ l(
              dc,
              {
                row: F,
                columns: t,
                isSelected: y ? oe.includes(F.id) : K === F.id,
                isSelectable: u ? u(F) : !0,
                onSelect: y ? pe : se,
                onRowClick: d,
                isLeftScrolled: $,
                isRightScrolled: X,
                selectable: y,
                renderCheckbox: L,
                checkboxPosition: N
              },
              F.id
            ))
          }
        )
      ]
    }
  ) }) });
}
const vc = nt(pc);
function gc({ as: e = "div", className: t, children: r }) {
  return yn(e, { className: _("bbn-card", t) }, r);
}
function Vn(e = {}) {
  const { copiedText: t = "Copied ✓", timeout: r = 2e3 } = e, [n, i] = G({}), o = Ae({}), s = ge((u) => {
    u && i((f) => ({ ...f, [u]: !1 }));
  }, []), a = ge(
    (u, f) => {
      if (!u || !f) return;
      navigator.clipboard.writeText(f).catch(() => {
      }), i((h) => ({ ...h, [u]: !0 }));
      const p = o.current[u];
      p && clearTimeout(p), r > 0 && (o.current[u] = setTimeout(() => {
        o.current[u] = void 0, s(u);
      }, r));
    },
    [r, s]
  ), c = ge(
    (u) => u && n[u] || !1,
    [n]
  ), d = ge(
    (u) => u && n[u] ? t : "",
    [n, t]
  );
  return J(() => () => {
    Object.values(o.current).forEach((u) => u && clearTimeout(u)), o.current = {};
  }, []), {
    isCopied: c,
    copiedText: d,
    copyToClipboard: a
  };
}
const us = ({
  children: e,
  value: t,
  className: r,
  onCopy: n,
  isCopied: i,
  copiedText: o,
  timeout: s = 2e3
}) => {
  const a = Ur(), c = {
    copiedText: o,
    timeout: s
  }, {
    isCopied: d,
    copiedText: u,
    copyToClipboard: f
  } = Vn(c), p = i !== void 0, h = p ? i : d(a), m = p ? o || "Copied ✓" : u(a), g = (y) => {
    y.stopPropagation(), p && n ? n(t) : f(a, t);
  };
  return /* @__PURE__ */ l(
    "div",
    {
      className: le(
        "inline-flex items-center cursor-pointer hover:opacity-100 transition-opacity duration-200",
        r
      ),
      onClick: g,
      children: /* @__PURE__ */ b("div", { className: "relative", children: [
        /* @__PURE__ */ l(
          "div",
          {
            className: le(
              "transition-opacity duration-300 ease-in-out",
              h && "opacity-0"
            ),
            children: e
          }
        ),
        h && /* @__PURE__ */ l(
          "div",
          {
            className: le(
              "absolute inset-0 flex items-center transition-opacity duration-300 ease-in-out text-green-600",
              "opacity-100"
            ),
            children: m
          }
        )
      ] })
    }
  );
};
function ds(e, t = 8) {
  if (!e || e.length <= t * 2)
    return e;
  const r = e.slice(0, t), n = e.slice(-t);
  return `${r}...${n}`;
}
function bc(e) {
  return typeof e == "string" && e.length >= 42 ? ds(e) : e;
}
function yc(e) {
  return typeof e == "string" && e.length >= 42;
}
function Sd({
  items: e,
  showDivider: t = !0,
  textSize: r = "medium",
  className: n
}) {
  const i = r === "medium" ? "text-[16px]" : "text-[14px]";
  return /* @__PURE__ */ l(
    "div",
    {
      className: le(
        "flex flex-col gap-6",
        t && "divide-y divide-surface-secondary",
        n
      ),
      children: e.map((o, s) => {
        const a = yc(o.value), c = bc(o.value);
        return /* @__PURE__ */ b("div", { className: "flex items-center justify-between", children: [
          /* @__PURE__ */ l("span", { className: le(i, "font-normal text-accent-secondary"), children: o.label }),
          /* @__PURE__ */ b("span", { className: le(
            i,
            "font-normal text-accent-primary",
            a && "flex items-center gap-1.5"
          ), children: [
            c,
            a && typeof o.value == "string" && /* @__PURE__ */ l(
              us,
              {
                value: o.value,
                className: "shrink-0",
                copiedText: "✓",
                children: /* @__PURE__ */ l(Ln, { size: 14, className: "text-accent-secondary" })
              }
            )
          ] })
        ] }, s);
      })
    }
  );
}
const fs = ({
  value: e,
  defaultValue: t = !1,
  onChange: r,
  className: n = "",
  disabled: i = !1
}) => {
  const [o = !1, s] = St({
    value: e,
    defaultValue: t,
    onStateChange: r
  });
  return /* @__PURE__ */ l(
    "button",
    {
      type: "button",
      onClick: () => {
        i || s(!o);
      },
      disabled: i,
      className: _(
        "bbn-toggle",
        o && "bbn-toggle-active",
        i && "bbn-toggle-disabled",
        n
      ),
      "aria-pressed": o,
      "aria-label": "Toggle",
      children: /* @__PURE__ */ l(
        "span",
        {
          className: _(
            "bbn-toggle-control",
            o && "bbn-toggle-control-active"
          )
        }
      )
    }
  );
};
function wc({
  value: e,
  min: t,
  max: r,
  step: n = 1,
  steps: i,
  maxStepCount: o = 10,
  onChange: s,
  onStepsChange: a,
  variant: c = "primary",
  activeColor: d,
  className: u,
  disabled: f = !1,
  showFill: p = !0
}) {
  const h = Te(() => (e - t) / (r - t) * 100, [e, t, r]), m = Te(() => {
    if (typeof i == "number") {
      const N = Math.min(i, o), k = (r - t) / (N - 1);
      return Array.from({ length: N }, (S, E) => ({
        value: t + k * E
      }));
    }
    if (Array.isArray(i))
      return i.slice(0, o);
    const w = 5, L = (r - t) / w;
    return Array.from({ length: w }, (N, k) => ({
      value: t + L * k
    }));
  }, [i, t, r, o, n]), g = Te(() => m ? m.filter((w) => w.value > t && w.value < r) : [], [m, t, r]), y = Te(() => {
    if (Array.isArray(i) && m && m.length > 1) {
      const w = m.map((N) => N.value).sort((N, k) => N - k);
      let L = 1 / 0;
      for (let N = 1; N < w.length; N++) {
        const k = w[N] - w[N - 1];
        k > 0 && k < L && (L = k);
      }
      return L !== 1 / 0 ? L : n;
    }
    return n;
  }, [i, m, n]), A = (w) => {
    if (Array.isArray(i) && m && m.length > 0) {
      const L = m.reduce((N, k) => Math.abs(k.value - w) < Math.abs(N.value - w) ? k : N);
      if (s(L.value), a && m) {
        const N = m.findIndex((k) => k.value === L.value);
        if (N !== -1) {
          const k = m.slice(0, N + 1).map((S) => S.value);
          a(k);
        }
      }
    } else
      s(w);
  };
  return /* @__PURE__ */ b("div", { className: "relative w-full", children: [
    /* @__PURE__ */ l(
      "input",
      {
        type: "range",
        min: t,
        max: r,
        step: y,
        value: e,
        onChange: (w) => A(parseFloat(w.target.value)),
        disabled: f,
        className: _(
          "bbn-slider",
          `bbn-slider-${c}`,
          p && "bbn-slider-filled",
          f && "bbn-slider-disabled",
          g.length > 0 && "bbn-slider-with-steps",
          u
        ),
        style: {
          "--slider-fill": `${h}%`,
          "--slider-active-color": d
        }
      }
    ),
    g.length > 0 && /* @__PURE__ */ l(
      "div",
      {
        className: "absolute left-0 right-0 pointer-events-none z-10",
        style: { top: "calc(50% - 1px)" },
        children: g.map((w, L) => {
          const N = (w.value - t) / (r - t) * 100;
          return /* @__PURE__ */ l(
            "div",
            {
              className: "absolute rounded-full bg-white",
              style: {
                width: "4px",
                height: "4px",
                left: `calc(${N}% - 1px)`
              }
            },
            L
          );
        })
      }
    ),
    c === "rainbow" && /* @__PURE__ */ l(
      "div",
      {
        className: "absolute top-0 h-2 rounded-lg pointer-events-none",
        style: {
          left: `${h}%`,
          right: 0,
          backgroundColor: "var(--unfilled-color)"
        }
      }
    )
  ] });
}
const xc = {
  adaptive: "adaptive",
  horizontal: "vertical",
  vertical: "horizontal"
};
function Ld({ className: e, orientation: t = "vertical", children: r }) {
  return /* @__PURE__ */ l("div", { className: le("bbn-list", `bbn-list-${t}`, e), children: Yn.map(
    r,
    (n) => Ho(n) ? Fo(n, {
      orientation: xc[t]
    }) : n
  ) });
}
function Cc({ className: e, orientation: t = "horizontal", title: r, value: n, suffix: i }) {
  return /* @__PURE__ */ b("div", { className: _("bbn-list-item", `bbn-list-item-${t}`, e), children: [
    /* @__PURE__ */ l(
      Z,
      {
        as: "div",
        className: _("bbn-list-title", `bbn-list-title-${t}`),
        variant: t === "horizontal" ? "body1" : "body2",
        children: r
      }
    ),
    /* @__PURE__ */ b(Z, { as: "div", className: _("bbn-list-value", `bbn-list-value-${t}`), variant: "body1", children: [
      n,
      i
    ] })
  ] });
}
function ro(e) {
  return we({ attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" }, child: [] }, { tag: "path", attr: { d: "M464 336a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z" }, child: [] }] })(e);
}
function Nc(e) {
  return we({ attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8Z" }, child: [] }, { tag: "path", attr: { d: "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8Z" }, child: [] }] })(e);
}
function kc({
  isOpen: e
}) {
  const [t, r] = G(!1), [n, i] = G(!1);
  J(() => {
    e && !t && (r(!0), i(!1), requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        i(!0);
      });
    }));
  }, [e, t]), J(() => {
    !e && t && i(!1);
  }, [e, t]);
  const o = ge(() => {
    !e && t && r(!1);
  }, [e, t]);
  return {
    mounted: t,
    shouldShowOpen: n,
    handleAnimationEnd: o
  };
}
const Ad = ({
  hidden: e = !1,
  loading: t,
  title: r,
  value: n,
  tooltip: i,
  loadingStyle: o = "spinner",
  ...s
}) => {
  const a = Ur(), c = jt(), [d, u] = G(!1), [f, p] = G(null);
  return J(() => {
    !c && d && u(!1);
  }, [c, d]), e ? null : /* @__PURE__ */ l(
    Cc,
    {
      ...s,
      title: r,
      value: t ? /* @__PURE__ */ b("div", { className: "inline-flex items-center gap-2", children: [
        /* @__PURE__ */ l("span", { className: "loader size-5" }),
        o === "spinner-and-value" && /* @__PURE__ */ l("span", { className: "opacity-50", children: n })
      ] }) : n,
      suffix: i ? c ? /* @__PURE__ */ b(Pe, { children: [
        /* @__PURE__ */ l("span", { className: "block size-5 cursor-pointer text-xs", onClick: () => u(!0), children: /* @__PURE__ */ l(ro, { size: 20 }) }),
        /* @__PURE__ */ b(ir, { open: d, onClose: () => u(!1), children: [
          /* @__PURE__ */ l("div", { className: "px-4 py-2 text-accent-primary", children: i }),
          /* @__PURE__ */ l("div", { className: "p-4", children: /* @__PURE__ */ l(Me, { variant: "contained", fluid: !0, onClick: () => u(!1), children: "Done" }) })
        ] })
      ] }) : /* @__PURE__ */ b(Pe, { children: [
        /* @__PURE__ */ l(
          "span",
          {
            className: "block size-5 cursor-pointer text-xs",
            onMouseEnter: (g) => p(g.currentTarget),
            onMouseLeave: () => p(null),
            "aria-describedby": a,
            children: /* @__PURE__ */ l(ro, { size: 20 })
          }
        ),
        /* @__PURE__ */ l(Nn, { open: !!f, anchorEl: f, placement: "top", offset: [0, 8], children: /* @__PURE__ */ l("div", { className: "tooltip-wrap", children: i }) })
      ] }) : void 0
    }
  );
};
function Sc({
  children: e,
  count: t = 0,
  max: r = 99,
  position: n = "bottom-right",
  color: i = "error",
  className: o,
  badgeClassName: s,
  contentClassName: a
}) {
  const c = typeof t == "number" ? t > 0 : t != null, d = typeof t == "number" && t > r ? `${r}+` : t, u = `bbn-badge-${n}`, f = `bbn-badge-${i}`;
  return /* @__PURE__ */ b("div", { className: _("bbn-badge", o), children: [
    e,
    c && /* @__PURE__ */ l("span", { className: _("bbn-badge-indicator", u, f, s), children: /* @__PURE__ */ l("span", { className: _("bbn-badge-content", a), children: d }) })
  ] });
}
const zt = ({
  children: e,
  style: t,
  variant: r = "contained",
  className: n
}) => /* @__PURE__ */ l(
  "div",
  {
    className: _("bbn-subsection", `bbn-subsection-${r}`, n),
    style: t,
    children: e
  }
);
function Lc({ counter: e, max: t, onAdd: r, alwaysShowCounter: n = !1, hidePlusButton: i = !1 }) {
  const o = e < t && !i, s = 0 < e || n && e === 0;
  return /* @__PURE__ */ b(
    "div",
    {
      className: _(
        "bg-primary-highlight flex overflow-hidden rounded-md border border-accent-primary w-fit",
        o && "cursor-pointer",
        !s && !o && "hidden",
        !s && "w-10"
      ),
      onClick: o ? r : void 0,
      children: [
        o && !i && /* @__PURE__ */ l("div", { className: "flex h-10 w-10 items-center justify-center", children: /* @__PURE__ */ l(Nc, { size: 20 }) }),
        s && /* @__PURE__ */ b("div", { className: _(
          "flex h-10 items-center px-4 text-base",
          o && "border-l border-accent-primary"
        ), children: [
          e,
          "/",
          t
        ] })
      ]
    }
  );
}
const hs = wr(void 0), ms = () => nr(hs), Ac = ({ children: e, value: t }) => /* @__PURE__ */ l(hs.Provider, { value: t, children: e }), ps = ({
  isOpen: e,
  onClose: t,
  title: r,
  children: n,
  className: i = "",
  titleAlign: o = "left",
  backIcon: s,
  fullHeight: a = !1,
  fullWidth: c = !1,
  showBackButton: d = !0,
  showDivider: u = !0,
  onBackdropClick: f
}) => {
  const { mounted: p, shouldShowOpen: h, handleAnimationEnd: m } = kc({ isOpen: e }), g = {
    left: "text-left",
    center: "text-center",
    right: "text-right"
  }, y = () => d || r ? /* @__PURE__ */ b(
    "div",
    {
      className: _(
        "flex items-center p-4",
        u && "border-b border-[#38708533] dark:border-[#404040]"
      ),
      children: [
        d && /* @__PURE__ */ l(
          "button",
          {
            onClick: t,
            className: "flex h-8 w-8 flex-shrink-0 items-center justify-center rounded transition-colors hover:bg-accent-secondary/10",
            "aria-label": "Go back",
            children: s || /* @__PURE__ */ l(
              "svg",
              {
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "text-accent-primary",
                children: /* @__PURE__ */ l(
                  "path",
                  {
                    d: "M10 12L6 8L10 4",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                  }
                )
              }
            )
          }
        ),
        r && /* @__PURE__ */ l(
          "h3",
          {
            className: _(
              "flex-1 text-sm font-medium text-accent-primary",
              d ? "ml-3" : "",
              g[o]
            ),
            children: r
          }
        )
      ]
    }
  ) : null, A = () => /* @__PURE__ */ b(Pe, { children: [
    y(),
    /* @__PURE__ */ l("div", { className: "flex-1 overflow-y-auto", children: n })
  ] });
  return a ? /* @__PURE__ */ b(Cn, { mounted: p, rootClassName: "menu-drawer-portal", children: [
    f && /* @__PURE__ */ l(
      "div",
      {
        className: _(
          "fixed inset-0 z-40 bg-black/50 transition-opacity duration-300",
          h ? "opacity-100" : "pointer-events-none opacity-0"
        ),
        onClick: f
      }
    ),
    /* @__PURE__ */ l(
      "div",
      {
        className: _(
          "transform transition-transform duration-300 ease-in-out",
          "bg-surface",
          "fixed inset-y-0 right-0 z-50",
          c ? "w-full" : "w-full max-w-sm",
          h ? "translate-x-0" : "translate-x-full",
          i
        ),
        onTransitionEnd: m,
        children: A()
      }
    )
  ] }) : /* @__PURE__ */ l(
    "div",
    {
      className: _(
        "transform transition-transform duration-300 ease-in-out",
        "bg-surface",
        "absolute inset-0 rounded-lg",
        e ? "translate-x-0" : "translate-x-full",
        i
      ),
      children: A()
    }
  );
}, xi = ({
  children: e,
  trigger: t,
  open: r,
  onOpenChange: n,
  placement: i = "bottom-end",
  offset: o = [0, 8],
  className: s,
  mobileMode: a = "dialog"
}) => {
  const [c, d] = G(!1), u = Ae(null), f = jt(), p = r !== void 0 ? r : c, h = (A) => {
    r === void 0 && d(A), n == null || n(A);
  }, m = () => h(!1), g = /* @__PURE__ */ l("div", { className: "relative w-full overflow-hidden", children: e }), y = t || /* @__PURE__ */ l("button", { className: "rounded p-2 hover:bg-gray-100 dark:hover:bg-gray-800", onClick: () => h(!p), children: "Menu" });
  return /* @__PURE__ */ b(Ac, { value: { isOpen: p, setIsOpen: h, onClose: m, isMobile: f }, children: [
    /* @__PURE__ */ l("div", { ref: u, className: "inline-block", children: q.isValidElement(y) && q.cloneElement(y, {
      onClick: () => h(!p),
      "aria-haspopup": "true",
      "aria-expanded": p
    }) }),
    f ? a === "dialog" ? /* @__PURE__ */ l(
      ir,
      {
        open: p,
        onClose: m,
        className: _(
          "bg-surface text-primary-main",
          s
        ),
        children: g
      }
    ) : /* @__PURE__ */ l(
      ps,
      {
        isOpen: p,
        onClose: m,
        onBackdropClick: m,
        fullHeight: !0,
        fullWidth: !0,
        showBackButton: !0,
        showDivider: !1,
        children: g
      }
    ) : /* @__PURE__ */ l(
      Nn,
      {
        anchorEl: u.current,
        open: p,
        offset: o,
        placement: i,
        onClickOutside: m,
        className: _(
          "rounded-lg border border-[#38708533] bg-surface shadow-lg dark:border-[#404040]",
          "min-w-[294px]",
          s
        ),
        children: g
      }
    )
  ] });
}, vs = ({
  icon: e,
  name: t,
  description: r,
  onClick: n,
  disabled: i = !1,
  className: o,
  children: s,
  suffix: a,
  selected: c = !1,
  role: d = "menuitem",
  toggle: u
}) => {
  const f = ms(), p = u ? /* @__PURE__ */ l(
    fs,
    {
      value: u.value,
      defaultValue: u.defaultValue,
      onChange: u.onChange
    }
  ) : null, h = p || a, m = () => {
    i || p || (n && n(), f && !h && f.onClose());
  };
  return s ? /* @__PURE__ */ l(
    "button",
    {
      onClick: m,
      disabled: i,
      className: _("w-full text-left", i && "cursor-not-allowed opacity-50", o),
      children: s
    }
  ) : /* @__PURE__ */ b(
    "div",
    {
      className: _(
        "flex w-full items-center justify-between p-6",
        "transition-colors",
        !p && "cursor-pointer hover:bg-accent-secondary/5",
        // Only hover if no toggle
        "text-left",
        c && "bg-accent-secondary/10",
        i && "cursor-not-allowed opacity-50",
        p && "cursor-default",
        // Disable pointer cursor when toggle is present
        o
      ),
      role: d,
      "aria-selected": c,
      onClick: m,
      children: [
        /* @__PURE__ */ b("div", { className: "flex items-center gap-3", children: [
          e && /* @__PURE__ */ l("div", { className: "flex-shrink-0", children: e }),
          /* @__PURE__ */ b("div", { className: "flex flex-col", children: [
            /* @__PURE__ */ l("div", { className: "text-sm font-medium text-accent-primary", children: t }),
            r && /* @__PURE__ */ l("div", { className: "text-xs text-accent-secondary", children: r })
          ] })
        ] }),
        h && /* @__PURE__ */ l("div", { className: "flex-shrink-0", children: h })
      ]
    }
  );
}, Ec = ({
  children: e,
  name: t,
  description: r,
  icon: n,
  backIcon: i,
  suffix: o,
  className: s,
  contentClassName: a,
  titleAlign: c = "left"
}) => {
  const [d, u] = G(!1), f = ms(), p = /* @__PURE__ */ l(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: "text-accent-primary",
      children: /* @__PURE__ */ l("path", { d: "M10 12L6 8L10 4", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
    }
  ), h = /* @__PURE__ */ l(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: "text-accent-primary",
      children: /* @__PURE__ */ l("path", { d: "M6 4L10 8L6 12", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
    }
  );
  return /* @__PURE__ */ b(Pe, { children: [
    /* @__PURE__ */ b(
      "button",
      {
        onClick: () => u(!0),
        className: _(
          "flex w-full items-center justify-between p-6",
          "transition-colors hover:bg-accent-secondary/5",
          "text-left focus:outline-none",
          s
        ),
        role: "menuitem",
        children: [
          /* @__PURE__ */ b("div", { className: "flex items-center gap-3", children: [
            n && /* @__PURE__ */ l("div", { className: "flex-shrink-0", children: n }),
            /* @__PURE__ */ b("div", { className: "flex flex-col", children: [
              /* @__PURE__ */ l("span", { className: "text-sm font-medium text-accent-primary", children: t }),
              r && /* @__PURE__ */ l("span", { className: "mt-0.5 text-xs text-accent-secondary", children: r })
            ] })
          ] }),
          o || h
        ]
      }
    ),
    /* @__PURE__ */ l(
      ps,
      {
        isOpen: d,
        onClose: () => u(!1),
        title: t || "",
        titleAlign: c,
        backIcon: i || p,
        fullHeight: f == null ? void 0 : f.isMobile,
        fullWidth: f == null ? void 0 : f.isMobile,
        onBackdropClick: f != null && f.isMobile ? void 0 : () => u(!1),
        className: _(f != null && f.isMobile ? "z-60" : "z-50", a),
        children: e
      }
    )
  ] });
}, Ed = ({
  label: e,
  description: t,
  onClick: r,
  selected: n = !1,
  className: i,
  suffix: o,
  disabled: s = !1
}) => {
  const a = /* @__PURE__ */ l("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ l(
    "path",
    {
      d: "M16.6667 5L7.5 14.1667L3.33333 10",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ) });
  return /* @__PURE__ */ b(
    "button",
    {
      role: "menuitem",
      onClick: r,
      disabled: s,
      className: _(
        "flex w-full items-center justify-between p-4",
        "transition-colors hover:bg-accent-secondary/5",
        "text-left focus:outline-none",
        n && "bg-accent-secondary/10",
        s && "cursor-not-allowed opacity-50",
        i
      ),
      "aria-selected": n,
      tabIndex: s ? -1 : 0,
      children: [
        /* @__PURE__ */ b("div", { className: "flex flex-col items-start", children: [
          /* @__PURE__ */ l("span", { className: "font-medium text-accent-primary", children: e }),
          t && /* @__PURE__ */ l("span", { className: "text-sm text-accent-secondary", children: t })
        ] }),
        n && (o || a)
      ]
    }
  );
}, Od = ({
  items: e,
  defaultActiveTab: t,
  activeTab: r,
  onTabChange: n,
  className: i,
  keepMounted: o,
  variant: s = "default"
}) => {
  var h, m;
  const [a, c] = G(
    t || ((h = e[0]) == null ? void 0 : h.id) || ""
  ), d = r ?? a;
  J(() => {
    r !== void 0 && c(r);
  }, [r]);
  const u = (g) => {
    n ? n(g) : c(g);
  }, f = (m = e.find((g) => g.id === d)) == null ? void 0 : m.content, p = s === "simple";
  return /* @__PURE__ */ b("div", { className: le("w-full", i), children: [
    /* @__PURE__ */ l("div", { className: "mb-6 flex w-full gap-6", role: "tablist", children: e.map((g) => /* @__PURE__ */ l(
      "button",
      {
        id: `tab-${g.id}`,
        role: "tab",
        "aria-selected": d === g.id,
        "aria-controls": `panel-${g.id}`,
        tabIndex: d === g.id ? 0 : -1,
        className: le(
          "transition-colors duration-200",
          p ? le(
            "text-lg font-normal pb-4",
            d === g.id ? "text-accent-primary" : "text-accent-secondary"
          ) : le(
            "rounded px-4 py-2 text-accent-primary",
            d === g.id ? "bg-secondary-highlight" : "bg-transparent"
          )
        ),
        onClick: () => u(g.id),
        children: g.label
      },
      g.id
    )) }),
    p && /* @__PURE__ */ l("div", { className: "w-full h-[1px] bg-secondary-strokeDark mb-6 -mt-6 opacity-30" }),
    o ? /* @__PURE__ */ l("div", { className: "mt-6", children: e.map((g) => /* @__PURE__ */ l(
      "div",
      {
        role: "tabpanel",
        id: `panel-${g.id}`,
        "aria-labelledby": `tab-${g.id}`,
        className: le(d === g.id ? "" : "hidden"),
        children: g.content
      },
      g.id
    )) }) : /* @__PURE__ */ l(
      "div",
      {
        role: "tabpanel",
        id: `panel-${d}`,
        "aria-labelledby": `tab-${d}`,
        children: f
      }
    )
  ] });
}, Ci = ({
  amount: e,
  currencyIcon: t,
  currencyName: r,
  placeholder: n = "Enter Amount",
  displayBalance: i,
  balanceDetails: o,
  min: s,
  step: a,
  autoFocus: c,
  onChange: d,
  onKeyDown: u,
  amountUsd: f,
  disabled: p = !1,
  readOnly: h = !1,
  onMaxClick: m
}) => /* @__PURE__ */ b(Pe, { children: [
  /* @__PURE__ */ b("div", { className: "flex w-full flex-row content-center items-center justify-between font-normal", children: [
    /* @__PURE__ */ b("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ l("img", { src: t, alt: r, className: "h-10 max-h-[2.5rem] w-10 max-w-[2.5rem]" }),
      /* @__PURE__ */ l("div", { className: "text-lg", children: r })
    ] }),
    /* @__PURE__ */ l(
      "input",
      {
        type: "number",
        value: e ?? "",
        min: s,
        step: a,
        onChange: d,
        onKeyDown: u,
        disabled: p,
        readOnly: h,
        placeholder: n,
        autoFocus: c,
        className: "w-2/3 bg-transparent text-right text-lg outline-none appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
      }
    )
  ] }),
  o && i ? /* @__PURE__ */ b("div", { className: "flex w-full flex-row content-center items-center justify-between text-sm text-accent-secondary", children: [
    /* @__PURE__ */ b("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ l(
        "button",
        {
          type: "button",
          onClick: m,
          disabled: p || !m,
          className: "cursor-pointer rounded bg-secondary-strokeLight px-2 py-0.5 text-xs text-accent-secondary transition-all hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50",
          children: "Max"
        }
      ),
      /* @__PURE__ */ b("span", { children: [
        typeof o.balance == "number" ? o.balance.toLocaleString("en-US", {
          minimumFractionDigits: o.decimals ?? 8,
          maximumFractionDigits: o.decimals ?? 8
        }) : o.balance,
        " ",
        o.symbol
      ] })
    ] }),
    o.displayUSD && o.price !== void 0 && /* @__PURE__ */ b("div", { children: [
      f,
      " USD"
    ] })
  ] }) : null
] }), Pn = ({ title: e, amount: t, symbol: r, caption: n, className: i }) => /* @__PURE__ */ b(zt, { className: _("bbn-co-staking-amount-item", i), children: [
  /* @__PURE__ */ b("div", { className: "bbn-co-staking-amount-item-header", children: [
    /* @__PURE__ */ l(Z, { variant: "body1", children: e }),
    /* @__PURE__ */ b(Z, { variant: "body1", children: [
      t,
      " ",
      r
    ] })
  ] }),
  /* @__PURE__ */ l(Z, { variant: "caption", className: "bbn-co-staking-amount-item-caption", children: n })
] }), gs = ({
  value: e,
  symbols: t = 8,
  size: r = "body2",
  className: n
}) => e ? /* @__PURE__ */ l(Z, { variant: r, className: _("text-accent-primary", n), children: /* @__PURE__ */ l("span", { children: ds(e, t) ?? e }) }) : null;
function Oc({ children: e, className: t, iconClassName: r, messageClassName: n }) {
  return /* @__PURE__ */ b("div", { className: _("bbn-warning", t), children: [
    /* @__PURE__ */ l(
      Yl,
      {
        variant: "secondary",
        size: 22,
        className: _("bbn-warning-icon", r)
      }
    ),
    /* @__PURE__ */ l("p", { className: _("bbn-warning-message", n), children: e })
  ] });
}
const br = Math.min, Yt = Math.max, dn = Math.round, on = Math.floor, kt = (e) => ({
  x: e,
  y: e
}), _c = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Vc = {
  start: "end",
  end: "start"
};
function Qn(e, t, r) {
  return Yt(e, br(t, r));
}
function Yr(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function er(e) {
  return e.split("-")[0];
}
function Gr(e) {
  return e.split("-")[1];
}
function bs(e) {
  return e === "x" ? "y" : "x";
}
function Ni(e) {
  return e === "y" ? "height" : "width";
}
const Tc = /* @__PURE__ */ new Set(["top", "bottom"]);
function It(e) {
  return Tc.has(er(e)) ? "y" : "x";
}
function ki(e) {
  return bs(It(e));
}
function Mc(e, t, r) {
  r === void 0 && (r = !1);
  const n = Gr(e), i = ki(e), o = Ni(i);
  let s = i === "x" ? n === (r ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[o] > t.floating[o] && (s = fn(s)), [s, fn(s)];
}
function Dc(e) {
  const t = fn(e);
  return [ei(e), t, ei(t)];
}
function ei(e) {
  return e.replace(/start|end/g, (t) => Vc[t]);
}
const no = ["left", "right"], io = ["right", "left"], Rc = ["top", "bottom"], Bc = ["bottom", "top"];
function Fc(e, t, r) {
  switch (e) {
    case "top":
    case "bottom":
      return r ? t ? io : no : t ? no : io;
    case "left":
    case "right":
      return t ? Rc : Bc;
    default:
      return [];
  }
}
function Hc(e, t, r, n) {
  const i = Gr(e);
  let o = Fc(er(e), r === "start", n);
  return i && (o = o.map((s) => s + "-" + i), t && (o = o.concat(o.map(ei)))), o;
}
function fn(e) {
  return e.replace(/left|right|bottom|top/g, (t) => _c[t]);
}
function Ic(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function ys(e) {
  return typeof e != "number" ? Ic(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function hn(e) {
  const {
    x: t,
    y: r,
    width: n,
    height: i
  } = e;
  return {
    width: n,
    height: i,
    top: r,
    left: t,
    right: t + n,
    bottom: r + i,
    x: t,
    y: r
  };
}
function oo(e, t, r) {
  let {
    reference: n,
    floating: i
  } = e;
  const o = It(t), s = ki(t), a = Ni(s), c = er(t), d = o === "y", u = n.x + n.width / 2 - i.width / 2, f = n.y + n.height / 2 - i.height / 2, p = n[a] / 2 - i[a] / 2;
  let h;
  switch (c) {
    case "top":
      h = {
        x: u,
        y: n.y - i.height
      };
      break;
    case "bottom":
      h = {
        x: u,
        y: n.y + n.height
      };
      break;
    case "right":
      h = {
        x: n.x + n.width,
        y: f
      };
      break;
    case "left":
      h = {
        x: n.x - i.width,
        y: f
      };
      break;
    default:
      h = {
        x: n.x,
        y: n.y
      };
  }
  switch (Gr(t)) {
    case "start":
      h[s] -= p * (r && d ? -1 : 1);
      break;
    case "end":
      h[s] += p * (r && d ? -1 : 1);
      break;
  }
  return h;
}
const $c = async (e, t, r) => {
  const {
    placement: n = "bottom",
    strategy: i = "absolute",
    middleware: o = [],
    platform: s
  } = r, a = o.filter(Boolean), c = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let d = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: u,
    y: f
  } = oo(d, n, c), p = n, h = {}, m = 0;
  for (let g = 0; g < a.length; g++) {
    const {
      name: y,
      fn: A
    } = a[g], {
      x: w,
      y: L,
      data: N,
      reset: k
    } = await A({
      x: u,
      y: f,
      initialPlacement: n,
      placement: p,
      strategy: i,
      middlewareData: h,
      rects: d,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = w ?? u, f = L ?? f, h = {
      ...h,
      [y]: {
        ...h[y],
        ...N
      }
    }, k && m <= 50 && (m++, typeof k == "object" && (k.placement && (p = k.placement), k.rects && (d = k.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }) : k.rects), {
      x: u,
      y: f
    } = oo(d, p, c)), g = -1);
  }
  return {
    x: u,
    y: f,
    placement: p,
    strategy: i,
    middlewareData: h
  };
};
async function ws(e, t) {
  var r;
  t === void 0 && (t = {});
  const {
    x: n,
    y: i,
    platform: o,
    rects: s,
    elements: a,
    strategy: c
  } = e, {
    boundary: d = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: f = "floating",
    altBoundary: p = !1,
    padding: h = 0
  } = Yr(t, e), m = ys(h), y = a[p ? f === "floating" ? "reference" : "floating" : f], A = hn(await o.getClippingRect({
    element: (r = await (o.isElement == null ? void 0 : o.isElement(y))) == null || r ? y : y.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(a.floating)),
    boundary: d,
    rootBoundary: u,
    strategy: c
  })), w = f === "floating" ? {
    x: n,
    y: i,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, L = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(a.floating)), N = await (o.isElement == null ? void 0 : o.isElement(L)) ? await (o.getScale == null ? void 0 : o.getScale(L)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, k = hn(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: w,
    offsetParent: L,
    strategy: c
  }) : w);
  return {
    top: (A.top - k.top + m.top) / N.y,
    bottom: (k.bottom - A.bottom + m.bottom) / N.y,
    left: (A.left - k.left + m.left) / N.x,
    right: (k.right - A.right + m.right) / N.x
  };
}
const Pc = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: r,
      y: n,
      placement: i,
      rects: o,
      platform: s,
      elements: a,
      middlewareData: c
    } = t, {
      element: d,
      padding: u = 0
    } = Yr(e, t) || {};
    if (d == null)
      return {};
    const f = ys(u), p = {
      x: r,
      y: n
    }, h = ki(i), m = Ni(h), g = await s.getDimensions(d), y = h === "y", A = y ? "top" : "left", w = y ? "bottom" : "right", L = y ? "clientHeight" : "clientWidth", N = o.reference[m] + o.reference[h] - p[h] - o.floating[m], k = p[h] - o.reference[h], S = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(d));
    let E = S ? S[L] : 0;
    (!E || !await (s.isElement == null ? void 0 : s.isElement(S))) && (E = a.floating[L] || o.floating[m]);
    const V = N / 2 - k / 2, I = E / 2 - g[m] / 2 - 1, H = br(f[A], I), W = br(f[w], I), O = H, T = E - g[m] - W, $ = E / 2 - g[m] / 2 + V, X = Qn(O, $, T), K = !c.arrow && Gr(i) != null && $ !== X && o.reference[m] / 2 - ($ < O ? H : W) - g[m] / 2 < 0, U = K ? $ < O ? $ - O : $ - T : 0;
    return {
      [h]: p[h] + U,
      data: {
        [h]: X,
        centerOffset: $ - X - U,
        ...K && {
          alignmentOffset: U
        }
      },
      reset: K
    };
  }
}), jc = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: i,
        middlewareData: o,
        rects: s,
        initialPlacement: a,
        platform: c,
        elements: d
      } = t, {
        mainAxis: u = !0,
        crossAxis: f = !0,
        fallbackPlacements: p,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: g = !0,
        ...y
      } = Yr(e, t);
      if ((r = o.arrow) != null && r.alignmentOffset)
        return {};
      const A = er(i), w = It(a), L = er(a) === a, N = await (c.isRTL == null ? void 0 : c.isRTL(d.floating)), k = p || (L || !g ? [fn(a)] : Dc(a)), S = m !== "none";
      !p && S && k.push(...Hc(a, g, m, N));
      const E = [a, ...k], V = await ws(t, y), I = [];
      let H = ((n = o.flip) == null ? void 0 : n.overflows) || [];
      if (u && I.push(V[A]), f) {
        const $ = Mc(i, s, N);
        I.push(V[$[0]], V[$[1]]);
      }
      if (H = [...H, {
        placement: i,
        overflows: I
      }], !I.every(($) => $ <= 0)) {
        var W, O;
        const $ = (((W = o.flip) == null ? void 0 : W.index) || 0) + 1, X = E[$];
        if (X && (!(f === "alignment" ? w !== It(X) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        H.every((te) => It(te.placement) === w ? te.overflows[0] > 0 : !0)))
          return {
            data: {
              index: $,
              overflows: H
            },
            reset: {
              placement: X
            }
          };
        let K = (O = H.filter((U) => U.overflows[0] <= 0).sort((U, te) => U.overflows[1] - te.overflows[1])[0]) == null ? void 0 : O.placement;
        if (!K)
          switch (h) {
            case "bestFit": {
              var T;
              const U = (T = H.filter((te) => {
                if (S) {
                  const ie = It(te.placement);
                  return ie === w || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  ie === "y";
                }
                return !0;
              }).map((te) => [te.placement, te.overflows.filter((ie) => ie > 0).reduce((ie, oe) => ie + oe, 0)]).sort((te, ie) => te[1] - ie[1])[0]) == null ? void 0 : T[0];
              U && (K = U);
              break;
            }
            case "initialPlacement":
              K = a;
              break;
          }
        if (i !== K)
          return {
            reset: {
              placement: K
            }
          };
      }
      return {};
    }
  };
}, zc = /* @__PURE__ */ new Set(["left", "top"]);
async function Wc(e, t) {
  const {
    placement: r,
    platform: n,
    elements: i
  } = e, o = await (n.isRTL == null ? void 0 : n.isRTL(i.floating)), s = er(r), a = Gr(r), c = It(r) === "y", d = zc.has(s) ? -1 : 1, u = o && c ? -1 : 1, f = Yr(t, e);
  let {
    mainAxis: p,
    crossAxis: h,
    alignmentAxis: m
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return a && typeof m == "number" && (h = a === "end" ? m * -1 : m), c ? {
    x: h * u,
    y: p * d
  } : {
    x: p * d,
    y: h * u
  };
}
const Uc = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var r, n;
      const {
        x: i,
        y: o,
        placement: s,
        middlewareData: a
      } = t, c = await Wc(t, e);
      return s === ((r = a.offset) == null ? void 0 : r.placement) && (n = a.arrow) != null && n.alignmentOffset ? {} : {
        x: i + c.x,
        y: o + c.y,
        data: {
          ...c,
          placement: s
        }
      };
    }
  };
}, Zc = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: n,
        placement: i
      } = t, {
        mainAxis: o = !0,
        crossAxis: s = !1,
        limiter: a = {
          fn: (y) => {
            let {
              x: A,
              y: w
            } = y;
            return {
              x: A,
              y: w
            };
          }
        },
        ...c
      } = Yr(e, t), d = {
        x: r,
        y: n
      }, u = await ws(t, c), f = It(er(i)), p = bs(f);
      let h = d[p], m = d[f];
      if (o) {
        const y = p === "y" ? "top" : "left", A = p === "y" ? "bottom" : "right", w = h + u[y], L = h - u[A];
        h = Qn(w, h, L);
      }
      if (s) {
        const y = f === "y" ? "top" : "left", A = f === "y" ? "bottom" : "right", w = m + u[y], L = m - u[A];
        m = Qn(w, m, L);
      }
      const g = a.fn({
        ...t,
        [p]: h,
        [f]: m
      });
      return {
        ...g,
        data: {
          x: g.x - r,
          y: g.y - n,
          enabled: {
            [p]: o,
            [f]: s
          }
        }
      };
    }
  };
};
function Tn() {
  return typeof window < "u";
}
function xr(e) {
  return xs(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function tt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Ot(e) {
  var t;
  return (t = (xs(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function xs(e) {
  return Tn() ? e instanceof Node || e instanceof tt(e).Node : !1;
}
function mt(e) {
  return Tn() ? e instanceof Element || e instanceof tt(e).Element : !1;
}
function At(e) {
  return Tn() ? e instanceof HTMLElement || e instanceof tt(e).HTMLElement : !1;
}
function so(e) {
  return !Tn() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof tt(e).ShadowRoot;
}
const qc = /* @__PURE__ */ new Set(["inline", "contents"]);
function Jr(e) {
  const {
    overflow: t,
    overflowX: r,
    overflowY: n,
    display: i
  } = pt(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + r) && !qc.has(i);
}
const Xc = /* @__PURE__ */ new Set(["table", "td", "th"]);
function Kc(e) {
  return Xc.has(xr(e));
}
const Yc = [":popover-open", ":modal"];
function Mn(e) {
  return Yc.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const Gc = ["transform", "translate", "scale", "rotate", "perspective"], Jc = ["transform", "translate", "scale", "rotate", "perspective", "filter"], Qc = ["paint", "layout", "strict", "content"];
function Si(e) {
  const t = Li(), r = mt(e) ? pt(e) : e;
  return Gc.some((n) => r[n] ? r[n] !== "none" : !1) || (r.containerType ? r.containerType !== "normal" : !1) || !t && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !t && (r.filter ? r.filter !== "none" : !1) || Jc.some((n) => (r.willChange || "").includes(n)) || Qc.some((n) => (r.contain || "").includes(n));
}
function e1(e) {
  let t = $t(e);
  for (; At(t) && !yr(t); ) {
    if (Si(t))
      return t;
    if (Mn(t))
      return null;
    t = $t(t);
  }
  return null;
}
function Li() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const t1 = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function yr(e) {
  return t1.has(xr(e));
}
function pt(e) {
  return tt(e).getComputedStyle(e);
}
function Dn(e) {
  return mt(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function $t(e) {
  if (xr(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    so(e) && e.host || // Fallback.
    Ot(e)
  );
  return so(t) ? t.host : t;
}
function Cs(e) {
  const t = $t(e);
  return yr(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : At(t) && Jr(t) ? t : Cs(t);
}
function $r(e, t, r) {
  var n;
  t === void 0 && (t = []), r === void 0 && (r = !0);
  const i = Cs(e), o = i === ((n = e.ownerDocument) == null ? void 0 : n.body), s = tt(i);
  if (o) {
    const a = ti(s);
    return t.concat(s, s.visualViewport || [], Jr(i) ? i : [], a && r ? $r(a) : []);
  }
  return t.concat(i, $r(i, [], r));
}
function ti(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Ns(e) {
  const t = pt(e);
  let r = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
  const i = At(e), o = i ? e.offsetWidth : r, s = i ? e.offsetHeight : n, a = dn(r) !== o || dn(n) !== s;
  return a && (r = o, n = s), {
    width: r,
    height: n,
    $: a
  };
}
function Ai(e) {
  return mt(e) ? e : e.contextElement;
}
function hr(e) {
  const t = Ai(e);
  if (!At(t))
    return kt(1);
  const r = t.getBoundingClientRect(), {
    width: n,
    height: i,
    $: o
  } = Ns(t);
  let s = (o ? dn(r.width) : r.width) / n, a = (o ? dn(r.height) : r.height) / i;
  return (!s || !Number.isFinite(s)) && (s = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: s,
    y: a
  };
}
const r1 = /* @__PURE__ */ kt(0);
function ks(e) {
  const t = tt(e);
  return !Li() || !t.visualViewport ? r1 : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function n1(e, t, r) {
  return t === void 0 && (t = !1), !r || t && r !== tt(e) ? !1 : t;
}
function tr(e, t, r, n) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  const i = e.getBoundingClientRect(), o = Ai(e);
  let s = kt(1);
  t && (n ? mt(n) && (s = hr(n)) : s = hr(e));
  const a = n1(o, r, n) ? ks(o) : kt(0);
  let c = (i.left + a.x) / s.x, d = (i.top + a.y) / s.y, u = i.width / s.x, f = i.height / s.y;
  if (o) {
    const p = tt(o), h = n && mt(n) ? tt(n) : n;
    let m = p, g = ti(m);
    for (; g && n && h !== m; ) {
      const y = hr(g), A = g.getBoundingClientRect(), w = pt(g), L = A.left + (g.clientLeft + parseFloat(w.paddingLeft)) * y.x, N = A.top + (g.clientTop + parseFloat(w.paddingTop)) * y.y;
      c *= y.x, d *= y.y, u *= y.x, f *= y.y, c += L, d += N, m = tt(g), g = ti(m);
    }
  }
  return hn({
    width: u,
    height: f,
    x: c,
    y: d
  });
}
function Rn(e, t) {
  const r = Dn(e).scrollLeft;
  return t ? t.left + r : tr(Ot(e)).left + r;
}
function Ss(e, t) {
  const r = e.getBoundingClientRect(), n = r.left + t.scrollLeft - Rn(e, r), i = r.top + t.scrollTop;
  return {
    x: n,
    y: i
  };
}
function i1(e) {
  let {
    elements: t,
    rect: r,
    offsetParent: n,
    strategy: i
  } = e;
  const o = i === "fixed", s = Ot(n), a = t ? Mn(t.floating) : !1;
  if (n === s || a && o)
    return r;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, d = kt(1);
  const u = kt(0), f = At(n);
  if ((f || !f && !o) && ((xr(n) !== "body" || Jr(s)) && (c = Dn(n)), At(n))) {
    const h = tr(n);
    d = hr(n), u.x = h.x + n.clientLeft, u.y = h.y + n.clientTop;
  }
  const p = s && !f && !o ? Ss(s, c) : kt(0);
  return {
    width: r.width * d.x,
    height: r.height * d.y,
    x: r.x * d.x - c.scrollLeft * d.x + u.x + p.x,
    y: r.y * d.y - c.scrollTop * d.y + u.y + p.y
  };
}
function o1(e) {
  return Array.from(e.getClientRects());
}
function s1(e) {
  const t = Ot(e), r = Dn(e), n = e.ownerDocument.body, i = Yt(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), o = Yt(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let s = -r.scrollLeft + Rn(e);
  const a = -r.scrollTop;
  return pt(n).direction === "rtl" && (s += Yt(t.clientWidth, n.clientWidth) - i), {
    width: i,
    height: o,
    x: s,
    y: a
  };
}
const ao = 25;
function a1(e, t) {
  const r = tt(e), n = Ot(e), i = r.visualViewport;
  let o = n.clientWidth, s = n.clientHeight, a = 0, c = 0;
  if (i) {
    o = i.width, s = i.height;
    const u = Li();
    (!u || u && t === "fixed") && (a = i.offsetLeft, c = i.offsetTop);
  }
  const d = Rn(n);
  if (d <= 0) {
    const u = n.ownerDocument, f = u.body, p = getComputedStyle(f), h = u.compatMode === "CSS1Compat" && parseFloat(p.marginLeft) + parseFloat(p.marginRight) || 0, m = Math.abs(n.clientWidth - f.clientWidth - h);
    m <= ao && (o -= m);
  } else d <= ao && (o += d);
  return {
    width: o,
    height: s,
    x: a,
    y: c
  };
}
const l1 = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function c1(e, t) {
  const r = tr(e, !0, t === "fixed"), n = r.top + e.clientTop, i = r.left + e.clientLeft, o = At(e) ? hr(e) : kt(1), s = e.clientWidth * o.x, a = e.clientHeight * o.y, c = i * o.x, d = n * o.y;
  return {
    width: s,
    height: a,
    x: c,
    y: d
  };
}
function lo(e, t, r) {
  let n;
  if (t === "viewport")
    n = a1(e, r);
  else if (t === "document")
    n = s1(Ot(e));
  else if (mt(t))
    n = c1(t, r);
  else {
    const i = ks(e);
    n = {
      x: t.x - i.x,
      y: t.y - i.y,
      width: t.width,
      height: t.height
    };
  }
  return hn(n);
}
function Ls(e, t) {
  const r = $t(e);
  return r === t || !mt(r) || yr(r) ? !1 : pt(r).position === "fixed" || Ls(r, t);
}
function u1(e, t) {
  const r = t.get(e);
  if (r)
    return r;
  let n = $r(e, [], !1).filter((a) => mt(a) && xr(a) !== "body"), i = null;
  const o = pt(e).position === "fixed";
  let s = o ? $t(e) : e;
  for (; mt(s) && !yr(s); ) {
    const a = pt(s), c = Si(s);
    !c && a.position === "fixed" && (i = null), (o ? !c && !i : !c && a.position === "static" && !!i && l1.has(i.position) || Jr(s) && !c && Ls(e, s)) ? n = n.filter((u) => u !== s) : i = a, s = $t(s);
  }
  return t.set(e, n), n;
}
function d1(e) {
  let {
    element: t,
    boundary: r,
    rootBoundary: n,
    strategy: i
  } = e;
  const s = [...r === "clippingAncestors" ? Mn(t) ? [] : u1(t, this._c) : [].concat(r), n], a = s[0], c = s.reduce((d, u) => {
    const f = lo(t, u, i);
    return d.top = Yt(f.top, d.top), d.right = br(f.right, d.right), d.bottom = br(f.bottom, d.bottom), d.left = Yt(f.left, d.left), d;
  }, lo(t, a, i));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function f1(e) {
  const {
    width: t,
    height: r
  } = Ns(e);
  return {
    width: t,
    height: r
  };
}
function h1(e, t, r) {
  const n = At(t), i = Ot(t), o = r === "fixed", s = tr(e, !0, o, t);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = kt(0);
  function d() {
    c.x = Rn(i);
  }
  if (n || !n && !o)
    if ((xr(t) !== "body" || Jr(i)) && (a = Dn(t)), n) {
      const h = tr(t, !0, o, t);
      c.x = h.x + t.clientLeft, c.y = h.y + t.clientTop;
    } else i && d();
  o && !n && i && d();
  const u = i && !n && !o ? Ss(i, a) : kt(0), f = s.left + a.scrollLeft - c.x - u.x, p = s.top + a.scrollTop - c.y - u.y;
  return {
    x: f,
    y: p,
    width: s.width,
    height: s.height
  };
}
function jn(e) {
  return pt(e).position === "static";
}
function co(e, t) {
  if (!At(e) || pt(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let r = e.offsetParent;
  return Ot(e) === r && (r = r.ownerDocument.body), r;
}
function As(e, t) {
  const r = tt(e);
  if (Mn(e))
    return r;
  if (!At(e)) {
    let i = $t(e);
    for (; i && !yr(i); ) {
      if (mt(i) && !jn(i))
        return i;
      i = $t(i);
    }
    return r;
  }
  let n = co(e, t);
  for (; n && Kc(n) && jn(n); )
    n = co(n, t);
  return n && yr(n) && jn(n) && !Si(n) ? r : n || e1(e) || r;
}
const m1 = async function(e) {
  const t = this.getOffsetParent || As, r = this.getDimensions, n = await r(e.floating);
  return {
    reference: h1(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function p1(e) {
  return pt(e).direction === "rtl";
}
const v1 = {
  convertOffsetParentRelativeRectToViewportRelativeRect: i1,
  getDocumentElement: Ot,
  getClippingRect: d1,
  getOffsetParent: As,
  getElementRects: m1,
  getClientRects: o1,
  getDimensions: f1,
  getScale: hr,
  isElement: mt,
  isRTL: p1
};
function Es(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function g1(e, t) {
  let r = null, n;
  const i = Ot(e);
  function o() {
    var a;
    clearTimeout(n), (a = r) == null || a.disconnect(), r = null;
  }
  function s(a, c) {
    a === void 0 && (a = !1), c === void 0 && (c = 1), o();
    const d = e.getBoundingClientRect(), {
      left: u,
      top: f,
      width: p,
      height: h
    } = d;
    if (a || t(), !p || !h)
      return;
    const m = on(f), g = on(i.clientWidth - (u + p)), y = on(i.clientHeight - (f + h)), A = on(u), L = {
      rootMargin: -m + "px " + -g + "px " + -y + "px " + -A + "px",
      threshold: Yt(0, br(1, c)) || 1
    };
    let N = !0;
    function k(S) {
      const E = S[0].intersectionRatio;
      if (E !== c) {
        if (!N)
          return s();
        E ? s(!1, E) : n = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      E === 1 && !Es(d, e.getBoundingClientRect()) && s(), N = !1;
    }
    try {
      r = new IntersectionObserver(k, {
        ...L,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(k, L);
    }
    r.observe(e);
  }
  return s(!0), o;
}
function b1(e, t, r, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: o = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = n, d = Ai(e), u = i || o ? [...d ? $r(d) : [], ...$r(t)] : [];
  u.forEach((A) => {
    i && A.addEventListener("scroll", r, {
      passive: !0
    }), o && A.addEventListener("resize", r);
  });
  const f = d && a ? g1(d, r) : null;
  let p = -1, h = null;
  s && (h = new ResizeObserver((A) => {
    let [w] = A;
    w && w.target === d && h && (h.unobserve(t), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var L;
      (L = h) == null || L.observe(t);
    })), r();
  }), d && !c && h.observe(d), h.observe(t));
  let m, g = c ? tr(e) : null;
  c && y();
  function y() {
    const A = tr(e);
    g && !Es(g, A) && r(), g = A, m = requestAnimationFrame(y);
  }
  return r(), () => {
    var A;
    u.forEach((w) => {
      i && w.removeEventListener("scroll", r), o && w.removeEventListener("resize", r);
    }), f == null || f(), (A = h) == null || A.disconnect(), h = null, c && cancelAnimationFrame(m);
  };
}
const y1 = Uc, w1 = Zc, x1 = jc, C1 = Pc, uo = (e, t, r) => {
  const n = /* @__PURE__ */ new Map(), i = {
    platform: v1,
    ...r
  }, o = {
    ...i.platform,
    _c: n
  };
  return $c(e, t, {
    ...i,
    platform: o
  });
};
var zn = { exports: {} };
var fo;
function N1() {
  return fo || (fo = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function r() {
        for (var o = "", s = 0; s < arguments.length; s++) {
          var a = arguments[s];
          a && (o = i(o, n(a)));
        }
        return o;
      }
      function n(o) {
        if (typeof o == "string" || typeof o == "number")
          return o;
        if (typeof o != "object")
          return "";
        if (Array.isArray(o))
          return r.apply(null, o);
        if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]"))
          return o.toString();
        var s = "";
        for (var a in o)
          t.call(o, a) && o[a] && (s = i(s, a));
        return s;
      }
      function i(o, s) {
        return s ? o ? o + " " + s : o + s : o;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(zn)), zn.exports;
}
var k1 = N1();
const ri = /* @__PURE__ */ bi(k1);
const S1 = "react-tooltip-core-styles", L1 = "react-tooltip-base-styles", ho = { core: !1, base: !1 };
function mo({ css: e, id: t = L1, type: r = "base", ref: n }) {
  var i, o;
  if (!e || typeof document > "u" || ho[r] || r === "core" && typeof process < "u" && (!((i = process == null ? void 0 : process.env) === null || i === void 0) && i.REACT_TOOLTIP_DISABLE_CORE_STYLES) || r !== "base" && typeof process < "u" && (!((o = process == null ? void 0 : process.env) === null || o === void 0) && o.REACT_TOOLTIP_DISABLE_BASE_STYLES)) return;
  r === "core" && (t = S1), n || (n = {});
  const { insertAt: s } = n;
  if (document.getElementById(t)) return;
  const a = document.head || document.getElementsByTagName("head")[0], c = document.createElement("style");
  c.id = t, c.type = "text/css", s === "top" && a.firstChild ? a.insertBefore(c, a.firstChild) : a.appendChild(c), c.styleSheet ? c.styleSheet.cssText = e : c.appendChild(document.createTextNode(e)), ho[r] = !0;
}
const po = async ({ elementReference: e = null, tooltipReference: t = null, tooltipArrowReference: r = null, place: n = "top", offset: i = 10, strategy: o = "absolute", middlewares: s = [y1(Number(i)), x1({ fallbackAxisSideDirection: "start" }), w1({ padding: 5 })], border: a, arrowSize: c = 8 }) => {
  if (!e) return { tooltipStyles: {}, tooltipArrowStyles: {}, place: n };
  if (t === null) return { tooltipStyles: {}, tooltipArrowStyles: {}, place: n };
  const d = s;
  return r ? (d.push(C1({ element: r, padding: 5 })), uo(e, t, { placement: n, strategy: o, middleware: d }).then(({ x: u, y: f, placement: p, middlewareData: h }) => {
    var m, g;
    const y = { left: `${u}px`, top: `${f}px`, border: a }, { x: A, y: w } = (m = h.arrow) !== null && m !== void 0 ? m : { x: 0, y: 0 }, L = (g = { top: "bottom", right: "left", bottom: "top", left: "right" }[p.split("-")[0]]) !== null && g !== void 0 ? g : "bottom", N = a && { borderBottom: a, borderRight: a };
    let k = 0;
    if (a) {
      const S = `${a}`.match(/(\d+)px/);
      k = S != null && S[1] ? Number(S[1]) : 1;
    }
    return { tooltipStyles: y, tooltipArrowStyles: { left: A != null ? `${A}px` : "", top: w != null ? `${w}px` : "", right: "", bottom: "", ...N, [L]: `-${c / 2 + k}px` }, place: p };
  })) : uo(e, t, { placement: "bottom", strategy: o, middleware: d }).then(({ x: u, y: f, placement: p }) => ({ tooltipStyles: { left: `${u}px`, top: `${f}px` }, tooltipArrowStyles: {}, place: p }));
}, vo = (e, t) => !("CSS" in window && "supports" in window.CSS) || window.CSS.supports(e, t), go = (e, t, r) => {
  let n = null;
  const i = function(...o) {
    const s = () => {
      n = null;
    };
    !n && (e.apply(this, o), n = setTimeout(s, t));
  };
  return i.cancel = () => {
    n && (clearTimeout(n), n = null);
  }, i;
}, bo = (e) => e !== null && !Array.isArray(e) && typeof e == "object", ni = (e, t) => {
  if (e === t) return !0;
  if (Array.isArray(e) && Array.isArray(t)) return e.length === t.length && e.every((i, o) => ni(i, t[o]));
  if (Array.isArray(e) !== Array.isArray(t)) return !1;
  if (!bo(e) || !bo(t)) return e === t;
  const r = Object.keys(e), n = Object.keys(t);
  return r.length === n.length && r.every((i) => ni(e[i], t[i]));
}, A1 = (e) => {
  if (!(e instanceof HTMLElement || e instanceof SVGElement)) return !1;
  const t = getComputedStyle(e);
  return ["overflow", "overflow-x", "overflow-y"].some((r) => {
    const n = t.getPropertyValue(r);
    return n === "auto" || n === "scroll";
  });
}, yo = (e) => {
  if (!e) return null;
  let t = e.parentElement;
  for (; t; ) {
    if (A1(t)) return t;
    t = t.parentElement;
  }
  return document.scrollingElement || document.documentElement;
}, E1 = typeof window < "u" ? da : J, at = (e) => {
  e.current && (clearTimeout(e.current), e.current = null);
}, O1 = "DEFAULT_TOOLTIP_ID", _1 = { anchorRefs: /* @__PURE__ */ new Set(), activeAnchor: { current: null }, attach: () => {
}, detach: () => {
}, setActiveAnchor: () => {
} }, V1 = wr({ getTooltipData: () => _1 });
function Os(e = O1) {
  return nr(V1).getTooltipData(e);
}
var dr = { tooltip: "core-styles-module_tooltip__3vRRp", fixed: "core-styles-module_fixed__pcSol", arrow: "core-styles-module_arrow__cvMwQ", noArrow: "core-styles-module_noArrow__xock6", clickable: "core-styles-module_clickable__ZuTTB", show: "core-styles-module_show__Nt9eE", closing: "core-styles-module_closing__sGnxF" }, Wn = { tooltip: "styles-module_tooltip__mnnfp", arrow: "styles-module_arrow__K0L3T", dark: "styles-module_dark__xNqje", light: "styles-module_light__Z6W-X", success: "styles-module_success__A2AKt", warning: "styles-module_warning__SCK0X", error: "styles-module_error__JvumD", info: "styles-module_info__BWdHW" };
const T1 = ({ forwardRef: e, id: t, className: r, classNameArrow: n, variant: i = "dark", anchorId: o, anchorSelect: s, place: a = "top", offset: c = 10, events: d = ["hover"], openOnClick: u = !1, positionStrategy: f = "absolute", middlewares: p, wrapper: h, delayShow: m = 0, delayHide: g = 0, float: y = !1, hidden: A = !1, noArrow: w = !1, clickable: L = !1, closeOnEsc: N = !1, closeOnScroll: k = !1, closeOnResize: S = !1, openEvents: E, closeEvents: V, globalCloseEvents: I, imperativeModeOnly: H, style: W, position: O, afterShow: T, afterHide: $, disableTooltip: X, content: K, contentWrapperRef: U, isOpen: te, defaultIsOpen: ie = !1, setIsOpen: oe, activeAnchor: se, setActiveAnchor: pe, border: de, opacity: Se, arrowColor: Oe, arrowSize: xe = 8, role: Fe = "tooltip" }) => {
  var F;
  const re = Ae(null), De = Ae(null), Ce = Ae(null), it = Ae(null), ft = Ae(null), [Ye, or] = G({ tooltipStyles: {}, tooltipArrowStyles: {}, place: a }), [He, Rt] = G(!1), [v, x] = G(!1), [C, R] = G(null), D = Ae(!1), M = Ae(null), { anchorRefs: z, setActiveAnchor: ee } = Os(t), he = Ae(!1), [ce, Ie] = G([]), _t = Ae(!1), vt = u || d.includes("click"), Wt = vt || (E == null ? void 0 : E.click) || (E == null ? void 0 : E.dblclick) || (E == null ? void 0 : E.mousedown), Bt = E ? { ...E } : { mouseover: !0, focus: !0, mouseenter: !1, click: !1, dblclick: !1, mousedown: !1 };
  !E && vt && Object.assign(Bt, { mouseenter: !1, focus: !1, mouseover: !1, click: !0 });
  const gt = V ? { ...V } : { mouseout: !0, blur: !0, mouseleave: !1, click: !1, dblclick: !1, mouseup: !1 };
  !V && vt && Object.assign(gt, { mouseleave: !1, blur: !1, mouseout: !1 });
  const Ge = I ? { ...I } : { escape: N || !1, scroll: k || !1, resize: S || !1, clickOutsideAnchor: Wt || !1 };
  H && (Object.assign(Bt, { mouseover: !1, focus: !1, mouseenter: !1, click: !1, dblclick: !1, mousedown: !1 }), Object.assign(gt, { mouseout: !1, blur: !1, mouseleave: !1, click: !1, dblclick: !1, mouseup: !1 }), Object.assign(Ge, { escape: !1, scroll: !1, resize: !1, clickOutsideAnchor: !1 })), E1(() => (_t.current = !0, () => {
    _t.current = !1;
  }), []);
  const Ne = (P) => {
    _t.current && (P && x(!0), setTimeout(() => {
      _t.current && (oe == null || oe(P), te === void 0 && Rt(P));
    }, 10));
  };
  J(() => {
    if (te === void 0) return () => null;
    te && x(!0);
    const P = setTimeout(() => {
      Rt(te);
    }, 10);
    return () => {
      clearTimeout(P);
    };
  }, [te]), J(() => {
    if (He !== D.current) if (at(ft), D.current = He, He) T == null || T();
    else {
      const P = ((Q) => {
        const ne = Q.match(/^([\d.]+)(ms|s)$/);
        if (!ne) return 0;
        const [, _e, $e] = ne;
        return Number(_e) * ($e === "ms" ? 1 : 1e3);
      })(getComputedStyle(document.body).getPropertyValue("--rt-transition-show-delay"));
      ft.current = setTimeout(() => {
        x(!1), R(null), $ == null || $();
      }, P + 25);
    }
  }, [He]);
  const en = (P) => {
    or((Q) => ni(Q, P) ? Q : P);
  }, Lr = (P = m) => {
    at(Ce), v ? Ne(!0) : Ce.current = setTimeout(() => {
      Ne(!0);
    }, P);
  }, sr = (P = g) => {
    at(it), it.current = setTimeout(() => {
      he.current || Ne(!1);
    }, P);
  }, Ar = (P) => {
    var Q;
    if (!P) return;
    const ne = (Q = P.currentTarget) !== null && Q !== void 0 ? Q : P.target;
    if (!(ne != null && ne.isConnected)) return pe(null), void ee({ current: null });
    m ? Lr() : Ne(!0), pe(ne), ee({ current: ne }), at(it);
  }, ar = () => {
    L ? sr(g || 100) : g ? sr() : Ne(!1), at(Ce);
  }, lr = ({ x: P, y: Q }) => {
    var ne;
    const _e = { getBoundingClientRect: () => ({ x: P, y: Q, width: 0, height: 0, top: Q, left: P, right: P, bottom: Q }) };
    po({ place: (ne = C == null ? void 0 : C.place) !== null && ne !== void 0 ? ne : a, offset: c, elementReference: _e, tooltipReference: re.current, tooltipArrowReference: De.current, strategy: f, middlewares: p, border: de, arrowSize: xe }).then(($e) => {
      en($e);
    });
  }, cr = (P) => {
    if (!P) return;
    const Q = P, ne = { x: Q.clientX, y: Q.clientY };
    lr(ne), M.current = ne;
  }, Er = (P) => {
    var Q;
    if (!He) return;
    const ne = P.target;
    ne.isConnected && (!((Q = re.current) === null || Q === void 0) && Q.contains(ne) || [document.querySelector(`[id='${o}']`), ...ce].some((_e) => _e == null ? void 0 : _e.contains(ne)) || (Ne(!1), at(Ce)));
  }, tn = go(Ar, 50), Re = go(ar, 50), ot = (P) => {
    Re.cancel(), tn(P);
  }, Y = () => {
    tn.cancel(), Re();
  }, ae = ge(() => {
    var P, Q;
    const ne = (P = C == null ? void 0 : C.position) !== null && P !== void 0 ? P : O;
    ne ? lr(ne) : y ? M.current && lr(M.current) : se != null && se.isConnected && po({ place: (Q = C == null ? void 0 : C.place) !== null && Q !== void 0 ? Q : a, offset: c, elementReference: se, tooltipReference: re.current, tooltipArrowReference: De.current, strategy: f, middlewares: p, border: de, arrowSize: xe }).then((_e) => {
      _t.current && en(_e);
    });
  }, [He, se, K, W, a, C == null ? void 0 : C.place, c, f, O, C == null ? void 0 : C.position, y, xe]);
  J(() => {
    var P, Q;
    const ne = new Set(z);
    ce.forEach((fe) => {
      X != null && X(fe) || ne.add({ current: fe });
    });
    const _e = document.querySelector(`[id='${o}']`);
    _e && !(X != null && X(_e)) && ne.add({ current: _e });
    const $e = () => {
      Ne(!1);
    }, bt = yo(se), yt = yo(re.current);
    Ge.scroll && (window.addEventListener("scroll", $e), bt == null || bt.addEventListener("scroll", $e), yt == null || yt.addEventListener("scroll", $e));
    let ze = null;
    Ge.resize ? window.addEventListener("resize", $e) : se && re.current && (ze = b1(se, re.current, ae, { ancestorResize: !0, elementResize: !0, layoutShift: !0 }));
    const st = (fe) => {
      fe.key === "Escape" && Ne(!1);
    };
    Ge.escape && window.addEventListener("keydown", st), Ge.clickOutsideAnchor && window.addEventListener("click", Er);
    const be = [], ur = (fe) => !!(fe != null && fe.target && (se != null && se.contains(fe.target))), la = (fe) => {
      He && ur(fe) || Ar(fe);
    }, ca = (fe) => {
      He && ur(fe) && ar();
    }, Bi = ["mouseover", "mouseout", "mouseenter", "mouseleave", "focus", "blur"], Fi = ["click", "dblclick", "mousedown", "mouseup"];
    Object.entries(Bt).forEach(([fe, Vt]) => {
      Vt && (Bi.includes(fe) ? be.push({ event: fe, listener: ot }) : Fi.includes(fe) && be.push({ event: fe, listener: la }));
    }), Object.entries(gt).forEach(([fe, Vt]) => {
      Vt && (Bi.includes(fe) ? be.push({ event: fe, listener: Y }) : Fi.includes(fe) && be.push({ event: fe, listener: ca }));
    }), y && be.push({ event: "pointermove", listener: cr });
    const Hi = () => {
      he.current = !0;
    }, Ii = () => {
      he.current = !1, ar();
    }, $i = L && (gt.mouseout || gt.mouseleave);
    return $i && ((P = re.current) === null || P === void 0 || P.addEventListener("mouseover", Hi), (Q = re.current) === null || Q === void 0 || Q.addEventListener("mouseout", Ii)), be.forEach(({ event: fe, listener: Vt }) => {
      ne.forEach((Fn) => {
        var Or;
        (Or = Fn.current) === null || Or === void 0 || Or.addEventListener(fe, Vt);
      });
    }), () => {
      var fe, Vt;
      Ge.scroll && (window.removeEventListener("scroll", $e), bt == null || bt.removeEventListener("scroll", $e), yt == null || yt.removeEventListener("scroll", $e)), Ge.resize ? window.removeEventListener("resize", $e) : ze == null || ze(), Ge.clickOutsideAnchor && window.removeEventListener("click", Er), Ge.escape && window.removeEventListener("keydown", st), $i && ((fe = re.current) === null || fe === void 0 || fe.removeEventListener("mouseover", Hi), (Vt = re.current) === null || Vt === void 0 || Vt.removeEventListener("mouseout", Ii)), be.forEach(({ event: Fn, listener: Or }) => {
        ne.forEach((ua) => {
          var Hn;
          (Hn = ua.current) === null || Hn === void 0 || Hn.removeEventListener(Fn, Or);
        });
      });
    };
  }, [se, ae, v, z, ce, E, V, I, vt, m, g]), J(() => {
    var P, Q;
    let ne = (Q = (P = C == null ? void 0 : C.anchorSelect) !== null && P !== void 0 ? P : s) !== null && Q !== void 0 ? Q : "";
    !ne && t && (ne = `[data-tooltip-id='${t.replace(/'/g, "\\'")}']`);
    const _e = new MutationObserver(($e) => {
      const bt = [], yt = [];
      $e.forEach((ze) => {
        if (ze.type === "attributes" && ze.attributeName === "data-tooltip-id" && (ze.target.getAttribute("data-tooltip-id") === t ? bt.push(ze.target) : ze.oldValue === t && yt.push(ze.target)), ze.type === "childList") {
          if (se) {
            const st = [...ze.removedNodes].filter((be) => be.nodeType === 1);
            if (ne) try {
              yt.push(...st.filter((be) => be.matches(ne))), yt.push(...st.flatMap((be) => [...be.querySelectorAll(ne)]));
            } catch {
            }
            st.some((be) => {
              var ur;
              return !!(!((ur = be == null ? void 0 : be.contains) === null || ur === void 0) && ur.call(be, se)) && (x(!1), Ne(!1), pe(null), at(Ce), at(it), !0);
            });
          }
          if (ne) try {
            const st = [...ze.addedNodes].filter((be) => be.nodeType === 1);
            bt.push(...st.filter((be) => be.matches(ne))), bt.push(...st.flatMap((be) => [...be.querySelectorAll(ne)]));
          } catch {
          }
        }
      }), (bt.length || yt.length) && Ie((ze) => [...ze.filter((st) => !yt.includes(st)), ...bt]);
    });
    return _e.observe(document.body, { childList: !0, subtree: !0, attributes: !0, attributeFilter: ["data-tooltip-id"], attributeOldValue: !0 }), () => {
      _e.disconnect();
    };
  }, [t, s, C == null ? void 0 : C.anchorSelect, se]), J(() => {
    ae();
  }, [ae]), J(() => {
    if (!(U != null && U.current)) return () => null;
    const P = new ResizeObserver(() => {
      setTimeout(() => ae());
    });
    return P.observe(U.current), () => {
      P.disconnect();
    };
  }, [K, U == null ? void 0 : U.current]), J(() => {
    var P;
    const Q = document.querySelector(`[id='${o}']`), ne = [...ce, Q];
    se && ne.includes(se) || pe((P = ce[0]) !== null && P !== void 0 ? P : Q);
  }, [o, ce, se]), J(() => (ie && Ne(!0), () => {
    at(Ce), at(it);
  }), []), J(() => {
    var P;
    let Q = (P = C == null ? void 0 : C.anchorSelect) !== null && P !== void 0 ? P : s;
    if (!Q && t && (Q = `[data-tooltip-id='${t.replace(/'/g, "\\'")}']`), Q) try {
      const ne = Array.from(document.querySelectorAll(Q));
      Ie(ne);
    } catch {
      Ie([]);
    }
  }, [t, s, C == null ? void 0 : C.anchorSelect]), J(() => {
    Ce.current && (at(Ce), Lr(m));
  }, [m]);
  const Je = (F = C == null ? void 0 : C.content) !== null && F !== void 0 ? F : K, Ut = He && Object.keys(Ye.tooltipStyles).length > 0;
  return Wr(e, () => ({ open: (P) => {
    if (P != null && P.anchorSelect) try {
      document.querySelector(P.anchorSelect);
    } catch {
      return void console.warn(`[react-tooltip] "${P.anchorSelect}" is not a valid CSS selector`);
    }
    R(P ?? null), P != null && P.delay ? Lr(P.delay) : Ne(!0);
  }, close: (P) => {
    P != null && P.delay ? sr(P.delay) : Ne(!1);
  }, activeAnchor: se, place: Ye.place, isOpen: !!(v && !A && Je && Ut) })), v && !A && Je ? q.createElement(h, { id: t, role: Fe, className: ri("react-tooltip", dr.tooltip, Wn.tooltip, Wn[i], r, `react-tooltip__place-${Ye.place}`, dr[Ut ? "show" : "closing"], Ut ? "react-tooltip__show" : "react-tooltip__closing", f === "fixed" && dr.fixed, L && dr.clickable), onTransitionEnd: (P) => {
    at(ft), He || P.propertyName !== "opacity" || (x(!1), R(null), $ == null || $());
  }, style: { ...W, ...Ye.tooltipStyles, opacity: Se !== void 0 && Ut ? Se : void 0 }, ref: re }, Je, q.createElement(h, { className: ri("react-tooltip-arrow", dr.arrow, Wn.arrow, n, w && dr.noArrow), style: { ...Ye.tooltipArrowStyles, background: Oe ? `linear-gradient(to right bottom, transparent 50%, ${Oe} 50%)` : void 0, "--rt-arrow-size": `${xe}px` }, ref: De })) : null;
}, M1 = ({ content: e }) => q.createElement("span", { dangerouslySetInnerHTML: { __html: e } }), wo = q.forwardRef(({ id: e, anchorId: t, anchorSelect: r, content: n, html: i, render: o, className: s, classNameArrow: a, variant: c = "dark", place: d = "top", offset: u = 10, wrapper: f = "div", children: p = null, events: h = ["hover"], openOnClick: m = !1, positionStrategy: g = "absolute", middlewares: y, delayShow: A = 0, delayHide: w = 0, float: L = !1, hidden: N = !1, noArrow: k = !1, clickable: S = !1, closeOnEsc: E = !1, closeOnScroll: V = !1, closeOnResize: I = !1, openEvents: H, closeEvents: W, globalCloseEvents: O, imperativeModeOnly: T = !1, style: $, position: X, isOpen: K, defaultIsOpen: U = !1, disableStyleInjection: te = !1, border: ie, opacity: oe, arrowColor: se, arrowSize: pe, setIsOpen: de, afterShow: Se, afterHide: Oe, disableTooltip: xe, role: Fe = "tooltip" }, F) => {
  const [re, De] = G(n), [Ce, it] = G(i), [ft, Ye] = G(d), [or, He] = G(c), [Rt, v] = G(u), [x, C] = G(A), [R, D] = G(w), [M, z] = G(L), [ee, he] = G(N), [ce, Ie] = G(f), [_t, vt] = G(h), [Wt, Bt] = G(g), [gt, Ge] = G(null), [Ne, en] = G(null), Lr = Ae(te), { anchorRefs: sr, activeAnchor: Ar } = Os(e), ar = (Re) => Re == null ? void 0 : Re.getAttributeNames().reduce((ot, Y) => {
    var ae;
    return Y.startsWith("data-tooltip-") && (ot[Y.replace(/^data-tooltip-/, "")] = (ae = Re == null ? void 0 : Re.getAttribute(Y)) !== null && ae !== void 0 ? ae : null), ot;
  }, {}), lr = (Re) => {
    const ot = { place: (Y) => {
      var ae;
      Ye((ae = Y) !== null && ae !== void 0 ? ae : d);
    }, content: (Y) => {
      De(Y ?? n);
    }, html: (Y) => {
      it(Y ?? i);
    }, variant: (Y) => {
      var ae;
      He((ae = Y) !== null && ae !== void 0 ? ae : c);
    }, offset: (Y) => {
      v(Y === null ? u : Number(Y));
    }, wrapper: (Y) => {
      var ae;
      Ie((ae = Y) !== null && ae !== void 0 ? ae : f);
    }, events: (Y) => {
      const ae = Y == null ? void 0 : Y.split(" ");
      vt(ae ?? h);
    }, "position-strategy": (Y) => {
      var ae;
      Bt((ae = Y) !== null && ae !== void 0 ? ae : g);
    }, "delay-show": (Y) => {
      C(Y === null ? A : Number(Y));
    }, "delay-hide": (Y) => {
      D(Y === null ? w : Number(Y));
    }, float: (Y) => {
      z(Y === null ? L : Y === "true");
    }, hidden: (Y) => {
      he(Y === null ? N : Y === "true");
    }, "class-name": (Y) => {
      Ge(Y);
    } };
    Object.values(ot).forEach((Y) => Y(null)), Object.entries(Re).forEach(([Y, ae]) => {
      var Je;
      (Je = ot[Y]) === null || Je === void 0 || Je.call(ot, ae);
    });
  };
  J(() => {
    De(n);
  }, [n]), J(() => {
    it(i);
  }, [i]), J(() => {
    Ye(d);
  }, [d]), J(() => {
    He(c);
  }, [c]), J(() => {
    v(u);
  }, [u]), J(() => {
    C(A);
  }, [A]), J(() => {
    D(w);
  }, [w]), J(() => {
    z(L);
  }, [L]), J(() => {
    he(N);
  }, [N]), J(() => {
    Bt(g);
  }, [g]), J(() => {
    Lr.current !== te && console.warn("[react-tooltip] Do not change `disableStyleInjection` dynamically.");
  }, [te]), J(() => {
    typeof window < "u" && window.dispatchEvent(new CustomEvent("react-tooltip-inject-styles", { detail: { disableCore: te === "core", disableBase: te } }));
  }, []), J(() => {
    var Re;
    const ot = new Set(sr);
    let Y = r;
    if (!Y && e && (Y = `[data-tooltip-id='${e.replace(/'/g, "\\'")}']`), Y) try {
      document.querySelectorAll(Y).forEach((Q) => {
        ot.add({ current: Q });
      });
    } catch {
      console.warn(`[react-tooltip] "${Y}" is not a valid CSS selector`);
    }
    const ae = document.querySelector(`[id='${t}']`);
    if (ae && ot.add({ current: ae }), !ot.size) return () => null;
    const Je = (Re = Ne ?? ae) !== null && Re !== void 0 ? Re : Ar.current, Ut = new MutationObserver((Q) => {
      Q.forEach((ne) => {
        var _e;
        if (!Je || ne.type !== "attributes" || !(!((_e = ne.attributeName) === null || _e === void 0) && _e.startsWith("data-tooltip-"))) return;
        const $e = ar(Je);
        lr($e);
      });
    }), P = { attributes: !0, childList: !1, subtree: !1 };
    if (Je) {
      const Q = ar(Je);
      lr(Q), Ut.observe(Je, P);
    }
    return () => {
      Ut.disconnect();
    };
  }, [sr, Ar, Ne, t, r]), J(() => {
    $ != null && $.border && console.warn("[react-tooltip] Do not set `style.border`. Use `border` prop instead."), ie && !vo("border", `${ie}`) && console.warn(`[react-tooltip] "${ie}" is not a valid \`border\`.`), $ != null && $.opacity && console.warn("[react-tooltip] Do not set `style.opacity`. Use `opacity` prop instead."), oe && !vo("opacity", `${oe}`) && console.warn(`[react-tooltip] "${oe}" is not a valid \`opacity\`.`);
  }, []);
  let cr = p;
  const Er = Ae(null);
  if (o) {
    const Re = o({ content: (Ne == null ? void 0 : Ne.getAttribute("data-tooltip-content")) || re || null, activeAnchor: Ne });
    cr = Re ? q.createElement("div", { ref: Er, className: "react-tooltip-content-wrapper" }, Re) : null;
  } else re && (cr = re);
  Ce && (cr = q.createElement(M1, { content: Ce }));
  const tn = { forwardRef: F, id: e, anchorId: t, anchorSelect: r, className: ri(s, gt), classNameArrow: a, content: cr, contentWrapperRef: Er, place: ft, variant: or, offset: Rt, wrapper: ce, events: _t, openOnClick: m, positionStrategy: Wt, middlewares: y, delayShow: x, delayHide: R, float: M, hidden: ee, noArrow: k, clickable: S, closeOnEsc: E, closeOnScroll: V, closeOnResize: I, openEvents: H, closeEvents: W, globalCloseEvents: O, imperativeModeOnly: T, style: $, position: X, isOpen: K, defaultIsOpen: U, border: ie, opacity: oe, arrowColor: se, arrowSize: pe, setIsOpen: de, afterShow: Se, afterHide: Oe, disableTooltip: xe, activeAnchor: Ne, setActiveAnchor: (Re) => en(Re), role: Fe };
  return q.createElement(T1, { ...tn });
});
typeof window < "u" && window.addEventListener("react-tooltip-inject-styles", (e) => {
  e.detail.disableCore || mo({ css: ":root{--rt-color-white:#fff;--rt-color-dark:#222;--rt-color-success:#8dc572;--rt-color-error:#be6464;--rt-color-warning:#f0ad4e;--rt-color-info:#337ab7;--rt-opacity:0.9;--rt-transition-show-delay:0.15s;--rt-transition-closing-delay:0.15s;--rt-arrow-size:8px}.core-styles-module_tooltip__3vRRp{position:absolute;top:0;left:0;pointer-events:none;opacity:0;will-change:opacity}.core-styles-module_fixed__pcSol{position:fixed}.core-styles-module_arrow__cvMwQ{position:absolute;background:inherit;z-index:-1}.core-styles-module_noArrow__xock6{display:none}.core-styles-module_clickable__ZuTTB{pointer-events:auto}.core-styles-module_show__Nt9eE{opacity:var(--rt-opacity);transition:opacity var(--rt-transition-show-delay)ease-out}.core-styles-module_closing__sGnxF{opacity:0;transition:opacity var(--rt-transition-closing-delay)ease-in}", type: "core" }), e.detail.disableBase || mo({ css: `
.styles-module_tooltip__mnnfp{padding:8px 16px;border-radius:3px;font-size:90%;width:max-content}.styles-module_arrow__K0L3T{width:var(--rt-arrow-size);height:var(--rt-arrow-size)}[class*='react-tooltip__place-top']>.styles-module_arrow__K0L3T{transform:rotate(45deg)}[class*='react-tooltip__place-right']>.styles-module_arrow__K0L3T{transform:rotate(135deg)}[class*='react-tooltip__place-bottom']>.styles-module_arrow__K0L3T{transform:rotate(225deg)}[class*='react-tooltip__place-left']>.styles-module_arrow__K0L3T{transform:rotate(315deg)}.styles-module_dark__xNqje{background:var(--rt-color-dark);color:var(--rt-color-white)}.styles-module_light__Z6W-X{background-color:var(--rt-color-white);color:var(--rt-color-dark)}.styles-module_success__A2AKt{background-color:var(--rt-color-success);color:var(--rt-color-white)}.styles-module_warning__SCK0X{background-color:var(--rt-color-warning);color:var(--rt-color-white)}.styles-module_error__JvumD{background-color:var(--rt-color-error);color:var(--rt-color-white)}.styles-module_info__BWdHW{background-color:var(--rt-color-info);color:var(--rt-color-white)}`, type: "base" });
});
const D1 = {
  default: "text-accent-primary",
  warning: "text-warning-main",
  error: "text-error-main"
}, R1 = {
  default: "text-secondary-strokeDark",
  warning: "text-warning-main",
  error: "text-error-main"
};
function xo({
  children: e,
  tooltip: t,
  status: r = "default",
  attachToChildren: n = !1,
  icon: i,
  className: o,
  placement: s = "top",
  tooltipVariant: a = "primary",
  offset: c = [8, 8]
}) {
  const d = Ur(), u = D1[r], f = {
    name: "customOffset",
    fn: ({ x: m, y: g, placement: y }) => {
      let A = m, w = g;
      return y === "top" ? w = g - c[1] : y === "bottom" ? w = g + c[1] : y === "left" ? A = m - c[0] : y === "right" && (A = m + c[0]), { x: A, y: w };
    }
  };
  if (!t)
    return n ? /* @__PURE__ */ l("span", { className: _("inline-flex items-center gap-1", u, o), children: e }) : /* @__PURE__ */ l("div", { className: _("inline-flex items-center gap-1", u, o), children: e });
  const p = /* @__PURE__ */ l(ss, { size: 16, className: R1[r] }), h = i || p;
  return n ? /* @__PURE__ */ b("span", { className: _("inline-flex items-center gap-1", u, o), children: [
    /* @__PURE__ */ l(
      "span",
      {
        className: "cursor-pointer",
        "data-tooltip-id": d,
        "data-tooltip-content": typeof t == "string" ? t : void 0,
        "data-tooltip-place": s,
        "data-tooltip-position-strategy": "fixed",
        "data-tooltip-wrapper": "span",
        children: e
      }
    ),
    /* @__PURE__ */ l(
      wo,
      {
        id: d,
        className: _(
          "react-tooltip",
          a === "secondary" && "react-tooltip--secondary"
        ),
        openOnClick: !1,
        clickable: !0,
        place: s,
        style: { zIndex: 99999 },
        positionStrategy: "fixed",
        middlewares: [f],
        offset: 0,
        children: typeof t != "string" && t
      }
    )
  ] }) : /* @__PURE__ */ b("div", { className: _("inline-flex items-center gap-1", u, o), children: [
    e,
    /* @__PURE__ */ l(
      "span",
      {
        className: _("cursor-pointer inline-flex items-center", u),
        "data-tooltip-id": d,
        "data-tooltip-content": typeof t == "string" ? t : void 0,
        "data-tooltip-place": s,
        "data-tooltip-position-strategy": "fixed",
        "data-tooltip-wrapper": "span",
        children: h
      }
    ),
    /* @__PURE__ */ l(
      wo,
      {
        id: d,
        className: _(
          "react-tooltip",
          a === "secondary" && "react-tooltip--secondary"
        ),
        openOnClick: !1,
        clickable: !0,
        place: s,
        style: { zIndex: 99999 },
        positionStrategy: "fixed",
        middlewares: [f],
        offset: 0,
        children: typeof t != "string" && t
      }
    )
  ] });
}
const _d = ({
  icon: e,
  title: t,
  content: r,
  onCloseClick: n,
  className: i,
  style: o
}) => /* @__PURE__ */ b(zt, { className: le("flex gap-3", i), style: o, children: [
  e,
  /* @__PURE__ */ b("div", { className: "flex flex-col gap-1", children: [
    typeof t == "string" ? /* @__PURE__ */ l(Z, { variant: "subtitle1", className: "text-accent-primary", children: t }) : t,
    typeof r == "string" ? /* @__PURE__ */ l(Z, { variant: "body1", className: "text-accent-secondary", children: r }) : r
  ] }),
  /* @__PURE__ */ l(
    "button",
    {
      type: "button",
      className: "cursor-pointer self-start",
      "aria-label": "Dismiss subsection",
      onClick: n,
      children: /* @__PURE__ */ l(An, { size: 14, variant: "accent-primary" })
    }
  )
] }), Vd = ({
  visible: e,
  message: t,
  onClick: r,
  onDismiss: n,
  className: i,
  icon: o
}) => {
  if (!e)
    return null;
  const s = (a) => {
    a.stopPropagation(), n();
  };
  return /* @__PURE__ */ b(
    "div",
    {
      className: _("bbn-top-banner", i),
      onClick: r,
      role: "button",
      tabIndex: 0,
      children: [
        /* @__PURE__ */ b("div", { className: "bbn-top-banner-content", children: [
          o,
          /* @__PURE__ */ l(Z, { variant: "body2", className: "bbn-top-banner-message", children: t })
        ] }),
        /* @__PURE__ */ l(
          "button",
          {
            onClick: s,
            className: "bbn-top-banner-dismiss-btn",
            "aria-label": "Dismiss banner",
            type: "button",
            children: /* @__PURE__ */ l(An, { size: 16, className: "bbn-top-banner-dismiss-icon" })
          }
        )
      ]
    }
  );
};
function B1(e) {
  return we({ attr: { viewBox: "0 0 256 256", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M196,136a16,16,0,1,1-16-16A16,16,0,0,1,196,136Zm40-36v80a32,32,0,0,1-32,32H60a32,32,0,0,1-32-32V60.92A32,32,0,0,1,60,28H192a12,12,0,0,1,0,24H60a8,8,0,0,0-8,8.26v.08A8.32,8.32,0,0,0,60.48,68H204A32,32,0,0,1,236,100Zm-24,0a8,8,0,0,0-8-8H60.48A33.72,33.72,0,0,1,52,90.92V180a8,8,0,0,0,8,8H204a8,8,0,0,0,8-8Z" }, child: [] }] })(e);
}
function F1(e) {
  return we({ attr: { viewBox: "0 0 256 256", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M227.31,80.23,175.77,28.69A16.13,16.13,0,0,0,164.45,24H91.55a16.13,16.13,0,0,0-11.32,4.69L28.69,80.23A16.13,16.13,0,0,0,24,91.55v72.9a16.13,16.13,0,0,0,4.69,11.32l51.54,51.54A16.13,16.13,0,0,0,91.55,232h72.9a16.13,16.13,0,0,0,11.32-4.69l51.54-51.54A16.13,16.13,0,0,0,232,164.45V91.55A16.13,16.13,0,0,0,227.31,80.23ZM120,80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm8,104a12,12,0,1,1,12-12A12,12,0,0,1,128,184Z" }, child: [] }] })(e);
}
const Td = ({ visible: e }) => e ? /* @__PURE__ */ l("div", { className: "bbn-testing-banner", children: /* @__PURE__ */ b("div", { className: "bbn-testing-banner-content", children: [
  /* @__PURE__ */ l(F1, { className: "bbn-testing-banner-icon" }),
  /* @__PURE__ */ b(Z, { variant: "body1", children: [
    /* @__PURE__ */ l("strong", { children: "This is a testing app" }),
    /* @__PURE__ */ l("br", {}),
    "The app may contain bugs. Use it after conducting your own research and making an informed decision. Tokens are for testing only and do not carry any monetary value and the testnet is not incentivized."
  ] })
] }) }) : null;
function H1(e) {
  return we({ attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeLinecap: "square", strokeMiterlimit: "10", strokeWidth: "44", d: "M416 128 192 384l-96-96" }, child: [] }] })(e);
}
function I1(e) {
  return we({ attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M240 240H32V32h208zm240 0H272V32h208zM240 480H32V272h208zm240 0H272V272h208z" }, child: [] }] })(e);
}
const $1 = (e, t) => t > e ? /* @__PURE__ */ l("div", { className: "flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-light", children: /* @__PURE__ */ l(H1, { size: 24, className: "text-accent-contrast" }) }) : t === e ? /* @__PURE__ */ l("div", { className: "flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-secondary-main", children: /* @__PURE__ */ l(ls, { size: 24, className: "text-accent-contrast" }) }) : /* @__PURE__ */ l("div", { className: "flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-secondary-main", children: /* @__PURE__ */ l(Z, { variant: "body1", className: "text-accent-contrast", children: e }) });
function Md({ step: e, currentStep: t, children: r, className: n }) {
  return /* @__PURE__ */ b(
    "div",
    {
      className: le(
        "flex w-full flex-row items-center gap-3 self-stretch rounded border border-secondary-strokeLight bg-surface p-4",
        !(e === t) && "opacity-25",
        n
      ),
      children: [
        $1(e, t),
        /* @__PURE__ */ b(Z, { variant: "body1", className: "text-accent-primary", children: [
          "Step ",
          e,
          ": ",
          r
        ] })
      ]
    }
  );
}
const _s = ({
  as: e = "div",
  className: t,
  children: r
}) => yn(
  e,
  { className: le("container px-4 mx-auto sm:px-0", t) },
  r
), P1 = ({ className: e }) => /* @__PURE__ */ l("a", { href: "/", children: /* @__PURE__ */ b(
  "svg",
  {
    viewBox: "0 0 367 91",
    xmlns: "http://www.w3.org/2000/svg",
    className: le("text-accent-contrast", e),
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          d: "M0 7.10867C0 5.15111 0.694596 3.4756 2.08532 2.08521C3.47605 0.694815 5.14874 0 7.10645 0C9.06417 0 10.7384 0.696344 12.1283 2.08521C13.5168 3.4756 14.2137 5.15111 14.2137 7.10867V16.5869C14.2137 17.3452 14.4651 17.9299 14.9709 18.3404C15.476 18.7524 16.0132 18.9564 16.5817 18.9564H30.7946C32.7524 18.9564 34.4266 19.6528 35.8165 21.0417C37.205 22.4321 37.9019 24.1076 37.9019 26.0651C37.9019 26.7615 38.1219 27.3302 38.5644 27.7712C39.006 28.2138 39.5745 28.4347 40.2699 28.4347C42.2276 28.4347 43.9018 29.131 45.2918 30.5199C46.6802 31.9103 47.3764 33.5858 47.3764 35.5433V54.4998C47.3764 56.4589 46.681 58.1344 45.2918 59.5233C43.9026 60.9121 42.2269 61.6085 40.2699 61.6085C39.7014 61.6085 39.1642 61.8141 38.6591 62.2245C38.1533 62.6365 37.9019 63.2198 37.9019 63.978C37.9019 65.9371 37.2057 67.6126 35.8165 69.0015C34.4273 70.3903 32.7516 71.0867 30.7946 71.0867H7.10645C5.14874 71.0867 3.47375 70.3919 2.08532 69.0015C0.69536 67.6126 0 65.9371 0 63.978V7.10867ZM30.7946 56.8693C31.3632 56.8693 31.8996 56.6798 32.4054 56.3007C32.9105 55.9215 33.1635 55.3215 33.1635 54.4998V35.5433C33.1635 34.9127 32.9411 34.3586 32.5002 33.8847C32.0578 33.4107 31.4892 33.1738 30.7946 33.1738H16.5817C15.8864 33.1738 15.3178 33.4268 14.8762 33.932C14.4337 34.4388 14.2137 34.9746 14.2137 35.5433V54.4998C14.2137 55.1961 14.4506 55.7648 14.9243 56.2059C15.3981 56.6484 15.9506 56.8693 16.5825 56.8693H30.7946Z",
          className: "fill-current"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          d: "M47.3818 45.0261C47.3818 43.0685 48.0764 41.393 49.4672 40.0026C50.8579 38.6122 52.5306 37.9174 54.4883 37.9174H78.1765C78.6824 37.9174 79.2035 37.7133 79.7407 37.3013C80.2763 36.8908 80.5468 36.3061 80.5468 35.5478C80.5468 34.7896 80.2763 34.2064 79.7407 33.7944C79.2035 33.3839 78.6824 33.1783 78.1765 33.1783H54.4883C52.5306 33.1783 50.8556 32.4835 49.4672 31.0931C48.0772 29.7042 47.3818 28.0287 47.3818 26.0696C47.3818 24.1105 48.0764 22.4365 49.4672 21.0461C50.8579 19.6558 52.5306 18.9609 54.4883 18.9609H78.1765C80.1342 18.9609 81.8092 19.6573 83.1984 21.0461C84.5876 22.4365 85.2837 24.112 85.2837 26.0696C85.2837 26.8279 85.5527 27.4126 86.0899 27.8231C86.6255 28.2351 87.1467 28.4392 87.6525 28.4392C89.6103 28.4392 91.2852 29.1355 92.6744 30.5244C94.0636 31.9148 94.7598 33.5903 94.7598 35.5478V63.9825C94.7598 65.9416 94.0644 67.6171 92.6744 69.006C91.2852 70.3963 89.6103 71.0912 87.6525 71.0912H63.9643C62.0059 71.0912 60.3309 70.3963 58.9424 69.006C57.5525 67.6171 56.8579 65.9416 56.8579 63.9825C56.8579 63.2877 56.605 62.719 56.0999 62.2764C55.594 61.8354 55.0576 61.6129 54.4891 61.6129C52.5314 61.6129 50.8564 60.9181 49.4679 59.5277C48.078 58.1389 47.3826 56.4634 47.3826 54.5043V45.0261H47.3818ZM78.1765 56.8738C78.745 56.8738 79.2807 56.6529 79.7881 56.2104C80.2924 55.7693 80.5461 55.2006 80.5461 54.5043C80.5461 53.9356 80.3237 53.3998 79.8821 52.893C79.4404 52.3877 78.8719 52.1347 78.1765 52.1347H63.9636C63.2682 52.1347 62.6997 52.3877 62.258 52.893C61.8156 53.3998 61.5955 53.9356 61.5955 54.5043C61.5955 55.2006 61.8469 55.7693 62.3528 56.2104C62.8579 56.6529 63.3951 56.8738 63.9636 56.8738H78.1765Z",
          className: "fill-current"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          d: "M94.7637 7.10867C94.7637 5.15111 95.4575 3.4756 96.8482 2.08521C98.239 0.694815 99.9117 0 101.87 0C103.829 0 105.502 0.696344 106.892 2.08521C108.28 3.4756 108.977 5.15111 108.977 7.10867V16.5869C108.977 17.3452 109.229 17.9299 109.735 18.3404C110.24 18.7524 110.777 18.9564 111.345 18.9564H125.558C127.516 18.9564 129.19 19.6528 130.58 21.0417C131.969 22.4321 132.665 24.1076 132.665 26.0651C132.665 26.7615 132.886 27.3302 133.328 27.7712C133.769 28.2138 134.337 28.4347 135.034 28.4347C136.991 28.4347 138.666 29.131 140.055 30.5199C141.444 31.9103 142.14 33.5858 142.14 35.5433V54.4998C142.14 56.4589 141.445 58.1344 140.055 59.5233C138.666 60.9121 136.991 61.6085 135.034 61.6085C134.465 61.6085 133.928 61.8141 133.423 62.2245C132.917 62.6365 132.665 63.2198 132.665 63.978C132.665 65.9371 131.969 67.6126 130.58 69.0015C129.191 70.3903 127.515 71.0867 125.558 71.0867H101.87C99.9117 71.0867 98.2367 70.3919 96.8482 69.0015C95.4583 67.6126 94.7637 65.9371 94.7637 63.978V7.10867ZM125.558 56.8693C126.127 56.8693 126.663 56.6798 127.169 56.3007C127.673 55.9215 127.927 55.3215 127.927 54.4998V35.5433C127.927 34.9127 127.705 34.3586 127.264 33.8847C126.821 33.4107 126.253 33.1738 125.558 33.1738H111.345C110.649 33.1738 110.081 33.4268 109.64 33.932C109.197 34.4388 108.977 34.9746 108.977 35.5433V54.4998C108.977 55.1961 109.214 55.7648 109.688 56.2059C110.162 56.6484 110.714 56.8693 111.346 56.8693H125.558Z",
          className: "fill-current"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          d: "M172.925 75.8303C173.619 75.8303 174.188 75.6079 174.63 75.1668C175.071 74.7242 175.293 74.1555 175.293 73.4607C175.293 72.7659 175.071 72.1957 174.63 71.7546C174.188 71.3121 173.619 71.0912 172.925 71.0912H158.712C156.753 71.0912 155.078 70.3964 153.69 69.006C152.3 67.6171 151.605 65.9416 151.605 63.9825C151.605 63.3519 151.383 62.7977 150.942 62.3238C150.499 61.8499 149.931 61.6129 149.236 61.6129C147.278 61.6129 145.603 60.9181 144.214 59.5277C142.824 58.1389 142.13 56.4634 142.13 54.5043V26.0696C142.13 24.112 142.824 22.4365 144.214 21.0461C145.605 19.6558 147.278 18.9609 149.236 18.9609C151.195 18.9609 152.868 19.6573 154.258 21.0461C155.647 22.4365 156.343 24.112 156.343 26.0696V54.5043C156.343 55.2006 156.564 55.7693 157.006 56.2104C157.447 56.6529 158.015 56.8738 158.712 56.8738H172.925C173.619 56.8738 174.188 56.6529 174.63 56.2104C175.071 55.7693 175.293 55.2006 175.293 54.5043V26.0696C175.293 24.112 175.987 22.4365 177.378 21.0461C178.769 19.6558 180.441 18.9609 182.4 18.9609C184.358 18.9609 186.032 19.6573 187.422 21.0461C188.81 22.4365 189.506 24.112 189.506 26.0696V73.4607C189.506 75.4183 188.811 77.0938 187.422 78.4842C186.032 79.873 184.357 80.5694 182.4 80.5694C181.704 80.5694 181.135 80.8064 180.694 81.2803C180.252 81.7542 180.031 82.3068 180.031 82.939C180.031 84.8965 179.336 86.572 177.946 87.9624C176.556 89.3513 174.881 90.0476 172.925 90.0476H149.236C147.278 90.0476 145.603 89.3513 144.214 87.9624C142.826 86.5735 142.13 84.8965 142.13 82.939C142.13 80.9814 142.824 79.3044 144.214 77.9155C145.603 76.5251 147.278 75.8303 149.236 75.8303H172.925Z",
          className: "fill-current"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          d: "M189.5 7.10867C189.5 5.15111 190.193 3.4756 191.584 2.08521C192.975 0.694815 194.647 0 196.606 0C198.564 0 200.238 0.696344 201.628 2.08521C203.016 3.4756 203.712 5.15111 203.712 7.10867V54.4998C203.712 55.2581 203.965 55.8428 204.47 56.2533C204.976 56.6653 205.513 56.8693 206.081 56.8693H210.819C212.776 56.8693 214.45 57.5657 215.84 58.9546C217.228 60.3449 217.925 62.0205 217.925 63.978C217.925 65.9356 217.229 67.6126 215.84 69.0015C214.451 70.3903 212.775 71.0867 210.819 71.0867H206.081C204.123 71.0867 202.448 70.3919 201.059 69.0015C199.669 67.6126 198.975 65.9371 198.975 63.978C198.975 63.2198 198.721 62.6365 198.217 62.2245C197.71 61.8141 197.174 61.6085 196.606 61.6085C194.647 61.6085 192.973 60.9136 191.584 59.5233C190.194 58.1344 189.5 56.4589 189.5 54.4998V7.10867Z",
          className: "fill-current"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          d: "M214.239 35.5478C214.239 33.5903 214.933 31.9148 216.323 30.5244C217.714 29.134 219.387 28.4392 221.345 28.4392C222.04 28.4392 222.608 28.1877 223.051 27.6809C223.492 27.1757 223.714 26.6383 223.714 26.0696C223.714 24.112 224.408 22.4365 225.799 21.0461C227.189 19.6558 228.862 18.9609 230.821 18.9609H245.033C246.991 18.9609 248.665 19.6573 250.055 21.0461C251.444 22.4365 252.14 24.112 252.14 26.0696C252.14 26.7659 252.378 27.3346 252.851 27.7757C253.325 28.2183 253.878 28.4392 254.509 28.4392C256.467 28.4392 258.141 29.1355 259.531 30.5244C260.92 31.9148 261.616 33.5903 261.616 35.5478V54.5043C261.616 56.4634 260.921 58.1389 259.531 59.5277C258.142 60.9166 256.466 61.6129 254.509 61.6129C253.751 61.6129 253.166 61.8828 252.757 62.4186C252.345 62.9559 252.14 63.4772 252.14 63.9825C252.14 65.9416 251.445 67.6171 250.055 69.006C248.666 70.3948 246.99 71.0912 245.033 71.0912H230.821C228.862 71.0912 227.187 70.3963 225.799 69.006C224.409 67.6171 223.714 65.9416 223.714 63.9825C223.714 63.2877 223.492 62.719 223.051 62.2764C222.608 61.8354 222.04 61.6129 221.345 61.6129C219.387 61.6129 217.712 60.9181 216.323 59.5277C214.933 58.1389 214.239 56.4634 214.239 54.5043V35.5478ZM245.033 56.8738C245.602 56.8738 246.138 56.6843 246.644 56.3051C247.149 55.926 247.402 55.326 247.402 54.5043V35.5478C247.402 34.9172 247.18 34.3631 246.739 33.8891C246.297 33.4152 245.728 33.1783 245.033 33.1783H230.821C230.124 33.1783 229.556 33.4313 229.115 33.9365C228.673 34.4433 228.452 34.9791 228.452 35.5478V54.5043C228.452 55.2006 228.689 55.7693 229.163 56.2104C229.637 56.6529 230.189 56.8738 230.821 56.8738H245.033Z",
          className: "fill-current"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          d: "M261.608 26.0696C261.608 24.112 262.302 22.4365 263.693 21.0461C265.084 19.6558 266.756 18.9609 268.715 18.9609H287.665C289.623 18.9609 291.297 19.6573 292.687 21.0461C294.076 22.4365 294.773 24.112 294.773 26.0696C294.773 26.8279 295.01 27.4126 295.483 27.8231C295.957 28.2351 296.51 28.4392 297.141 28.4392C298.34 28.4392 299.383 28.6761 300.268 29.15C301.152 29.6239 301.894 30.2087 302.495 30.9035C303.095 31.5998 303.537 32.3581 303.822 33.1783C304.106 34 304.248 34.7896 304.248 35.5478V63.9825C304.248 65.9416 303.553 67.6171 302.163 69.006C300.774 70.3948 299.098 71.0912 297.141 71.0912C295.185 71.0912 293.508 70.3963 292.12 69.006C290.73 67.6171 290.035 65.9416 290.035 63.9825V35.5478C290.035 34.853 289.782 34.2843 289.277 33.8417C288.77 33.4007 288.235 33.1783 287.666 33.1783H278.192C277.496 33.1783 276.927 33.4152 276.486 33.8891C276.044 34.3631 275.823 34.9172 275.823 35.5478V63.9825C275.823 65.9416 275.127 67.6171 273.738 69.006C272.349 70.3948 270.673 71.0912 268.716 71.0912C266.759 71.0912 265.083 70.3963 263.694 69.006C262.305 67.6171 261.61 65.9416 261.61 63.9825V26.0696H261.608Z",
          className: "fill-current"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          d: "M318.727 8.91004C318.491 8.27077 318.649 7.55278 319.131 7.0709L325.69 0.511563C326.171 0.029677 326.889 -0.127847 327.529 0.107966L341.514 5.24587C341.857 5.37211 342.086 5.69931 342.086 6.06544V9.12744C342.086 9.35904 341.994 9.5811 341.83 9.74481L338.426 13.1489C338.185 13.3898 337.826 13.4686 337.506 13.3506L333.749 11.9651L329.622 10.442C329.272 10.313 328.932 10.6531 329.061 11.0026L331.97 18.8876C332.088 19.2072 332.009 19.5663 331.768 19.8072L328.742 22.8328C328.401 23.1737 328.401 23.7266 328.742 24.0676L331.784 27.1099C332.025 27.3508 332.104 27.7098 331.986 28.0295L329.077 35.9138C328.948 36.2634 329.288 36.6034 329.638 36.4745L337.522 33.5659C337.842 33.4479 338.201 33.5267 338.442 33.7676L341.83 37.1555C341.994 37.3193 342.086 37.5414 342.086 37.7729V40.8359C342.086 41.2015 341.858 41.5285 341.515 41.655L327.545 46.8084C326.906 47.0442 326.188 46.8867 325.706 46.4049L319.147 39.8453C318.665 39.3635 318.507 38.6454 318.743 38.0062L323.879 24.0844C324.023 23.6943 324.023 23.2657 323.879 22.8756L318.727 8.91004Z",
          className: "fill-current"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          d: "M366.892 38.0062C367.128 38.6454 366.97 39.3634 366.488 39.8453L359.929 46.4047C359.448 46.8866 358.729 47.0441 358.09 46.8083L344.105 41.6704C343.762 41.5442 343.533 41.217 343.533 40.8508V37.7888C343.533 37.5572 343.625 37.3352 343.789 37.1715L347.193 33.7674C347.434 33.5265 347.793 33.4477 348.113 33.5657L351.869 34.9511L355.997 36.4743C356.347 36.6033 356.687 36.2632 356.558 35.9137L353.649 28.0287C353.531 27.709 353.61 27.35 353.851 27.1091L356.877 24.0835C357.218 23.7426 357.218 23.1897 356.877 22.8487L353.835 19.8064C353.594 19.5655 353.515 19.2064 353.633 18.8868L356.542 11.0025C356.671 10.6528 356.331 10.3128 355.981 10.4418L348.097 13.3504C347.777 13.4683 347.418 13.3895 347.177 13.1486L343.789 9.76074C343.625 9.59703 343.533 9.3749 343.533 9.14338V6.08043C343.533 5.71474 343.761 5.38783 344.104 5.2613L358.073 0.107968C358.713 -0.127845 359.431 0.0296791 359.913 0.511492L366.472 7.07097C366.954 7.55278 367.112 8.27085 366.876 8.91011L361.74 22.8319C361.596 23.222 361.596 23.6506 361.74 24.0407L366.892 38.0061L366.892 38.0062Z",
          className: "fill-current"
        }
      )
    ]
  }
) }), Vs = () => /* @__PURE__ */ l("a", { href: "/", children: /* @__PURE__ */ b(
  "svg",
  {
    width: "164",
    height: "40",
    viewBox: "0 0 164 40",
    xmlns: "http://www.w3.org/2000/svg",
    className: "text-accent-primary",
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          d: "M0 3.15782C0 2.28823 0.308554 1.54393 0.926343 0.926293C1.54413 0.308651 2.28718 0 3.15683 0C4.02649 0 4.77021 0.30933 5.38766 0.926293C6.00443 1.54393 6.31401 2.28823 6.31401 3.15782V7.36824C6.31401 7.70507 6.42568 7.96483 6.6504 8.14717C6.87477 8.33019 7.1134 8.42085 7.36595 8.42085H13.6796C14.5493 8.42085 15.293 8.73018 15.9104 9.34714C16.5272 9.96478 16.8368 10.7091 16.8368 11.5787C16.8368 11.888 16.9345 12.1406 17.1311 12.3365C17.3273 12.5331 17.5798 12.6313 17.8887 12.6313C18.7584 12.6313 19.5021 12.9406 20.1196 13.5576C20.7363 14.1752 21.0456 14.9195 21.0456 15.7891V24.2099C21.0456 25.0802 20.7367 25.8245 20.1196 26.4415C19.5024 27.0584 18.758 27.3678 17.8887 27.3678C17.6362 27.3678 17.3976 27.4591 17.1732 27.6414C16.9485 27.8244 16.8368 28.0835 16.8368 28.4204C16.8368 29.2906 16.5276 30.0349 15.9104 30.6519C15.2933 31.2688 14.5489 31.5782 13.6796 31.5782H3.15683C2.28718 31.5782 1.54311 31.2695 0.926343 30.6519C0.308893 30.0349 0 29.2906 0 28.4204V3.15782ZM13.6796 25.2625C13.9322 25.2625 14.1705 25.1783 14.3952 25.0099C14.6195 24.8415 14.7319 24.575 14.7319 24.2099V15.7891C14.7319 15.509 14.6331 15.2628 14.4373 15.0523C14.2407 14.8417 13.9882 14.7365 13.6796 14.7365H7.36595C7.05705 14.7365 6.8045 14.8489 6.6083 15.0733C6.41177 15.2984 6.31401 15.5365 6.31401 15.7891V24.2099C6.31401 24.5193 6.41924 24.7719 6.62969 24.9678C6.84015 25.1644 7.08556 25.2625 7.36628 25.2625H13.6796Z",
          className: "fill-current"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          d: "M21.0485 20.0005C21.0485 19.1309 21.357 18.3867 21.9748 17.769C22.5926 17.1514 23.3356 16.8427 24.2053 16.8427H34.7281C34.9528 16.8427 35.1843 16.7521 35.4229 16.569C35.6609 16.3867 35.781 16.1269 35.781 15.7901C35.781 15.4533 35.6609 15.1942 35.4229 15.0112C35.1843 14.8288 34.9528 14.7375 34.7281 14.7375H24.2053C23.3356 14.7375 22.5916 14.4289 21.9748 13.8112C21.3574 13.1943 21.0485 12.45 21.0485 11.5797C21.0485 10.7094 21.357 9.96581 21.9748 9.34817C22.5926 8.73053 23.3356 8.42188 24.2053 8.42188H34.7281C35.5977 8.42188 36.3418 8.73121 36.9589 9.34817C37.576 9.96581 37.8853 10.7101 37.8853 11.5797C37.8853 11.9165 38.0047 12.1763 38.2434 12.3586C38.4813 12.5416 38.7128 12.6323 38.9375 12.6323C39.8072 12.6323 40.5513 12.9416 41.1684 13.5586C41.7855 14.1762 42.0947 14.9205 42.0947 15.7901V28.4214C42.0947 29.2916 41.7858 30.0359 41.1684 30.6529C40.5513 31.2705 39.8072 31.5792 38.9375 31.5792H28.4148C27.5448 31.5792 26.8007 31.2705 26.1839 30.6529C25.5665 30.0359 25.2579 29.2916 25.2579 28.4214C25.2579 28.1127 25.1456 27.8601 24.9212 27.6635C24.6965 27.4676 24.4582 27.3688 24.2056 27.3688C23.336 27.3688 22.5919 27.0601 21.9751 26.4425C21.3577 25.8255 21.0488 25.0812 21.0488 24.211V20.0005H21.0485ZM34.7281 25.2636C34.9806 25.2636 35.2186 25.1654 35.444 24.9688C35.668 24.7729 35.7807 24.5203 35.7807 24.211C35.7807 23.9583 35.6819 23.7203 35.4857 23.4952C35.2895 23.2707 35.037 23.1584 34.7281 23.1584H28.4144C28.1055 23.1584 27.853 23.2707 27.6568 23.4952C27.4602 23.7203 27.3625 23.9583 27.3625 24.211C27.3625 24.5203 27.4742 24.7729 27.6989 24.9688C27.9232 25.1654 28.1619 25.2636 28.4144 25.2636H34.7281Z",
          className: "fill-current"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          d: "M42.095 3.15782C42.095 2.28823 42.4032 1.54393 43.021 0.926293C43.6388 0.308651 44.3819 0 45.2519 0C46.1219 0 46.8652 0.30933 47.4827 0.926293C48.0995 1.54393 48.4087 2.28823 48.4087 3.15782V7.36824C48.4087 7.70507 48.5207 7.96483 48.7454 8.14717C48.9698 8.33019 49.2084 8.42085 49.461 8.42085H55.7747C56.6443 8.42085 57.388 8.73018 58.0055 9.34714C58.6222 9.96478 58.9315 10.7091 58.9315 11.5787C58.9315 11.888 59.0296 12.1406 59.2261 12.3365C59.422 12.5331 59.6745 12.6313 59.9838 12.6313C60.8534 12.6313 61.5971 12.9406 62.2146 13.5576C62.8314 14.1752 63.1406 14.9195 63.1406 15.7891V24.2099C63.1406 25.0802 62.8317 25.8245 62.2146 26.4415C61.5975 27.0584 60.8531 27.3678 59.9838 27.3678C59.7312 27.3678 59.4926 27.4591 59.2682 27.6414C59.0435 27.8244 58.9315 28.0835 58.9315 28.4204C58.9315 29.2906 58.6226 30.0349 58.0055 30.6519C57.3884 31.2688 56.644 31.5782 55.7747 31.5782H45.2519C44.3819 31.5782 43.6378 31.2695 43.021 30.6519C42.4036 30.0349 42.095 29.2906 42.095 28.4204V3.15782ZM55.7747 25.2625C56.0272 25.2625 56.2651 25.1783 56.4902 25.0099C56.7142 24.8415 56.8269 24.575 56.8269 24.2099V15.7891C56.8269 15.509 56.7281 15.2628 56.5323 15.0523C56.3358 14.8417 56.0832 14.7365 55.7747 14.7365H49.461C49.1517 14.7365 48.8992 14.8489 48.7033 15.0733C48.5068 15.2984 48.4087 15.5365 48.4087 15.7891V24.2099C48.4087 24.5193 48.5143 24.7719 48.7247 24.9678C48.9352 25.1644 49.1806 25.2625 49.4613 25.2625H55.7747Z",
          className: "fill-current"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          d: "M76.8172 33.6844C77.1258 33.6844 77.3784 33.5856 77.5749 33.3897C77.7708 33.1931 77.8695 32.9405 77.8695 32.6318C77.8695 32.3232 77.7708 32.0699 77.5749 31.8739C77.3784 31.6773 77.1258 31.5792 76.8172 31.5792H70.5036C69.6336 31.5792 68.8895 31.2706 68.2727 30.6529C67.6553 30.0359 67.3467 29.2917 67.3467 28.4214C67.3467 28.1413 67.248 27.8951 67.0521 27.6846C66.8556 27.474 66.603 27.3688 66.2945 27.3688C65.4245 27.3688 64.6804 27.0601 64.0636 26.4425C63.4462 25.8255 63.1376 25.0812 63.1376 24.211V11.5797C63.1376 10.7101 63.4458 9.96581 64.0636 9.34817C64.6814 8.73053 65.4245 8.42188 66.2945 8.42188C67.1645 8.42188 67.9079 8.73121 68.5253 9.34817C69.1421 9.96581 69.4513 10.7101 69.4513 11.5797V24.211C69.4513 24.5203 69.5494 24.7729 69.7459 24.9688C69.9418 25.1654 70.1944 25.2636 70.5036 25.2636H76.8172C77.1258 25.2636 77.3784 25.1654 77.5749 24.9688C77.7708 24.7729 77.8695 24.5203 77.8695 24.211V11.5797C77.8695 10.7101 78.1777 9.96581 78.7955 9.34817C79.4133 8.73053 80.1564 8.42188 81.0264 8.42188C81.8964 8.42188 82.6397 8.73121 83.2572 9.34817C83.874 9.96581 84.1832 10.7101 84.1832 11.5797V32.6318C84.1832 33.5014 83.8743 34.2457 83.2572 34.8633C82.6397 35.4803 81.8957 35.7896 81.0264 35.7896C80.7171 35.7896 80.4646 35.8949 80.2687 36.1054C80.0722 36.3159 79.9741 36.5614 79.9741 36.8422C79.9741 37.7118 79.6652 38.4561 79.0481 39.0738C78.4306 39.6907 77.6866 40 76.8172 40H66.2945C65.4245 40 64.6804 39.6907 64.0636 39.0738C63.4469 38.4568 63.1376 37.7118 63.1376 36.8422C63.1376 35.9726 63.4458 35.2277 64.0636 34.6107C64.6804 33.9931 65.4245 33.6844 66.2945 33.6844H76.8172Z",
          className: "fill-current"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          d: "M84.1783 3.15782C84.1783 2.28823 84.4866 1.54393 85.1043 0.926293C85.7221 0.308651 86.4652 0 87.3352 0C88.2052 0 88.9486 0.30933 89.566 0.926293C90.1828 1.54393 90.492 2.28823 90.492 3.15782V24.2099C90.492 24.5468 90.604 24.8065 90.8287 24.9889C91.0531 25.1719 91.2917 25.2625 91.5443 25.2625H93.6488C94.5182 25.2625 95.2619 25.5719 95.8793 26.1888C96.4961 26.8065 96.8057 27.5508 96.8057 28.4204C96.8057 29.2899 96.4965 30.0349 95.8793 30.6519C95.2622 31.2688 94.5178 31.5782 93.6488 31.5782H91.5443C90.6743 31.5782 89.9302 31.2695 89.3135 30.6519C88.696 30.0349 88.3875 29.2906 88.3875 28.4204C88.3875 28.0835 88.2748 27.8244 88.0507 27.6414C87.8257 27.4591 87.5877 27.3678 87.3352 27.3678C86.4652 27.3678 85.7211 27.0591 85.1043 26.4415C84.4869 25.8245 84.1783 25.0802 84.1783 24.2099V3.15782Z",
          className: "fill-current"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          d: "M95.1696 15.7901C95.1696 14.9205 95.4778 14.1762 96.0956 13.5586C96.7133 12.9409 97.4564 12.6323 98.3264 12.6323C98.635 12.6323 98.8875 12.5206 99.084 12.2955C99.2799 12.071 99.3787 11.8323 99.3787 11.5797C99.3787 10.7101 99.6869 9.96581 100.305 9.34817C100.922 8.73053 101.666 8.42188 102.536 8.42188H108.849C109.719 8.42188 110.463 8.73121 111.08 9.34817C111.697 9.96581 112.006 10.7101 112.006 11.5797C112.006 11.889 112.112 12.1416 112.322 12.3376C112.532 12.5342 112.778 12.6323 113.059 12.6323C113.928 12.6323 114.672 12.9416 115.289 13.5586C115.906 14.1762 116.215 14.9205 116.215 15.7901V24.211C116.215 25.0812 115.907 25.8255 115.289 26.4425C114.672 27.0594 113.928 27.3688 113.059 27.3688C112.722 27.3688 112.462 27.4886 112.28 27.7267C112.097 27.9654 112.006 28.1969 112.006 28.4214C112.006 29.2916 111.697 30.0359 111.08 30.6529C110.463 31.2699 109.718 31.5792 108.849 31.5792H102.536C101.666 31.5792 100.921 31.2705 100.305 30.6529C99.6872 30.0359 99.3787 29.2916 99.3787 28.4214C99.3787 28.1127 99.2799 27.8601 99.084 27.6635C98.8875 27.4676 98.635 27.3688 98.3264 27.3688C97.4564 27.3688 96.7123 27.0601 96.0956 26.4425C95.4781 25.8255 95.1696 25.0812 95.1696 24.211V15.7901ZM108.849 25.2636C109.102 25.2636 109.34 25.1794 109.565 25.0109C109.789 24.8425 109.901 24.576 109.901 24.211V15.7901C109.901 15.51 109.803 15.2638 109.607 15.0533C109.41 14.8428 109.158 14.7375 108.849 14.7375H102.536C102.226 14.7375 101.974 14.8499 101.778 15.0743C101.581 15.2995 101.483 15.5375 101.483 15.7901V24.211C101.483 24.5203 101.589 24.7729 101.799 24.9688C102.01 25.1644 102.255 25.2636 102.536 25.2636H108.849Z",
          className: "fill-current"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          d: "M116.212 11.5797C116.212 10.7101 116.52 9.96581 117.138 9.34817C117.756 8.73053 118.499 8.42188 119.369 8.42188H127.787C128.657 8.42188 129.401 8.73121 130.018 9.34817C130.635 9.96581 130.944 10.7101 130.944 11.5797C130.944 11.9165 131.05 12.1763 131.26 12.3586C131.471 12.5416 131.716 12.6323 131.997 12.6323C132.529 12.6323 132.993 12.7376 133.386 12.9481C133.778 13.1586 134.108 13.4184 134.375 13.727C134.641 14.0363 134.838 14.3732 134.964 14.7375C135.09 15.1025 135.154 15.4533 135.154 15.7901V28.4214C135.154 29.2916 134.845 30.0359 134.228 30.6529C133.61 31.2699 132.866 31.5792 131.997 31.5792C131.127 31.5792 130.383 31.2705 129.766 30.6529C129.148 30.0359 128.84 29.2916 128.84 28.4214V15.7901C128.84 15.4815 128.728 15.2288 128.503 15.0322C128.278 14.8363 128.04 14.7375 127.788 14.7375H123.579C123.27 14.7375 123.017 14.8428 122.821 15.0533C122.625 15.2638 122.527 15.51 122.527 15.7901V28.4214C122.527 29.2916 122.218 30.0359 121.601 30.6529C120.983 31.2699 120.239 31.5792 119.37 31.5792C118.5 31.5792 117.756 31.2705 117.139 30.6529C116.521 30.0359 116.213 29.2916 116.213 28.4214V11.5797H116.212Z",
          className: "fill-current"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          d: "M141.589 3.95802C141.485 3.67405 141.555 3.3551 141.769 3.14104L144.682 0.227247C144.896 0.0131831 145.215 -0.0567923 145.499 0.0479608L151.712 2.33033C151.864 2.3864 151.966 2.53175 151.966 2.69439V4.0546C151.966 4.15748 151.925 4.25612 151.852 4.32884L150.34 5.84099C150.233 5.94801 150.074 5.98301 149.932 5.93062L148.263 5.31516L146.429 4.63855C146.274 4.58124 146.123 4.73231 146.18 4.88758L147.472 8.39027C147.525 8.53225 147.49 8.69176 147.382 8.79878L146.038 10.1428C145.887 10.2942 145.887 10.5399 146.038 10.6913L147.39 12.0428C147.497 12.1498 147.532 12.3093 147.479 12.4513L146.187 15.9537C146.13 16.109 146.281 16.26 146.436 16.2027L149.939 14.9107C150.081 14.8583 150.24 14.8933 150.347 15.0003L151.852 16.5053C151.925 16.578 151.966 16.6767 151.966 16.7795V18.1401C151.966 18.3026 151.865 18.4478 151.712 18.504L145.507 20.7933C145.223 20.898 144.904 20.828 144.69 20.614L141.776 17.7001C141.562 17.4861 141.492 17.1671 141.597 16.8831L143.878 10.6988C143.942 10.5255 143.942 10.3351 143.878 10.1618L141.589 3.95802Z",
          className: "fill-current"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          d: "M162.985 16.8831C163.09 17.1671 163.02 17.486 162.806 17.7001L159.892 20.6139C159.678 20.828 159.359 20.898 159.075 20.7932L152.863 18.5109C152.71 18.4548 152.608 18.3094 152.608 18.1468V16.7866C152.608 16.6837 152.649 16.5851 152.722 16.5123L154.234 15.0002C154.341 14.8932 154.501 14.8582 154.643 14.9106L156.312 15.526L158.145 16.2026C158.3 16.2599 158.451 16.1089 158.394 15.9536L157.102 12.4509C157.05 12.3089 157.085 12.1494 157.192 12.0424L158.536 10.6984C158.688 10.5469 158.688 10.3013 158.536 10.1499L157.185 8.79842C157.078 8.6914 157.043 8.5319 157.095 8.38991L158.387 4.88752C158.444 4.73221 158.293 4.58118 158.138 4.63845L154.636 5.93052C154.494 5.98292 154.334 5.94791 154.227 5.8409L152.722 4.33592C152.649 4.2632 152.608 4.16452 152.608 4.06168V2.70105C152.608 2.5386 152.71 2.39338 152.862 2.33718L159.067 0.0479617C159.351 -0.0567914 159.67 0.0131841 159.884 0.227215L162.798 3.14107C163.012 3.3551 163.082 3.67408 162.978 3.95806L160.696 10.1424C160.632 10.3157 160.632 10.5061 160.696 10.6794L162.985 16.8831L162.985 16.8831Z",
          className: "fill-current"
        }
      )
    ]
  }
) }), Ts = () => /* @__PURE__ */ l("a", { href: "/", children: /* @__PURE__ */ b(
  "svg",
  {
    width: "41",
    height: "40",
    viewBox: "0 0 41 40",
    xmlns: "http://www.w3.org/2000/svg",
    className: "text-accent-primary",
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          d: "M0.0915035 7.59655C-0.108345 7.05153 0.0251545 6.43939 0.433423 6.02854L5.99194 0.436178C6.40027 0.0253318 7.00888 -0.10897 7.55065 0.0920797L19.4025 4.47256C19.6937 4.58019 19.8872 4.85915 19.8872 5.1713V7.78191C19.8872 7.97936 19.8093 8.16869 19.6705 8.30826L16.7857 11.2105C16.5815 11.4159 16.2773 11.4831 16.0064 11.3825L9.32443 8.90267C9.02814 8.79268 8.73993 9.08262 8.84926 9.38063L11.3143 16.1032C11.4143 16.3757 11.3475 16.6819 11.1433 16.8873L8.57869 19.4668C8.28967 19.7575 8.28967 20.2289 8.57869 20.5196L11.1569 23.1134C11.3611 23.3188 11.4279 23.6249 11.3279 23.8974L8.86283 30.6195C8.75356 30.9175 9.04171 31.2074 9.338 31.0975L16.0199 28.6176C16.2908 28.5171 16.5951 28.5843 16.7993 28.7897L19.6705 31.6781C19.8092 31.8177 19.8872 32.0071 19.8872 32.2045V34.8159C19.8872 35.1277 19.6941 35.4064 19.4034 35.5143L7.56477 39.9079C7.023 40.109 6.41445 39.9747 6.00612 39.5639L0.44705 33.9714C0.0387203 33.5606 -0.0947793 32.9484 0.105069 32.4034L4.45771 20.5339C4.57968 20.2013 4.57968 19.8359 4.45771 19.5033L0.0915035 7.59655Z",
          className: "fill-current"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          d: "M40.9085 32.4033C41.1083 32.9483 40.9748 33.5605 40.5666 33.9713L35.0081 39.5638C34.5997 39.9746 33.9912 40.1089 33.4494 39.9079L21.5975 35.5274C21.3063 35.4198 21.1128 35.1408 21.1128 34.8286V32.218C21.1128 32.0206 21.1907 31.8313 21.3295 31.6917L24.2143 28.7894C24.4185 28.5841 24.7227 28.5169 24.9936 28.6174L31.6756 31.0973C31.9719 31.2073 32.2601 30.9173 32.1507 30.6193L29.6856 23.8967C29.5857 23.6242 29.6525 23.3181 29.8567 23.1127L32.4213 20.5331C32.7103 20.2424 32.7103 19.7711 32.4213 19.4804L29.8431 16.8866C29.6389 16.6812 29.5721 16.375 29.6721 16.1025L32.1372 9.38048C32.2464 9.08241 31.9583 8.79253 31.662 8.90245L24.9801 11.3823C24.7092 11.4829 24.4049 11.4157 24.2007 11.2103L21.3295 8.32182C21.1908 8.18225 21.1128 7.99286 21.1128 7.79547V5.18405C21.1128 4.87227 21.3059 4.59356 21.5966 4.48568L33.4352 0.0920516C33.9769 -0.108998 34.5855 0.0253039 34.9938 0.436088L40.5529 6.02857C40.9612 6.43936 41.0947 7.05156 40.8949 7.59659L36.5422 19.466C36.4203 19.7986 36.4203 20.164 36.5422 20.4966L40.9085 32.4033Z",
          className: "fill-current"
        }
      )
    ]
  }
) }), Dd = () => /* @__PURE__ */ l("span", { className: "mx-2 inline-block h-[24px] w-auto", children: /* @__PURE__ */ l(Vs, {}) }), Rd = ({ children: e }) => /* @__PURE__ */ l("nav", { className: "flex items-center justify-center gap-5 lg:gap-14", children: e }), Bd = ({ title: e, href: t, onClick: r, isActive: n }) => /* @__PURE__ */ l(
  "a",
  {
    href: t,
    onClick: r,
    className: _(
      "flex h-10 w-fit items-center justify-center whitespace-nowrap text-center",
      n ? "text-accent-primary" : "text-accent-secondary"
    ),
    children: e
  }
);
function j1(e) {
  return we({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10h5v-2h-5c-4.34 0-8-3.66-8-8s3.66-8 8-8 8 3.66 8 8v1.43c0 .79-.71 1.57-1.5 1.57s-1.5-.78-1.5-1.57V12c0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5c1.38 0 2.64-.56 3.54-1.47.65.89 1.77 1.47 2.96 1.47 1.97 0 3.5-1.6 3.5-3.57V12c0-5.52-4.48-10-10-10zm0 13c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z" }, child: [] }] })(e);
}
function z1(e) {
  return we({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z" }, child: [] }] })(e);
}
function W1(e) {
  return we({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M21 8H3V4h18v4zm0 2H3v4h18v-4zm0 6H3v4h18v-4z" }, child: [] }] })(e);
}
function U1(e) {
  return we({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" }, child: [] }] })(e);
}
function Z1(e) {
  return we({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" }, child: [] }] })(e);
}
function q1(e) {
  return we({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0V0z" }, child: [] }, { tag: "path", attr: { d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" }, child: [] }] })(e);
}
const X1 = ({
  open: e,
  onClose: t,
  children: r
}) => e ? /* @__PURE__ */ b("div", { className: "fixed inset-0 z-50 flex flex-col bg-surface", children: [
  /* @__PURE__ */ b("div", { className: "container mx-auto flex h-20 items-center gap-4 px-4 sm:px-0", children: [
    /* @__PURE__ */ l(Ts, {}),
    /* @__PURE__ */ l(
      "button",
      {
        type: "button",
        "aria-label": "Close menu",
        onClick: t,
        className: "cursor-pointer text-accent-primary",
        children: /* @__PURE__ */ l(Z1, { size: 32 })
      }
    )
  ] }),
  /* @__PURE__ */ l("nav", { className: "container m-auto flex flex-col gap-9 px-4 pb-20 sm:px-0", children: r })
] }) : null, K1 = {
  sm: "mb-8",
  md: "mb-20",
  lg: "mb-32"
}, Fd = ({
  navigation: e,
  mobileNavigation: t,
  logo: r,
  mobileLogo: n,
  rightActions: i,
  className: o,
  showMobileMenu: s = !0,
  size: a = "md"
}) => {
  const c = jt(), [d, u] = G(!1);
  return /* @__PURE__ */ b("header", { className: le(K1[a], o), children: [
    /* @__PURE__ */ b(_s, { className: "relative flex h-20 items-center justify-between", children: [
      /* @__PURE__ */ l("div", { className: "flex items-center gap-4", children: c ? /* @__PURE__ */ b(Pe, { children: [
        n || /* @__PURE__ */ l(Ts, {}),
        s && t && /* @__PURE__ */ l(
          "button",
          {
            type: "button",
            "aria-label": "Open menu",
            className: "cursor-pointer text-accent-primary",
            onClick: () => u(!0),
            children: /* @__PURE__ */ l(q1, { size: 32 })
          }
        )
      ] }) : r || /* @__PURE__ */ l(Vs, {}) }),
      !c && e && /* @__PURE__ */ l("div", { className: "absolute left-1/2 -translate-x-1/2 transform", children: e }),
      /* @__PURE__ */ l("div", { className: "flex items-center gap-4", children: i })
    ] }),
    s && t && /* @__PURE__ */ l(
      X1,
      {
        open: c && d,
        onClose: () => u(!1),
        children: t
      }
    )
  ] });
};
function Y1(e) {
  return we({ attr: { fill: "currentColor", viewBox: "0 0 16 16" }, child: [{ tag: "path", attr: { d: "M13.545 2.907a13.2 13.2 0 0 0-3.257-1.011.05.05 0 0 0-.052.025c-.141.25-.297.577-.406.833a12.2 12.2 0 0 0-3.658 0 8 8 0 0 0-.412-.833.05.05 0 0 0-.052-.025c-1.125.194-2.22.534-3.257 1.011a.04.04 0 0 0-.021.018C.356 6.024-.213 9.047.066 12.032q.003.022.021.037a13.3 13.3 0 0 0 3.995 2.02.05.05 0 0 0 .056-.019q.463-.63.818-1.329a.05.05 0 0 0-.01-.059l-.018-.011a9 9 0 0 1-1.248-.595.05.05 0 0 1-.02-.066l.015-.019q.127-.095.248-.195a.05.05 0 0 1 .051-.007c2.619 1.196 5.454 1.196 8.041 0a.05.05 0 0 1 .053.007q.121.1.248.195a.05.05 0 0 1-.004.085 8 8 0 0 1-1.249.594.05.05 0 0 0-.03.03.05.05 0 0 0 .003.041c.24.465.515.909.817 1.329a.05.05 0 0 0 .056.019 13.2 13.2 0 0 0 4.001-2.02.05.05 0 0 0 .021-.037c.334-3.451-.559-6.449-2.366-9.106a.03.03 0 0 0-.02-.019m-8.198 7.307c-.789 0-1.438-.724-1.438-1.612s.637-1.613 1.438-1.613c.807 0 1.45.73 1.438 1.613 0 .888-.637 1.612-1.438 1.612m5.316 0c-.788 0-1.438-.724-1.438-1.612s.637-1.613 1.438-1.613c.807 0 1.451.73 1.438 1.613 0 .888-.631 1.612-1.438 1.612" }, child: [] }] })(e);
}
function G1(e) {
  return we({ attr: { fill: "currentColor", viewBox: "0 0 16 16" }, child: [{ tag: "path", attr: { d: "M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27s1.36.09 2 .27c1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.01 8.01 0 0 0 16 8c0-4.42-3.58-8-8-8" }, child: [] }] })(e);
}
function J1(e) {
  return we({ attr: { fill: "currentColor", viewBox: "0 0 16 16" }, child: [{ tag: "path", attr: { d: "M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z" }, child: [] }] })(e);
}
function Q1(e) {
  return we({ attr: { fill: "currentColor", viewBox: "0 0 16 16" }, child: [{ tag: "path", attr: { d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.287 5.906q-1.168.486-4.666 2.01-.567.225-.595.442c-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294q.39.01.868-.32 3.269-2.206 3.374-2.23c.05-.012.12-.026.166.016s.042.12.037.141c-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8 8 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629q.14.092.27.187c.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.4 1.4 0 0 0-.013-.315.34.34 0 0 0-.114-.217.53.53 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09" }, child: [] }] })(e);
}
function eu(e) {
  return we({ attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" }, child: [] }] })(e);
}
function tu(e) {
  return we({ attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z" }, child: [] }] })(e);
}
function ru(e) {
  return we({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M11.03 2.59a1.501 1.501 0 0 1 1.94 0l7.5 6.363a1.5 1.5 0 0 1 .53 1.144V19.5a1.5 1.5 0 0 1-1.5 1.5h-5.75a.75.75 0 0 1-.75-.75V14h-2v6.25a.75.75 0 0 1-.75.75H4.5A1.5 1.5 0 0 1 3 19.5v-9.403c0-.44.194-.859.53-1.144ZM12 3.734l-7.5 6.363V19.5h5v-6.25a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v6.25h5v-9.403Z" }, child: [] }] })(e);
}
function nu(e) {
  return we({ attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M426.2 80.4l-170.2 32-170.2-32C64 77 48 97.3 48 118v244.5c0 20.7 16 32.6 37.8 37.6L256 432l170.2-32c21.8-5 37.8-16.9 37.8-37.6V118c0-20.7-16-41-37.8-37.6zm0 282l-151.2 32V149.9l151.2-32v244.5zm-189.2 32l-151.2-32V118L237 150v244.4z" }, child: [] }] })(e);
}
const iu = [
  {
    name: "Website",
    url: "https://babylonlabs.io",
    Icon: ru
  },
  {
    name: "X",
    url: "https://x.com/babylonlabs_io",
    Icon: eu
  },
  {
    name: "GitHub",
    url: "https://github.com/babylonlabs-io",
    Icon: G1
  },
  {
    name: "Telegram",
    url: "https://t.me/babyloncommunity",
    Icon: Q1
  },
  {
    name: "LinkedIn",
    url: "https://www.linkedin.com/company/babylon-labs-official",
    Icon: J1
  },
  {
    name: "Docs",
    url: "https://docs.babylonlabs.io/",
    Icon: nu
  },
  {
    name: "Forum",
    url: "https://forum.babylon.foundation/",
    Icon: z1
  },
  {
    name: "Email",
    url: "mailto:contact@babylonlabs.io",
    Icon: j1
  },
  {
    name: "Discord",
    url: "https://discord.gg/babylonglobal",
    Icon: Y1
  }
], Hd = ({
  socialLinks: e = iu,
  logo: t,
  className: r,
  copyrightYear: n = (/* @__PURE__ */ new Date()).getFullYear()
}) => /* @__PURE__ */ l(
  "footer",
  {
    className: le(
      "relative mt-24 flex bg-primary-light py-10 text-accent-contrast before:absolute before:-top-2 before:left-1/4 before:h-3 before:w-2/3 before:bg-primary-light dark:bg-primary-main dark:before:bg-primary-main md:py-20",
      r
    ),
    children: /* @__PURE__ */ b(_s, { className: "flex flex-col items-center md:flex-row-reverse md:items-start md:justify-between", children: [
      t || /* @__PURE__ */ l(P1, { className: "h-[61px] w-[250px] lg:h-[90px] lg:w-[367px]" }),
      /* @__PURE__ */ b("div", { className: "mt-10 md:mt-0", children: [
        /* @__PURE__ */ l("div", { className: "mb:pt-0 flex flex-wrap justify-center gap-x-5 gap-y-8 pb-10 pt-2 md:justify-start md:pb-8", children: e.map(({ name: i, url: o, Icon: s }) => /* @__PURE__ */ l(
          "a",
          {
            href: o,
            target: "_blank",
            rel: "noopener noreferrer",
            className: "transition-colors hover:text-secondary-main",
            children: /* @__PURE__ */ l(s, { size: 28, title: i })
          },
          i
        )) }),
        /* @__PURE__ */ b(Z, { variant: "body2", className: "text-center md:text-left", children: [
          /* @__PURE__ */ l(
            "a",
            {
              href: "https://babylonlabs.io/terms-of-use",
              target: "_blank",
              rel: "noopener noreferrer",
              className: "transition-colors hover:text-secondary-main",
              children: "Terms of Use"
            }
          ),
          " ",
          "-",
          " ",
          /* @__PURE__ */ l(
            "a",
            {
              href: "https://babylonlabs.io/privacy-policy",
              target: "_blank",
              rel: "noopener noreferrer",
              className: "transition-colors hover:text-secondary-main",
              children: "Privacy Policy"
            }
          ),
          " ",
          "- ",
          n,
          " Babylon Labs. All rights reserved."
        ] })
      ] })
    ] })
  }
), Id = ({
  loading: e = !1,
  connected: t = !1,
  onClick: r,
  text: n = "Connect",
  loadingText: i = "Loading...",
  className: o,
  disabled: s = !1
}) => t ? null : /* @__PURE__ */ b(
  Me,
  {
    size: "large",
    className: o || "h-[2.5rem] min-h-[2.5rem] rounded-full px-6 py-2 text-base text-white md:rounded",
    onClick: r,
    color: "secondary",
    disabled: s || e,
    "data-testid": "connect-wallet-button",
    children: [
      /* @__PURE__ */ l(B1, { size: 20, className: "flex md:hidden" }),
      /* @__PURE__ */ l("span", { className: "hidden md:flex", children: e ? i : n })
    ]
  }
), ou = {
  lg: {
    logo: "size-10",
    badge: "!min-w-5 !h-5",
    badgeText: "!text-xs"
  },
  md: {
    logo: "size-6",
    badge: "!min-w-4 !h-4 !px-0.5",
    badgeText: "!text-[10px]"
  },
  sm: {
    logo: "size-5",
    badge: "!min-w-3 !h-3 !px-0.5",
    badgeText: "!text-[8px]"
  }
}, Co = ({ logoUrl: e, rank: t, moniker: r, size: n = "md", className: i }) => {
  const [o, s] = G(!1), a = ou[n], c = typeof t == "number" && !Number.isNaN(t), d = (r == null ? void 0 : r.charAt(0).toUpperCase()) ?? (c ? String(t) : "?");
  return /* @__PURE__ */ l(
    Sc,
    {
      count: c ? t : void 0,
      position: "bottom-right",
      color: "secondary",
      className: le(a.logo, i),
      badgeClassName: le("border border-accent-contrast overflow-hidden", a.badge),
      contentClassName: a.badgeText,
      max: 99,
      children: e && !o ? /* @__PURE__ */ l(
        "img",
        {
          src: e,
          alt: r || (c ? `Finality Provider ${t}` : "Finality Provider"),
          className: "h-full w-full rounded-full object-cover",
          onError: () => s(!0)
        }
      ) : /* @__PURE__ */ l(
        Z,
        {
          as: "span",
          className: "inline-flex h-full w-full items-center justify-center rounded-full bg-secondary-main text-[1rem] text-accent-contrast",
          children: d
        }
      )
    }
  );
};
function Ms({ bsnId: e, bsnName: t, bsnLogoUrl: r, address: n, provider: i, onRemove: o, showChain: s = !0 }) {
  var h;
  if (!i) return null;
  const a = (h = i.description) == null ? void 0 : h.moniker, c = (t == null ? void 0 : t.charAt(0).toUpperCase()) || "?", d = (m) => !m || m.length <= 12 ? m : `${m.slice(0, 6)}...${m.slice(-6)}`, u = () => /* @__PURE__ */ b("div", { className: "flex items-center text-xs text-accent-secondary", children: [
    /* @__PURE__ */ l(
      Co,
      {
        logoUrl: i.logo_url,
        rank: i.rank,
        moniker: a,
        size: "sm",
        className: "mr-1"
      }
    ),
    a
  ] }), f = () => s ? n ? /* @__PURE__ */ b(Z, { as: "div", className: "flex items-center gap-1 text-base font-medium text-accent-primary", children: [
    d(n),
    /* @__PURE__ */ l(us, { value: n, className: "cursor-pointer", copiedText: "✓", children: /* @__PURE__ */ l(Ln, { size: 12 }) })
  ] }) : /* @__PURE__ */ l(Z, { as: "div", className: "text-base font-medium text-accent-primary", children: t }) : /* @__PURE__ */ l(Z, { as: "div", className: "text-base font-medium text-accent-primary", children: a });
  return /* @__PURE__ */ b("div", { className: "flex flex-row items-center justify-between", children: [
    /* @__PURE__ */ b("div", { className: "flex h-10 flex-row gap-2", children: [
      /* @__PURE__ */ l("div", { className: "shrink-0", children: s ? r ? /* @__PURE__ */ l(Jt, { url: r, alt: t, variant: "rounded", size: "large" }) : /* @__PURE__ */ l(Jt, { variant: "rounded", size: "large", children: /* @__PURE__ */ l(
        Z,
        {
          as: "span",
          className: "inline-flex h-full w-full items-center justify-center bg-secondary-main text-xs text-accent-contrast",
          children: c
        }
      ) }) : /* @__PURE__ */ l(
        Co,
        {
          logoUrl: i.logo_url,
          rank: i.rank,
          moniker: a,
          size: "lg"
        }
      ) }),
      /* @__PURE__ */ b("div", { className: "flex flex-col justify-center text-accent-primary", children: [
        s && u(),
        f()
      ] })
    ] }),
    o ? /* @__PURE__ */ l(
      "button",
      {
        onClick: () => o(e),
        className: "ml-[10px] flex items-center justify-center cursor-pointer p-1",
        children: /* @__PURE__ */ l(An, { size: 12 })
      }
    ) : null
  ] });
}
const No = {
  active: "bg-success-main",
  pending: "bg-warning-main",
  inactive: "bg-accent-disabled",
  warning: "bg-accent-disabled",
  default: "bg-info-main"
};
function $d({
  status: e,
  label: t,
  className: r = ""
}) {
  const n = t || e.charAt(0).toUpperCase() + e.slice(1);
  return /* @__PURE__ */ b(
    "span",
    {
      className: `inline-flex items-center gap-2 ${r}`,
      children: [
        /* @__PURE__ */ l(
          "span",
          {
            className: `w-2 h-2 rounded-full flex-shrink-0 ${No[e] || No.default}`
          }
        ),
        /* @__PURE__ */ l("span", { className: "text-sm text-accent-primary font-normal", children: n })
      ]
    }
  );
}
function Pd({
  id: e,
  title: t,
  details: r,
  actions: n = [],
  onAction: i
}) {
  return /* @__PURE__ */ b(gc, { className: "flex flex-col p-4", children: [
    /* @__PURE__ */ b("div", { className: "flex items-center justify-between pb-3", children: [
      /* @__PURE__ */ b("div", { className: "flex items-center gap-2", children: [
        t.icons.length > 0 && /* @__PURE__ */ l(pa, { size: "small", children: t.icons.map((o, s) => /* @__PURE__ */ l(
          Jt,
          {
            url: o,
            alt: `Icon ${s + 1}`,
            size: "small",
            variant: "circular"
          },
          s
        )) }),
        /* @__PURE__ */ l("span", { className: "text-base font-semibold text-accent-primary", children: t.text })
      ] }),
      n.length > 0 && /* @__PURE__ */ l(
        xi,
        {
          trigger: /* @__PURE__ */ l(
            "button",
            {
              className: "rounded p-1 hover:bg-surface-secondary",
              "aria-label": "Actions",
              children: /* @__PURE__ */ l(ec, { size: 20, variant: "accent-primary" })
            }
          ),
          placement: "bottom-end",
          children: n.map((o) => /* @__PURE__ */ l(
            vs,
            {
              name: o.name,
              onClick: () => i == null ? void 0 : i(e, o.action)
            },
            o.action
          ))
        }
      )
    ] }),
    /* @__PURE__ */ l("div", { className: "border-t border-surface-secondary mb-3" }),
    /* @__PURE__ */ l("div", { className: "flex flex-col gap-3", children: r.map((o, s) => /* @__PURE__ */ b("div", { className: "flex items-start justify-between gap-4", children: [
      /* @__PURE__ */ l("span", { className: "text-xs text-accent-secondary whitespace-nowrap", children: o.label }),
      /* @__PURE__ */ l("div", { className: "flex-1 flex justify-end text-right", children: typeof o.value == "string" ? /* @__PURE__ */ l("span", { className: "text-sm text-accent-primary", children: o.value }) : o.value })
    ] }, s)) })
  ] });
}
function su(e) {
  const t = e.match(/^(.*?)([MKB])$/);
  return t ? { value: t[1], unit: t[2] } : { value: e, unit: "" };
}
function jd({ title: e, amount: t, subtitle: r }) {
  const { value: n, unit: i } = su(t);
  return /* @__PURE__ */ b("div", { className: "flex flex-col gap-[2px]", children: [
    /* @__PURE__ */ l("p", { className: "text-[12px] font-normal text-accent-secondary", style: { letterSpacing: "0.4px" }, children: e }),
    /* @__PURE__ */ b("div", { className: "flex items-baseline gap-0.5", children: [
      /* @__PURE__ */ l("span", { className: "text-[24px] font-normal text-accent-primary", children: n }),
      i && /* @__PURE__ */ l("span", { className: "text-[24px] font-normal text-accent-secondary", children: i })
    ] }),
    r && /* @__PURE__ */ l("p", { className: "text-[14px] font-normal text-accent-primary", children: r })
  ] });
}
function zd({
  id: e,
  name: t,
  icon: r,
  isSelected: n,
  onToggle: i,
  className: o
}) {
  return /* @__PURE__ */ b("div", { className: le(
    "flex items-center justify-between p-4 rounded-lg bg-secondary-highlight dark:bg-primary-main",
    o
  ), children: [
    /* @__PURE__ */ b("div", { className: "flex items-center gap-3", children: [
      r && /* @__PURE__ */ l("div", { className: "flex h-10 w-10 items-center justify-center overflow-hidden rounded-full bg-primary-main", children: r }),
      /* @__PURE__ */ l(Z, { variant: "body1", className: "text-lg font-medium text-accent-primary", children: t })
    ] }),
    /* @__PURE__ */ l(
      Me,
      {
        size: "small",
        variant: n ? "contained" : "outlined",
        color: "primary",
        rounded: !0,
        onClick: () => i(e),
        className: "min-w-[100px] text-sm",
        children: n ? "Selected" : "Select"
      }
    )
  ] });
}
var Qr = (e) => e.type === "checkbox", Xt = (e) => e instanceof Date, We = (e) => e == null;
const Ds = (e) => typeof e == "object";
var Le = (e) => !We(e) && !Array.isArray(e) && Ds(e) && !Xt(e), Rs = (e) => Le(e) && e.target ? Qr(e.target) ? e.target.checked : e.target.value : e, au = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, Bs = (e, t) => e.has(au(t)), lu = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return Le(t) && t.hasOwnProperty("isPrototypeOf");
}, Ei = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Ze(e) {
  let t;
  const r = Array.isArray(e), n = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    t = new Date(e);
  else if (e instanceof Set)
    t = new Set(e);
  else if (!(Ei && (e instanceof Blob || n)) && (r || Le(e)))
    if (t = r ? [] : {}, !r && !lu(e))
      t = e;
    else
      for (const i in e)
        e.hasOwnProperty(i) && (t[i] = Ze(e[i]));
  else
    return e;
  return t;
}
var Bn = (e) => Array.isArray(e) ? e.filter(Boolean) : [], ke = (e) => e === void 0, B = (e, t, r) => {
  if (!t || !Le(e))
    return r;
  const n = Bn(t.split(/[,[\].]+?/)).reduce((i, o) => We(i) ? i : i[o], e);
  return ke(n) || n === e ? ke(e[t]) ? r : e[t] : n;
}, Qe = (e) => typeof e == "boolean", Oi = (e) => /^\w*$/.test(e), Fs = (e) => Bn(e.replace(/["|']|\]/g, "").split(/\.|\[/)), ue = (e, t, r) => {
  let n = -1;
  const i = Oi(t) ? [t] : Fs(t), o = i.length, s = o - 1;
  for (; ++n < o; ) {
    const a = i[n];
    let c = r;
    if (n !== s) {
      const d = e[a];
      c = Le(d) || Array.isArray(d) ? d : isNaN(+i[n + 1]) ? {} : [];
    }
    if (a === "__proto__" || a === "constructor" || a === "prototype")
      return;
    e[a] = c, e = e[a];
  }
  return e;
};
const mn = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, ht = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Tt = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, Hs = q.createContext(null), Cr = () => q.useContext(Hs), cu = (e) => {
  const { children: t, ...r } = e;
  return q.createElement(Hs.Provider, { value: r }, t);
};
var Is = (e, t, r, n = !0) => {
  const i = {
    defaultValues: t._defaultValues
  };
  for (const o in e)
    Object.defineProperty(i, o, {
      get: () => {
        const s = o;
        return t._proxyFormState[s] !== ht.all && (t._proxyFormState[s] = !n || ht.all), r && (r[s] = !0), e[s];
      }
    });
  return i;
}, qe = (e) => Le(e) && !Object.keys(e).length, $s = (e, t, r, n) => {
  r(e);
  const { name: i, ...o } = e;
  return qe(o) || Object.keys(o).length >= Object.keys(t).length || Object.keys(o).find((s) => t[s] === (!n || ht.all));
}, Br = (e) => Array.isArray(e) ? e : [e], Ps = (e, t, r) => !e || !t || e === t || Br(e).some((n) => n && (r ? n === t : n.startsWith(t) || t.startsWith(n)));
function _i(e) {
  const t = q.useRef(e);
  t.current = e, q.useEffect(() => {
    const r = !e.disabled && t.current.subject && t.current.subject.subscribe({
      next: t.current.next
    });
    return () => {
      r && r.unsubscribe();
    };
  }, [e.disabled]);
}
function js(e) {
  const t = Cr(), { control: r = t.control, disabled: n, name: i, exact: o } = e || {}, [s, a] = q.useState(r._formState), c = q.useRef(!0), d = q.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), u = q.useRef(i);
  return u.current = i, _i({
    disabled: n,
    next: (f) => c.current && Ps(u.current, f.name, o) && $s(f, d.current, r._updateFormState) && a({
      ...r._formState,
      ...f
    }),
    subject: r._subjects.state
  }), q.useEffect(() => (c.current = !0, d.current.isValid && r._updateValid(!0), () => {
    c.current = !1;
  }), [r]), q.useMemo(() => Is(s, r, d.current, !1), [s, r]);
}
var xt = (e) => typeof e == "string", zs = (e, t, r, n, i) => xt(e) ? (n && t.watch.add(e), B(r, e, i)) : Array.isArray(e) ? e.map((o) => (n && t.watch.add(o), B(r, o))) : (n && (t.watchAll = !0), r);
function Ws(e) {
  const t = Cr(), { control: r = t.control, name: n, defaultValue: i, disabled: o, exact: s } = e || {}, a = q.useRef(n);
  a.current = n, _i({
    disabled: o,
    subject: r._subjects.values,
    next: (u) => {
      Ps(a.current, u.name, s) && d(Ze(zs(a.current, r._names, u.values || r._formValues, !1, i)));
    }
  });
  const [c, d] = q.useState(r._getWatch(n, i));
  return q.useEffect(() => r._removeUnmounted()), c;
}
function uu(e) {
  const t = Cr(), { name: r, disabled: n, control: i = t.control, shouldUnregister: o } = e, s = Bs(i._names.array, r), a = Ws({
    control: i,
    name: r,
    defaultValue: B(i._formValues, r, B(i._defaultValues, r, e.defaultValue)),
    exact: !0
  }), c = js({
    control: i,
    name: r,
    exact: !0
  }), d = q.useRef(i.register(r, {
    ...e.rules,
    value: a,
    ...Qe(e.disabled) ? { disabled: e.disabled } : {}
  })), u = q.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!B(c.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!B(c.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!B(c.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!B(c.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => B(c.errors, r)
    }
  }), [c, r]), f = q.useMemo(() => ({
    name: r,
    value: a,
    ...Qe(n) || c.disabled ? { disabled: c.disabled || n } : {},
    onChange: (p) => d.current.onChange({
      target: {
        value: Rs(p),
        name: r
      },
      type: mn.CHANGE
    }),
    onBlur: () => d.current.onBlur({
      target: {
        value: B(i._formValues, r),
        name: r
      },
      type: mn.BLUR
    }),
    ref: (p) => {
      const h = B(i._fields, r);
      h && p && (h._f.ref = {
        focus: () => p.focus(),
        select: () => p.select(),
        setCustomValidity: (m) => p.setCustomValidity(m),
        reportValidity: () => p.reportValidity()
      });
    }
  }), [
    r,
    i._formValues,
    n,
    c.disabled,
    a,
    i._fields
  ]);
  return q.useEffect(() => {
    const p = i._options.shouldUnregister || o, h = (m, g) => {
      const y = B(i._fields, m);
      y && y._f && (y._f.mount = g);
    };
    if (h(r, !0), p) {
      const m = Ze(B(i._options.defaultValues, r));
      ue(i._defaultValues, r, m), ke(B(i._formValues, r)) && ue(i._formValues, r, m);
    }
    return () => {
      (s ? p && !i._state.action : p) ? i.unregister(r) : h(r, !1);
    };
  }, [r, i, s, o]), q.useEffect(() => {
    Qe(n) && B(i._fields, r) && i._updateDisabledField({
      disabled: n,
      fields: i._fields,
      name: r,
      value: B(i._fields, r)._f.value
    });
  }, [n, r, i]), q.useMemo(() => ({
    field: f,
    formState: c,
    fieldState: u
  }), [f, c, u]);
}
var Us = (e, t, r, n, i) => t ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [n]: i || !0
  }
} : {}, ko = (e) => ({
  isOnSubmit: !e || e === ht.onSubmit,
  isOnBlur: e === ht.onBlur,
  isOnChange: e === ht.onChange,
  isOnAll: e === ht.all,
  isOnTouch: e === ht.onTouched
}), So = (e, t, r) => !r && (t.watchAll || t.watch.has(e) || [...t.watch].some((n) => e.startsWith(n) && /^\.\w+/.test(e.slice(n.length))));
const Fr = (e, t, r, n) => {
  for (const i of r || Object.keys(e)) {
    const o = B(e, i);
    if (o) {
      const { _f: s, ...a } = o;
      if (s) {
        if (s.refs && s.refs[0] && t(s.refs[0], i) && !n)
          return !0;
        if (s.ref && t(s.ref, s.name) && !n)
          return !0;
        if (Fr(a, t))
          break;
      } else if (Le(a) && Fr(a, t))
        break;
    }
  }
};
var du = (e, t, r) => {
  const n = Br(B(e, r));
  return ue(n, "root", t[r]), ue(e, r, n), e;
}, Vi = (e) => e.type === "file", wt = (e) => typeof e == "function", pn = (e) => {
  if (!Ei)
    return !1;
  const t = e ? e.ownerDocument : 0;
  return e instanceof (t && t.defaultView ? t.defaultView.HTMLElement : HTMLElement);
}, an = (e) => xt(e), Ti = (e) => e.type === "radio", vn = (e) => e instanceof RegExp;
const Lo = {
  value: !1,
  isValid: !1
}, Ao = { value: !0, isValid: !0 };
var Zs = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const t = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: t, isValid: !!t.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !ke(e[0].attributes.value) ? ke(e[0].value) || e[0].value === "" ? Ao : { value: e[0].value, isValid: !0 } : Ao
    ) : Lo;
  }
  return Lo;
};
const Eo = {
  isValid: !1,
  value: null
};
var qs = (e) => Array.isArray(e) ? e.reduce((t, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : t, Eo) : Eo;
function Oo(e, t, r = "validate") {
  if (an(e) || Array.isArray(e) && e.every(an) || Qe(e) && !e)
    return {
      type: r,
      message: an(e) ? e : "",
      ref: t
    };
}
var fr = (e) => Le(e) && !vn(e) ? e : {
  value: e,
  message: ""
}, _o = async (e, t, r, n, i) => {
  const { ref: o, refs: s, required: a, maxLength: c, minLength: d, min: u, max: f, pattern: p, validate: h, name: m, valueAsNumber: g, mount: y, disabled: A } = e._f, w = B(t, m);
  if (!y || A)
    return {};
  const L = s ? s[0] : o, N = (O) => {
    n && L.reportValidity && (L.setCustomValidity(Qe(O) ? "" : O || ""), L.reportValidity());
  }, k = {}, S = Ti(o), E = Qr(o), V = S || E, I = (g || Vi(o)) && ke(o.value) && ke(w) || pn(o) && o.value === "" || w === "" || Array.isArray(w) && !w.length, H = Us.bind(null, m, r, k), W = (O, T, $, X = Tt.maxLength, K = Tt.minLength) => {
    const U = O ? T : $;
    k[m] = {
      type: O ? X : K,
      message: U,
      ref: o,
      ...H(O ? X : K, U)
    };
  };
  if (i ? !Array.isArray(w) || !w.length : a && (!V && (I || We(w)) || Qe(w) && !w || E && !Zs(s).isValid || S && !qs(s).isValid)) {
    const { value: O, message: T } = an(a) ? { value: !!a, message: a } : fr(a);
    if (O && (k[m] = {
      type: Tt.required,
      message: T,
      ref: L,
      ...H(Tt.required, T)
    }, !r))
      return N(T), k;
  }
  if (!I && (!We(u) || !We(f))) {
    let O, T;
    const $ = fr(f), X = fr(u);
    if (!We(w) && !isNaN(w)) {
      const K = o.valueAsNumber || w && +w;
      We($.value) || (O = K > $.value), We(X.value) || (T = K < X.value);
    } else {
      const K = o.valueAsDate || new Date(w), U = (oe) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + oe), te = o.type == "time", ie = o.type == "week";
      xt($.value) && w && (O = te ? U(w) > U($.value) : ie ? w > $.value : K > new Date($.value)), xt(X.value) && w && (T = te ? U(w) < U(X.value) : ie ? w < X.value : K < new Date(X.value));
    }
    if ((O || T) && (W(!!O, $.message, X.message, Tt.max, Tt.min), !r))
      return N(k[m].message), k;
  }
  if ((c || d) && !I && (xt(w) || i && Array.isArray(w))) {
    const O = fr(c), T = fr(d), $ = !We(O.value) && w.length > +O.value, X = !We(T.value) && w.length < +T.value;
    if (($ || X) && (W($, O.message, T.message), !r))
      return N(k[m].message), k;
  }
  if (p && !I && xt(w)) {
    const { value: O, message: T } = fr(p);
    if (vn(O) && !w.match(O) && (k[m] = {
      type: Tt.pattern,
      message: T,
      ref: o,
      ...H(Tt.pattern, T)
    }, !r))
      return N(T), k;
  }
  if (h) {
    if (wt(h)) {
      const O = await h(w, t), T = Oo(O, L);
      if (T && (k[m] = {
        ...T,
        ...H(Tt.validate, T.message)
      }, !r))
        return N(T.message), k;
    } else if (Le(h)) {
      let O = {};
      for (const T in h) {
        if (!qe(O) && !r)
          break;
        const $ = Oo(await h[T](w, t), L, T);
        $ && (O = {
          ...$,
          ...H(T, $.message)
        }, N($.message), r && (k[m] = O));
      }
      if (!qe(O) && (k[m] = {
        ref: L,
        ...O
      }, !r))
        return k;
    }
  }
  return N(!0), k;
};
function fu(e, t) {
  const r = t.slice(0, -1).length;
  let n = 0;
  for (; n < r; )
    e = ke(e) ? n++ : e[t[n++]];
  return e;
}
function hu(e) {
  for (const t in e)
    if (e.hasOwnProperty(t) && !ke(e[t]))
      return !1;
  return !0;
}
function Ve(e, t) {
  const r = Array.isArray(t) ? t : Oi(t) ? [t] : Fs(t), n = r.length === 1 ? e : fu(e, r), i = r.length - 1, o = r[i];
  return n && delete n[o], i !== 0 && (Le(n) && qe(n) || Array.isArray(n) && hu(n)) && Ve(e, r.slice(0, -1)), e;
}
var Un = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (i) => {
      for (const o of e)
        o.next && o.next(i);
    },
    subscribe: (i) => (e.push(i), {
      unsubscribe: () => {
        e = e.filter((o) => o !== i);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, ii = (e) => We(e) || !Ds(e);
function Ht(e, t) {
  if (ii(e) || ii(t))
    return e === t;
  if (Xt(e) && Xt(t))
    return e.getTime() === t.getTime();
  const r = Object.keys(e), n = Object.keys(t);
  if (r.length !== n.length)
    return !1;
  for (const i of r) {
    const o = e[i];
    if (!n.includes(i))
      return !1;
    if (i !== "ref") {
      const s = t[i];
      if (Xt(o) && Xt(s) || Le(o) && Le(s) || Array.isArray(o) && Array.isArray(s) ? !Ht(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Xs = (e) => e.type === "select-multiple", mu = (e) => Ti(e) || Qr(e), Zn = (e) => pn(e) && e.isConnected, Ks = (e) => {
  for (const t in e)
    if (wt(e[t]))
      return !0;
  return !1;
};
function gn(e, t = {}) {
  const r = Array.isArray(e);
  if (Le(e) || r)
    for (const n in e)
      Array.isArray(e[n]) || Le(e[n]) && !Ks(e[n]) ? (t[n] = Array.isArray(e[n]) ? [] : {}, gn(e[n], t[n])) : We(e[n]) || (t[n] = !0);
  return t;
}
function Ys(e, t, r) {
  const n = Array.isArray(e);
  if (Le(e) || n)
    for (const i in e)
      Array.isArray(e[i]) || Le(e[i]) && !Ks(e[i]) ? ke(t) || ii(r[i]) ? r[i] = Array.isArray(e[i]) ? gn(e[i], []) : { ...gn(e[i]) } : Ys(e[i], We(t) ? {} : t[i], r[i]) : r[i] = !Ht(e[i], t[i]);
  return r;
}
var Vr = (e, t) => Ys(e, t, gn(t)), Gs = (e, { valueAsNumber: t, valueAsDate: r, setValueAs: n }) => ke(e) ? e : t ? e === "" ? NaN : e && +e : r && xt(e) ? new Date(e) : n ? n(e) : e;
function qn(e) {
  const t = e.ref;
  if (!(e.refs ? e.refs.every((r) => r.disabled) : t.disabled))
    return Vi(t) ? t.files : Ti(t) ? qs(e.refs).value : Xs(t) ? [...t.selectedOptions].map(({ value: r }) => r) : Qr(t) ? Zs(e.refs).value : Gs(ke(t.value) ? e.ref.value : t.value, e);
}
var pu = (e, t, r, n) => {
  const i = {};
  for (const o of e) {
    const s = B(t, o);
    s && ue(i, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: i,
    shouldUseNativeValidation: n
  };
}, Tr = (e) => ke(e) ? e : vn(e) ? e.source : Le(e) ? vn(e.value) ? e.value.source : e.value : e;
const Vo = "AsyncFunction";
var vu = (e) => !!e && !!e.validate && !!(wt(e.validate) && e.validate.constructor.name === Vo || Le(e.validate) && Object.values(e.validate).find((t) => t.constructor.name === Vo)), gu = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate);
function To(e, t, r) {
  const n = B(e, r);
  if (n || Oi(r))
    return {
      error: n,
      name: r
    };
  const i = r.split(".");
  for (; i.length; ) {
    const o = i.join("."), s = B(t, o), a = B(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (a && a.type)
      return {
        name: o,
        error: a
      };
    i.pop();
  }
  return {
    name: r
  };
}
var bu = (e, t, r, n, i) => i.isOnAll ? !1 : !r && i.isOnTouch ? !(t || e) : (r ? n.isOnBlur : i.isOnBlur) ? !e : (r ? n.isOnChange : i.isOnChange) ? e : !0, yu = (e, t) => !Bn(B(e, t)).length && Ve(e, t);
const wu = {
  mode: ht.onSubmit,
  reValidateMode: ht.onChange,
  shouldFocusError: !0
};
function xu(e = {}) {
  let t = {
    ...wu,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: wt(t.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: t.errors || {},
    disabled: t.disabled || !1
  }, n = {}, i = Le(t.defaultValues) || Le(t.values) ? Ze(t.defaultValues || t.values) || {} : {}, o = t.shouldUnregister ? {} : Ze(i), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, a = {
    mount: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, c, d = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, f = {
    values: Un(),
    array: Un(),
    state: Un()
  }, p = ko(t.mode), h = ko(t.reValidateMode), m = t.criteriaMode === ht.all, g = (v) => (x) => {
    clearTimeout(d), d = setTimeout(v, x);
  }, y = async (v) => {
    if (!t.disabled && (u.isValid || v)) {
      const x = t.resolver ? qe((await V()).errors) : await H(n, !0);
      x !== r.isValid && f.state.next({
        isValid: x
      });
    }
  }, A = (v, x) => {
    !t.disabled && (u.isValidating || u.validatingFields) && ((v || Array.from(a.mount)).forEach((C) => {
      C && (x ? ue(r.validatingFields, C, x) : Ve(r.validatingFields, C));
    }), f.state.next({
      validatingFields: r.validatingFields,
      isValidating: !qe(r.validatingFields)
    }));
  }, w = (v, x = [], C, R, D = !0, M = !0) => {
    if (R && C && !t.disabled) {
      if (s.action = !0, M && Array.isArray(B(n, v))) {
        const z = C(B(n, v), R.argA, R.argB);
        D && ue(n, v, z);
      }
      if (M && Array.isArray(B(r.errors, v))) {
        const z = C(B(r.errors, v), R.argA, R.argB);
        D && ue(r.errors, v, z), yu(r.errors, v);
      }
      if (u.touchedFields && M && Array.isArray(B(r.touchedFields, v))) {
        const z = C(B(r.touchedFields, v), R.argA, R.argB);
        D && ue(r.touchedFields, v, z);
      }
      u.dirtyFields && (r.dirtyFields = Vr(i, o)), f.state.next({
        name: v,
        isDirty: O(v, x),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      ue(o, v, x);
  }, L = (v, x) => {
    ue(r.errors, v, x), f.state.next({
      errors: r.errors
    });
  }, N = (v) => {
    r.errors = v, f.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, k = (v, x, C, R) => {
    const D = B(n, v);
    if (D) {
      const M = B(o, v, ke(C) ? B(i, v) : C);
      ke(M) || R && R.defaultChecked || x ? ue(o, v, x ? M : qn(D._f)) : X(v, M), s.mount && y();
    }
  }, S = (v, x, C, R, D) => {
    let M = !1, z = !1;
    const ee = {
      name: v
    };
    if (!t.disabled) {
      const he = !!(B(n, v) && B(n, v)._f && B(n, v)._f.disabled);
      if (!C || R) {
        u.isDirty && (z = r.isDirty, r.isDirty = ee.isDirty = O(), M = z !== ee.isDirty);
        const ce = he || Ht(B(i, v), x);
        z = !!(!he && B(r.dirtyFields, v)), ce || he ? Ve(r.dirtyFields, v) : ue(r.dirtyFields, v, !0), ee.dirtyFields = r.dirtyFields, M = M || u.dirtyFields && z !== !ce;
      }
      if (C) {
        const ce = B(r.touchedFields, v);
        ce || (ue(r.touchedFields, v, C), ee.touchedFields = r.touchedFields, M = M || u.touchedFields && ce !== C);
      }
      M && D && f.state.next(ee);
    }
    return M ? ee : {};
  }, E = (v, x, C, R) => {
    const D = B(r.errors, v), M = u.isValid && Qe(x) && r.isValid !== x;
    if (t.delayError && C ? (c = g(() => L(v, C)), c(t.delayError)) : (clearTimeout(d), c = null, C ? ue(r.errors, v, C) : Ve(r.errors, v)), (C ? !Ht(D, C) : D) || !qe(R) || M) {
      const z = {
        ...R,
        ...M && Qe(x) ? { isValid: x } : {},
        errors: r.errors,
        name: v
      };
      r = {
        ...r,
        ...z
      }, f.state.next(z);
    }
  }, V = async (v) => {
    A(v, !0);
    const x = await t.resolver(o, t.context, pu(v || a.mount, n, t.criteriaMode, t.shouldUseNativeValidation));
    return A(v), x;
  }, I = async (v) => {
    const { errors: x } = await V(v);
    if (v)
      for (const C of v) {
        const R = B(x, C);
        R ? ue(r.errors, C, R) : Ve(r.errors, C);
      }
    else
      r.errors = x;
    return x;
  }, H = async (v, x, C = {
    valid: !0
  }) => {
    for (const R in v) {
      const D = v[R];
      if (D) {
        const { _f: M, ...z } = D;
        if (M) {
          const ee = a.array.has(M.name), he = D._f && vu(D._f);
          he && u.validatingFields && A([R], !0);
          const ce = await _o(D, o, m, t.shouldUseNativeValidation && !x, ee);
          if (he && u.validatingFields && A([R]), ce[M.name] && (C.valid = !1, x))
            break;
          !x && (B(ce, M.name) ? ee ? du(r.errors, ce, M.name) : ue(r.errors, M.name, ce[M.name]) : Ve(r.errors, M.name));
        }
        !qe(z) && await H(z, x, C);
      }
    }
    return C.valid;
  }, W = () => {
    for (const v of a.unMount) {
      const x = B(n, v);
      x && (x._f.refs ? x._f.refs.every((C) => !Zn(C)) : !Zn(x._f.ref)) && xe(v);
    }
    a.unMount = /* @__PURE__ */ new Set();
  }, O = (v, x) => !t.disabled && (v && x && ue(o, v, x), !Ht(se(), i)), T = (v, x, C) => zs(v, a, {
    ...s.mount ? o : ke(x) ? i : xt(v) ? { [v]: x } : x
  }, C, x), $ = (v) => Bn(B(s.mount ? o : i, v, t.shouldUnregister ? B(i, v, []) : [])), X = (v, x, C = {}) => {
    const R = B(n, v);
    let D = x;
    if (R) {
      const M = R._f;
      M && (!M.disabled && ue(o, v, Gs(x, M)), D = pn(M.ref) && We(x) ? "" : x, Xs(M.ref) ? [...M.ref.options].forEach((z) => z.selected = D.includes(z.value)) : M.refs ? Qr(M.ref) ? M.refs.length > 1 ? M.refs.forEach((z) => (!z.defaultChecked || !z.disabled) && (z.checked = Array.isArray(D) ? !!D.find((ee) => ee === z.value) : D === z.value)) : M.refs[0] && (M.refs[0].checked = !!D) : M.refs.forEach((z) => z.checked = z.value === D) : Vi(M.ref) ? M.ref.value = "" : (M.ref.value = D, M.ref.type || f.values.next({
        name: v,
        values: { ...o }
      })));
    }
    (C.shouldDirty || C.shouldTouch) && S(v, D, C.shouldTouch, C.shouldDirty, !0), C.shouldValidate && oe(v);
  }, K = (v, x, C) => {
    for (const R in x) {
      const D = x[R], M = `${v}.${R}`, z = B(n, M);
      (a.array.has(v) || Le(D) || z && !z._f) && !Xt(D) ? K(M, D, C) : X(M, D, C);
    }
  }, U = (v, x, C = {}) => {
    const R = B(n, v), D = a.array.has(v), M = Ze(x);
    ue(o, v, M), D ? (f.array.next({
      name: v,
      values: { ...o }
    }), (u.isDirty || u.dirtyFields) && C.shouldDirty && f.state.next({
      name: v,
      dirtyFields: Vr(i, o),
      isDirty: O(v, M)
    })) : R && !R._f && !We(M) ? K(v, M, C) : X(v, M, C), So(v, a) && f.state.next({ ...r }), f.values.next({
      name: s.mount ? v : void 0,
      values: { ...o }
    });
  }, te = async (v) => {
    s.mount = !0;
    const x = v.target;
    let C = x.name, R = !0;
    const D = B(n, C), M = () => x.type ? qn(D._f) : Rs(v), z = (ee) => {
      R = Number.isNaN(ee) || Xt(ee) && isNaN(ee.getTime()) || Ht(ee, B(o, C, ee));
    };
    if (D) {
      let ee, he;
      const ce = M(), Ie = v.type === mn.BLUR || v.type === mn.FOCUS_OUT, _t = !gu(D._f) && !t.resolver && !B(r.errors, C) && !D._f.deps || bu(Ie, B(r.touchedFields, C), r.isSubmitted, h, p), vt = So(C, a, Ie);
      ue(o, C, ce), Ie ? (D._f.onBlur && D._f.onBlur(v), c && c(0)) : D._f.onChange && D._f.onChange(v);
      const Wt = S(C, ce, Ie, !1), Bt = !qe(Wt) || vt;
      if (!Ie && f.values.next({
        name: C,
        type: v.type,
        values: { ...o }
      }), _t)
        return u.isValid && (t.mode === "onBlur" ? Ie && y() : y()), Bt && f.state.next({ name: C, ...vt ? {} : Wt });
      if (!Ie && vt && f.state.next({ ...r }), t.resolver) {
        const { errors: gt } = await V([C]);
        if (z(ce), R) {
          const Ge = To(r.errors, n, C), Ne = To(gt, n, Ge.name || C);
          ee = Ne.error, C = Ne.name, he = qe(gt);
        }
      } else
        A([C], !0), ee = (await _o(D, o, m, t.shouldUseNativeValidation))[C], A([C]), z(ce), R && (ee ? he = !1 : u.isValid && (he = await H(n, !0)));
      R && (D._f.deps && oe(D._f.deps), E(C, he, ee, Wt));
    }
  }, ie = (v, x) => {
    if (B(r.errors, x) && v.focus)
      return v.focus(), 1;
  }, oe = async (v, x = {}) => {
    let C, R;
    const D = Br(v);
    if (t.resolver) {
      const M = await I(ke(v) ? v : D);
      C = qe(M), R = v ? !D.some((z) => B(M, z)) : C;
    } else v ? (R = (await Promise.all(D.map(async (M) => {
      const z = B(n, M);
      return await H(z && z._f ? { [M]: z } : z);
    }))).every(Boolean), !(!R && !r.isValid) && y()) : R = C = await H(n);
    return f.state.next({
      ...!xt(v) || u.isValid && C !== r.isValid ? {} : { name: v },
      ...t.resolver || !v ? { isValid: C } : {},
      errors: r.errors
    }), x.shouldFocus && !R && Fr(n, ie, v ? D : a.mount), R;
  }, se = (v) => {
    const x = {
      ...s.mount ? o : i
    };
    return ke(v) ? x : xt(v) ? B(x, v) : v.map((C) => B(x, C));
  }, pe = (v, x) => ({
    invalid: !!B((x || r).errors, v),
    isDirty: !!B((x || r).dirtyFields, v),
    error: B((x || r).errors, v),
    isValidating: !!B(r.validatingFields, v),
    isTouched: !!B((x || r).touchedFields, v)
  }), de = (v) => {
    v && Br(v).forEach((x) => Ve(r.errors, x)), f.state.next({
      errors: v ? r.errors : {}
    });
  }, Se = (v, x, C) => {
    const R = (B(n, v, { _f: {} })._f || {}).ref, D = B(r.errors, v) || {}, { ref: M, message: z, type: ee, ...he } = D;
    ue(r.errors, v, {
      ...he,
      ...x,
      ref: R
    }), f.state.next({
      name: v,
      errors: r.errors,
      isValid: !1
    }), C && C.shouldFocus && R && R.focus && R.focus();
  }, Oe = (v, x) => wt(v) ? f.values.subscribe({
    next: (C) => v(T(void 0, x), C)
  }) : T(v, x, !0), xe = (v, x = {}) => {
    for (const C of v ? Br(v) : a.mount)
      a.mount.delete(C), a.array.delete(C), x.keepValue || (Ve(n, C), Ve(o, C)), !x.keepError && Ve(r.errors, C), !x.keepDirty && Ve(r.dirtyFields, C), !x.keepTouched && Ve(r.touchedFields, C), !x.keepIsValidating && Ve(r.validatingFields, C), !t.shouldUnregister && !x.keepDefaultValue && Ve(i, C);
    f.values.next({
      values: { ...o }
    }), f.state.next({
      ...r,
      ...x.keepDirty ? { isDirty: O() } : {}
    }), !x.keepIsValid && y();
  }, Fe = ({ disabled: v, name: x, field: C, fields: R, value: D }) => {
    if (Qe(v) && s.mount || v) {
      const M = v ? void 0 : ke(D) ? qn(C ? C._f : B(R, x)._f) : D;
      (v || !v && !ke(M)) && ue(o, x, M), S(x, M, !1, !1, !0);
    }
  }, F = (v, x = {}) => {
    let C = B(n, v);
    const R = Qe(x.disabled) || Qe(t.disabled);
    return ue(n, v, {
      ...C || {},
      _f: {
        ...C && C._f ? C._f : { ref: { name: v } },
        name: v,
        mount: !0,
        ...x
      }
    }), a.mount.add(v), C ? Fe({
      field: C,
      disabled: Qe(x.disabled) ? x.disabled : t.disabled,
      name: v,
      value: x.value
    }) : k(v, !0, x.value), {
      ...R ? { disabled: x.disabled || t.disabled } : {},
      ...t.progressive ? {
        required: !!x.required,
        min: Tr(x.min),
        max: Tr(x.max),
        minLength: Tr(x.minLength),
        maxLength: Tr(x.maxLength),
        pattern: Tr(x.pattern)
      } : {},
      name: v,
      onChange: te,
      onBlur: te,
      ref: (D) => {
        if (D) {
          F(v, x), C = B(n, v);
          const M = ke(D.value) && D.querySelectorAll && D.querySelectorAll("input,select,textarea")[0] || D, z = mu(M), ee = C._f.refs || [];
          if (z ? ee.find((he) => he === M) : M === C._f.ref)
            return;
          ue(n, v, {
            _f: {
              ...C._f,
              ...z ? {
                refs: [
                  ...ee.filter(Zn),
                  M,
                  ...Array.isArray(B(i, v)) ? [{}] : []
                ],
                ref: { type: M.type, name: v }
              } : { ref: M }
            }
          }), k(v, !1, void 0, M);
        } else
          C = B(n, v, {}), C._f && (C._f.mount = !1), (t.shouldUnregister || x.shouldUnregister) && !(Bs(a.array, v) && s.action) && a.unMount.add(v);
      }
    };
  }, re = () => t.shouldFocusError && Fr(n, ie, a.mount), De = (v) => {
    Qe(v) && (f.state.next({ disabled: v }), Fr(n, (x, C) => {
      const R = B(n, C);
      R && (x.disabled = R._f.disabled || v, Array.isArray(R._f.refs) && R._f.refs.forEach((D) => {
        D.disabled = R._f.disabled || v;
      }));
    }, 0, !1));
  }, Ce = (v, x) => async (C) => {
    let R;
    if (C && (C.preventDefault && C.preventDefault(), C.persist && C.persist()), t.disabled) {
      x && await x({ ...r.errors }, C);
      return;
    }
    let D = Ze(o);
    if (f.state.next({
      isSubmitting: !0
    }), t.resolver) {
      const { errors: M, values: z } = await V();
      r.errors = M, D = z;
    } else
      await H(n);
    if (Ve(r.errors, "root"), qe(r.errors)) {
      f.state.next({
        errors: {}
      });
      try {
        await v(D, C);
      } catch (M) {
        R = M;
      }
    } else
      x && await x({ ...r.errors }, C), re(), setTimeout(re);
    if (f.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: qe(r.errors) && !R,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), R)
      throw R;
  }, it = (v, x = {}) => {
    B(n, v) && (ke(x.defaultValue) ? U(v, Ze(B(i, v))) : (U(v, x.defaultValue), ue(i, v, Ze(x.defaultValue))), x.keepTouched || Ve(r.touchedFields, v), x.keepDirty || (Ve(r.dirtyFields, v), r.isDirty = x.defaultValue ? O(v, Ze(B(i, v))) : O()), x.keepError || (Ve(r.errors, v), u.isValid && y()), f.state.next({ ...r }));
  }, ft = (v, x = {}) => {
    const C = v ? Ze(v) : i, R = Ze(C), D = qe(v), M = D ? i : R;
    if (x.keepDefaultValues || (i = C), !x.keepValues) {
      if (x.keepDirtyValues) {
        const z = /* @__PURE__ */ new Set([
          ...a.mount,
          ...Object.keys(Vr(i, o))
        ]);
        for (const ee of Array.from(z))
          B(r.dirtyFields, ee) ? ue(M, ee, B(o, ee)) : U(ee, B(M, ee));
      } else {
        if (Ei && ke(v))
          for (const z of a.mount) {
            const ee = B(n, z);
            if (ee && ee._f) {
              const he = Array.isArray(ee._f.refs) ? ee._f.refs[0] : ee._f.ref;
              if (pn(he)) {
                const ce = he.closest("form");
                if (ce) {
                  ce.reset();
                  break;
                }
              }
            }
          }
        n = {};
      }
      o = t.shouldUnregister ? x.keepDefaultValues ? Ze(i) : {} : Ze(M), f.array.next({
        values: { ...M }
      }), f.values.next({
        values: { ...M }
      });
    }
    a = {
      mount: x.keepDirtyValues ? a.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!x.keepIsValid || !!x.keepDirtyValues, s.watch = !!t.shouldUnregister, f.state.next({
      submitCount: x.keepSubmitCount ? r.submitCount : 0,
      isDirty: D ? !1 : x.keepDirty ? r.isDirty : !!(x.keepDefaultValues && !Ht(v, i)),
      isSubmitted: x.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: D ? {} : x.keepDirtyValues ? x.keepDefaultValues && o ? Vr(i, o) : r.dirtyFields : x.keepDefaultValues && v ? Vr(i, v) : x.keepDirty ? r.dirtyFields : {},
      touchedFields: x.keepTouched ? r.touchedFields : {},
      errors: x.keepErrors ? r.errors : {},
      isSubmitSuccessful: x.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Ye = (v, x) => ft(wt(v) ? v(o) : v, x);
  return {
    control: {
      register: F,
      unregister: xe,
      getFieldState: pe,
      handleSubmit: Ce,
      setError: Se,
      _executeSchema: V,
      _getWatch: T,
      _getDirty: O,
      _updateValid: y,
      _removeUnmounted: W,
      _updateFieldArray: w,
      _updateDisabledField: Fe,
      _getFieldArray: $,
      _reset: ft,
      _resetDefaultValues: () => wt(t.defaultValues) && t.defaultValues().then((v) => {
        Ye(v, t.resetOptions), f.state.next({
          isLoading: !1
        });
      }),
      _updateFormState: (v) => {
        r = {
          ...r,
          ...v
        };
      },
      _disableForm: De,
      _subjects: f,
      _proxyFormState: u,
      _setErrors: N,
      get _fields() {
        return n;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(v) {
        s = v;
      },
      get _defaultValues() {
        return i;
      },
      get _names() {
        return a;
      },
      set _names(v) {
        a = v;
      },
      get _formState() {
        return r;
      },
      set _formState(v) {
        r = v;
      },
      get _options() {
        return t;
      },
      set _options(v) {
        t = {
          ...t,
          ...v
        };
      }
    },
    trigger: oe,
    register: F,
    handleSubmit: Ce,
    watch: Oe,
    setValue: U,
    getValues: se,
    reset: Ye,
    resetField: it,
    clearErrors: de,
    unregister: xe,
    setError: Se,
    setFocus: (v, x = {}) => {
      const C = B(n, v), R = C && C._f;
      if (R) {
        const D = R.refs ? R.refs[0] : R.ref;
        D.focus && (D.focus(), x.shouldSelect && wt(D.select) && D.select());
      }
    },
    getFieldState: pe
  };
}
function Cu(e = {}) {
  const t = q.useRef(), r = q.useRef(), [n, i] = q.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: wt(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: wt(e.defaultValues) ? void 0 : e.defaultValues
  });
  t.current || (t.current = {
    ...xu(e),
    formState: n
  });
  const o = t.current.control;
  return o._options = e, _i({
    subject: o._subjects.state,
    next: (s) => {
      $s(s, o._proxyFormState, o._updateFormState, !0) && i({ ...o._formState });
    }
  }), q.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), q.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== n.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, n.isDirty]), q.useEffect(() => {
    e.values && !Ht(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, i((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), q.useEffect(() => {
    e.errors && o._setErrors(e.errors);
  }, [e.errors, o]), q.useEffect(() => {
    o._state.mount || (o._updateValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), q.useEffect(() => {
    e.shouldUnregister && o._subjects.values.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), q.useMemo(() => ({
    ...t.current,
    formState: Is(n, o)
  }), [n, o]);
}
const Mo = (e, t, r) => {
  if (e && "reportValidity" in e) {
    const n = B(r, t);
    e.setCustomValidity(n && n.message || ""), e.reportValidity();
  }
}, Js = (e, t) => {
  for (const r in t.fields) {
    const n = t.fields[r];
    n && n.ref && "reportValidity" in n.ref ? Mo(n.ref, r, e) : n.refs && n.refs.forEach((i) => Mo(i, r, e));
  }
}, Nu = (e, t) => {
  t.shouldUseNativeValidation && Js(e, t);
  const r = {};
  for (const n in e) {
    const i = B(t.fields, n), o = Object.assign(e[n] || {}, { ref: i && i.ref });
    if (ku(t.names || Object.keys(e), n)) {
      const s = Object.assign({}, B(r, n));
      ue(s, "root", o), ue(r, n, s);
    } else ue(r, n, o);
  }
  return r;
}, ku = (e, t) => e.some((r) => r.startsWith(t + "."));
function Su(e, t, r) {
  return t === void 0 && (t = {}), r === void 0 && (r = {}), function(n, i, o) {
    try {
      return Promise.resolve(function(s, a) {
        try {
          var c = (t.context && process.env.NODE_ENV === "development" && console.warn("You should not used the yup options context. Please, use the 'useForm' context object instead"), Promise.resolve(e[r.mode === "sync" ? "validateSync" : "validate"](n, Object.assign({ abortEarly: !1 }, t, { context: i }))).then(function(d) {
            return o.shouldUseNativeValidation && Js({}, o), { values: r.raw ? n : d, errors: {} };
          }));
        } catch (d) {
          return a(d);
        }
        return c && c.then ? c.then(void 0, a) : c;
      }(0, function(s) {
        if (!s.inner) throw s;
        return { values: {}, errors: Nu((a = s, c = !o.shouldUseNativeValidation && o.criteriaMode === "all", (a.inner || []).reduce(function(d, u) {
          if (d[u.path] || (d[u.path] = { message: u.message, type: u.type }), c) {
            var f = d[u.path].types, p = f && f[u.type];
            d[u.path] = Us(u.path, c, d, u.type, p ? [].concat(p, u.message) : u.message);
          }
          return d;
        }, {})), o) };
        var a, c;
      }));
    } catch (s) {
      return Promise.reject(s);
    }
  };
}
function Lu({
  className: e,
  name: t,
  children: r,
  mode: n = "onBlur",
  reValidateMode: i = "onBlur",
  defaultValues: o,
  schema: s,
  formProps: a,
  onSubmit: c = () => null,
  onChange: d
}, u) {
  const f = Cu({
    mode: n,
    reValidateMode: i,
    defaultValues: o,
    resolver: s ? Su(s) : void 0
  });
  return Wr(u, () => f, [f]), J(() => {
    if (!d) return;
    const { unsubscribe: p } = f.watch(d);
    return p;
  }, [d, f.watch]), /* @__PURE__ */ l(cu, { ...f, children: /* @__PURE__ */ l(
    "form",
    {
      className: _("bbn-form", e),
      name: t,
      onSubmit: f.handleSubmit(c),
      ...a,
      children: r
    }
  ) });
}
const Wd = nt(Lu);
function Nr({
  name: e,
  defaultValue: t,
  disabled: r = !1,
  autoFocus: n = !1,
  shouldUnregister: i = !1,
  validateOnMount: o = !0
}) {
  const { setFocus: s, trigger: a } = Cr(), { field: c, fieldState: d } = uu({ name: e, defaultValue: t, disabled: r, shouldUnregister: i }), { invalid: u, isTouched: f, error: p } = d;
  return J(() => {
    o ? a(e, { shouldFocus: n }) : n && s(e);
  }, [e, o]), {
    ...c,
    value: c.value,
    invalid: u && f,
    error: (p == null ? void 0 : p.message) ?? ""
  };
}
function Ud(e) {
  const { getFieldState: t } = Cr(), r = js({ name: e });
  return Array.isArray(e) ? e.map((i) => t(i, r)) : t(e, r);
}
const Au = /^-?\d*\.?\d*$/;
function Zd({
  name: e,
  id: t = e,
  label: r,
  hint: n,
  className: i,
  controlClassName: o,
  disabled: s,
  autoFocus: a,
  defaultValue: c,
  placeholder: d,
  type: u,
  suffix: f,
  prefix: p,
  shouldUnregister: h,
  state: m,
  validateOnMount: g
}) {
  const {
    ref: y,
    value: A = "",
    error: w,
    invalid: L,
    onChange: N,
    onBlur: k
  } = Nr({ name: e, defaultValue: c, autoFocus: a, shouldUnregister: h, validateOnMount: g }), S = L ? "error" : m;
  return /* @__PURE__ */ l(Sn, { label: r, className: o, state: S, hint: L ? w : n, children: /* @__PURE__ */ l(
    kn,
    {
      inputMode: "decimal",
      pattern: "^-?\\d*\\.?\\d*$",
      ref: y,
      value: A,
      id: t,
      name: e,
      type: u,
      className: i,
      disabled: s,
      autoFocus: a,
      placeholder: d,
      suffix: f,
      prefix: p,
      state: S,
      onChange: (I) => {
        Au.test(I.target.value) && N(I.target.value);
      },
      onBlur: k
    }
  ) });
}
function qd({
  name: e,
  id: t = e,
  label: r,
  hint: n,
  className: i,
  controlClassName: o,
  disabled: s,
  autoFocus: a,
  defaultValue: c,
  placeholder: d,
  type: u,
  suffix: f,
  prefix: p,
  shouldUnregister: h,
  state: m,
  validateOnMount: g
}) {
  const {
    ref: y,
    value: A = "",
    error: w,
    invalid: L,
    onChange: N,
    onBlur: k
  } = Nr({ name: e, defaultValue: c, autoFocus: a, shouldUnregister: h, validateOnMount: g }), S = L ? "error" : m;
  return /* @__PURE__ */ l(Sn, { label: r, className: o, state: S, hint: L ? w : n, children: /* @__PURE__ */ l(
    kn,
    {
      ref: y,
      value: A,
      id: t,
      name: e,
      type: u,
      className: i,
      disabled: s,
      autoFocus: a,
      placeholder: d,
      suffix: f,
      prefix: p,
      state: S,
      onChange: N,
      onBlur: k
    }
  ) });
}
function Xd({
  name: e,
  id: t = e,
  label: r,
  className: n,
  disabled: i,
  value: o,
  defaultChecked: s,
  labelClassName: a,
  orientation: c
}) {
  const { ref: d, value: u = !1, onChange: f, onBlur: p } = Nr({ name: e });
  return /* @__PURE__ */ l(
    ya,
    {
      ref: d,
      name: e,
      checked: u,
      id: t,
      label: r,
      className: n,
      disabled: i,
      value: o,
      defaultChecked: s,
      labelClassName: a,
      orientation: c,
      inputProps: { onChange: f, onBlur: p }
    }
  );
}
function Kd({
  name: e,
  id: t = e,
  label: r,
  className: n,
  disabled: i,
  value: o,
  defaultChecked: s,
  labelClassName: a,
  orientation: c
}) {
  const {
    ref: d,
    value: u,
    onChange: f,
    onBlur: p
  } = Nr({ name: e, disabled: i, defaultValue: s ? o : void 0 });
  return /* @__PURE__ */ l(
    xa,
    {
      ref: d,
      name: e,
      id: t,
      label: r,
      className: n,
      disabled: i,
      checked: u === o,
      value: o,
      labelClassName: a,
      orientation: c,
      inputProps: { onChange: f, onBlur: p }
    }
  );
}
function Yd({
  open: e,
  defaultOpen: t,
  options: r,
  optionClassName: n,
  popoverClassName: i,
  name: o,
  id: s = o,
  label: a,
  hint: c,
  className: d,
  controlClassName: u,
  disabled: f,
  autoFocus: p,
  defaultValue: h,
  placeholder: m,
  shouldUnregister: g,
  state: y,
  validateOnMount: A,
  onOpen: w,
  onClose: L,
  renderSelectedOption: N
}) {
  const {
    ref: k,
    value: S = "",
    error: E,
    invalid: V,
    onChange: I,
    onBlur: H
  } = Nr({ name: o, defaultValue: h, autoFocus: p, shouldUnregister: g, validateOnMount: A }), W = V ? "error" : y;
  return /* @__PURE__ */ l(Sn, { label: a, className: u, state: W, hint: V ? E : c, children: /* @__PURE__ */ l(
    yi,
    {
      open: e,
      defaultOpen: t,
      options: r,
      ref: k,
      value: S,
      id: s,
      name: o,
      className: d,
      disabled: f,
      placeholder: m,
      state: W,
      optionClassName: n,
      popoverClassName: i,
      onSelect: I,
      onBlur: H,
      onOpen: w,
      onClose: () => {
        H == null || H(), L == null || L();
      },
      renderSelectedOption: N
    }
  ) });
}
function Eu({ displayError: e = !1, ...t }) {
  const { error: r, value: n, onChange: i, onBlur: o, disabled: s, name: a, ref: c } = Nr(t), d = /* @__PURE__ */ l("input", { ref: c, type: "hidden", name: a, disabled: s, value: n, onChange: i, onBlur: o });
  return e ? /* @__PURE__ */ l(Sn, { hint: e ? r : "", state: e ? "error" : "default", children: d }) : d;
}
const Ou = ({
  attributes: e,
  providerItemProps: t,
  isSelected: r = !1,
  isSelectable: n = !0,
  onSelect: i,
  actionLabel: o = "Select",
  selectedLabel: s = "Selected"
}) => /* @__PURE__ */ b("div", { className: "bg-secondary-highlight h-[316px] overflow-hidden p-4 flex flex-col rounded justify-between", children: [
  /* @__PURE__ */ l(Ms, { ...t }),
  /* @__PURE__ */ l("div", { className: "w-full h-px bg-secondary-strokeLight" }),
  Object.entries(e).map(([a, c]) => /* @__PURE__ */ b(
    "div",
    {
      className: "text-sm flex flex-row justify-between first:mt-0 mt-1",
      children: [
        /* @__PURE__ */ l("div", { className: "text-accent-secondary", children: a }),
        /* @__PURE__ */ l("div", { className: "text-accent-primary font-medium", children: c })
      ]
    },
    a
  )),
  i && /* @__PURE__ */ l(
    Me,
    {
      className: "mt-4",
      onClick: i,
      disabled: !n,
      variant: r ? "contained" : "outlined",
      children: r ? s : o
    }
  )
] });
function _u({ className: e, ...t }) {
  const r = jt(Kr);
  return /* @__PURE__ */ l(
    r ? ir : Xr,
    {
      ...t,
      ...r ? {} : { dialogClassName: "h-[90vh] min-h-[400px] max-h-[720px] flex flex-col" },
      className: le("w-[41.25rem] max-w-full", e)
    }
  );
}
const Gd = ({
  open: e,
  validators: t,
  columns: r,
  onClose: n,
  onSelect: i,
  title: o = "",
  description: s,
  confirmSelection: a = !1,
  onBack: c,
  onAdd: d,
  layout: u,
  defaultLayout: f = "list",
  onLayoutChange: p,
  isRowSelectable: h,
  gridItemMapper: m,
  filters: g
}) => {
  const [y, A] = G(""), [w, L] = G(null), [N, k] = St({
    value: u,
    defaultValue: f,
    onStateChange: p
  });
  J(() => {
    e && (L(null), A(""));
  }, [e]);
  const E = /* @__PURE__ */ l(
    Vu,
    {
      searchTerm: y,
      onClearSearch: () => {
        A("");
      },
      onSearchChange: A,
      filters: g,
      gridItemMapper: m,
      currentLayout: N ?? "list",
      onToggleLayout: () => k(N === "grid" ? "list" : "grid")
    }
  ), V = Te(() => y.trim() ? t.filter(
    (H) => H.name.toLowerCase().includes(y.toLowerCase())
  ) : t, [t, y]), I = Te(
    () => V.find((H) => H.id === w) || null,
    [V, w]
  );
  return /* @__PURE__ */ b(_u, { open: e, onClose: n, className: "w-[52rem]", children: [
    /* @__PURE__ */ l(En, { title: o, onClose: n, className: "text-accent-primary" }),
    s && /* @__PURE__ */ l("div", { className: "mt-4", children: /* @__PURE__ */ l(Z, { className: "text-accent-secondary", children: s }) }),
    E,
    /* @__PURE__ */ b(On, { className: "mt-4 flex flex-col", style: { overflowY: "hidden" }, children: [
      /* @__PURE__ */ l(
        Tu,
        {
          rows: V,
          currentLayout: N ?? "list",
          gridItemMapper: m,
          isRowSelectable: h,
          selectedId: w,
          onSelectRowId: L,
          confirmSelection: a,
          onSelect: i,
          onClose: n
        }
      ),
      /* @__PURE__ */ l(
        Mu,
        {
          rows: V,
          currentLayout: N ?? "list",
          gridItemMapper: m,
          columns: r,
          selectedId: w,
          onSelectRowId: L,
          confirmSelection: a,
          onSelect: i,
          onClose: n,
          isRowSelectable: h
        }
      )
    ] }),
    /* @__PURE__ */ l(
      Du,
      {
        confirmSelection: a,
        onBack: c,
        selectedRow: I,
        onAdd: d,
        onClose: n,
        clearSelection: () => L(null)
      }
    )
  ] });
}, Vu = wn(({
  searchTerm: e,
  onClearSearch: t,
  onSearchChange: r,
  filters: n,
  gridItemMapper: i,
  currentLayout: o,
  onToggleLayout: s
}) => /* @__PURE__ */ b("div", { className: "mt-4 flex flex-col md:flex-row gap-4", children: [
  /* @__PURE__ */ l("div", { className: "flex-1", children: /* @__PURE__ */ l(
    kn,
    {
      placeholder: "Search",
      wrapperClassName: "h-full",
      id: "validator-selector-search",
      value: e,
      onChange: (c) => r(c.target.value),
      prefix: e ? /* @__PURE__ */ l(
        "button",
        {
          onClick: t,
          className: "opacity-60 hover:opacity-100 transition-opacity",
          children: /* @__PURE__ */ l(U1, { size: 18, className: "text-secondary-strokeDark" })
        }
      ) : /* @__PURE__ */ l("span", { className: "text-secondary-strokeDark", children: /* @__PURE__ */ l(Va, { size: 20 }) }),
      className: "w-full"
    }
  ) }),
  n != null && n.slot ? /* @__PURE__ */ l("div", { className: "w-full md:w-[200px]", children: n.slot }) : n != null && n.options && n.options.length > 0 ? /* @__PURE__ */ l("div", { className: "w-full md:w-[200px]", children: /* @__PURE__ */ l(
    yi,
    {
      options: n.options,
      onSelect: (c) => {
        var d;
        return (d = n == null ? void 0 : n.onSelect) == null ? void 0 : d.call(n, c);
      },
      placeholder: n.placeholder ?? "Select Status",
      value: e ? "" : n.value,
      disabled: !!e || n.disabled,
      renderSelectedOption: n.renderSelectedOption,
      className: le("h-10", n.className)
    }
  ) }) : null,
  i ? /* @__PURE__ */ l("div", { className: "flex items-center gap-2 text-secondary-strokeDark/50", children: /* @__PURE__ */ l(li, { onClick: s, children: /* @__PURE__ */ l("div", { className: "text-accent-primary", children: o === "grid" ? /* @__PURE__ */ l(W1, { size: 24 }) : /* @__PURE__ */ l(I1, { size: 20 }) }) }) }) : null
] })), Tu = wn(({ rows: e, currentLayout: t, gridItemMapper: r, isRowSelectable: n, selectedId: i, onSelectRowId: o, confirmSelection: s, onSelect: a, onClose: c }) => t === "grid" && r ? /* @__PURE__ */ l("div", { className: "grid grid-cols-2 gap-4 w-full flex-1 min-h-0 overflow-auto", children: e.map((d, u) => {
  const f = r(d, u), p = n ? n(d) : !0;
  return /* @__PURE__ */ l(
    Ou,
    {
      providerItemProps: f.providerItemProps,
      attributes: f.attributes,
      isSelected: i === d.id,
      isSelectable: p,
      actionLabel: s ? void 0 : "Add",
      onSelect: () => {
        p && (s ? o(d.id) : (a(d), c()));
      }
    },
    d.id
  );
}) }) : null), Mu = wn(({ rows: e, currentLayout: t, gridItemMapper: r, columns: n, selectedId: i, onSelectRowId: o, confirmSelection: s, onSelect: a, onClose: c, isRowSelectable: d }) => t === "grid" && r ? null : /* @__PURE__ */ l(
  vc,
  {
    data: e,
    columns: n,
    className: "w-full",
    wrapperClassName: "w-full flex-1 min-h-0 overflow-auto",
    fluid: !0,
    selectedRow: i ?? void 0,
    onSelectedRowChange: (u) => o(u),
    onRowSelect: (u) => {
      if (!u) {
        o(null);
        return;
      }
      s ? o(u.id) : (a(u), c());
    },
    isRowSelectable: d
  }
)), Du = wn(({ confirmSelection: e, onBack: t, selectedRow: r, onAdd: n, onClose: i, clearSelection: o }) => e ? /* @__PURE__ */ b(_n, { className: "flex mt-4 justify-between", children: [
  t ? /* @__PURE__ */ l(Me, { variant: "outlined", onClick: t, children: "Back" }) : /* @__PURE__ */ l("div", {}),
  /* @__PURE__ */ l(
    Me,
    {
      variant: "contained",
      onClick: () => {
        r && n && (n(r), o(), i());
      },
      disabled: !r,
      children: "Add"
    }
  )
] }) : null);
var kr = 1e9, Ru = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed during run-time using `Decimal.config`.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
  // `toFixed`, `toPrecision` and `toSignificantDigits`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -MAX_E
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to MAX_E
  // The natural logarithm of 10.
  // 115 digits
  LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
}, Di, ye = !0, dt = "[DecimalError] ", Gt = dt + "Invalid argument: ", Mi = dt + "Exponent out of range: ", Sr = Math.floor, Zt = Math.pow, Bu = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, et, Be = 1e7, ve = 7, Qs = 9007199254740991, bn = Sr(Qs / ve), j = {};
j.absoluteValue = j.abs = function() {
  var e = new this.constructor(this);
  return e.s && (e.s = 1), e;
};
j.comparedTo = j.cmp = function(e) {
  var t, r, n, i, o = this;
  if (e = new o.constructor(e), o.s !== e.s) return o.s || -e.s;
  if (o.e !== e.e) return o.e > e.e ^ o.s < 0 ? 1 : -1;
  for (n = o.d.length, i = e.d.length, t = 0, r = n < i ? n : i; t < r; ++t)
    if (o.d[t] !== e.d[t]) return o.d[t] > e.d[t] ^ o.s < 0 ? 1 : -1;
  return n === i ? 0 : n > i ^ o.s < 0 ? 1 : -1;
};
j.decimalPlaces = j.dp = function() {
  var e = this, t = e.d.length - 1, r = (t - e.e) * ve;
  if (t = e.d[t], t) for (; t % 10 == 0; t /= 10) r--;
  return r < 0 ? 0 : r;
};
j.dividedBy = j.div = function(e) {
  return Mt(this, new this.constructor(e));
};
j.dividedToIntegerBy = j.idiv = function(e) {
  var t = this, r = t.constructor;
  return me(Mt(t, new r(e), 0, 1), r.precision);
};
j.equals = j.eq = function(e) {
  return !this.cmp(e);
};
j.exponent = function() {
  return Ee(this);
};
j.greaterThan = j.gt = function(e) {
  return this.cmp(e) > 0;
};
j.greaterThanOrEqualTo = j.gte = function(e) {
  return this.cmp(e) >= 0;
};
j.isInteger = j.isint = function() {
  return this.e > this.d.length - 2;
};
j.isNegative = j.isneg = function() {
  return this.s < 0;
};
j.isPositive = j.ispos = function() {
  return this.s > 0;
};
j.isZero = function() {
  return this.s === 0;
};
j.lessThan = j.lt = function(e) {
  return this.cmp(e) < 0;
};
j.lessThanOrEqualTo = j.lte = function(e) {
  return this.cmp(e) < 1;
};
j.logarithm = j.log = function(e) {
  var t, r = this, n = r.constructor, i = n.precision, o = i + 5;
  if (e === void 0)
    e = new n(10);
  else if (e = new n(e), e.s < 1 || e.eq(et)) throw Error(dt + "NaN");
  if (r.s < 1) throw Error(dt + (r.s ? "NaN" : "-Infinity"));
  return r.eq(et) ? new n(0) : (ye = !1, t = Mt(Pr(r, o), Pr(e, o), o), ye = !0, me(t, i));
};
j.minus = j.sub = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? ra(t, e) : ea(t, (e.s = -e.s, e));
};
j.modulo = j.mod = function(e) {
  var t, r = this, n = r.constructor, i = n.precision;
  if (e = new n(e), !e.s) throw Error(dt + "NaN");
  return r.s ? (ye = !1, t = Mt(r, e, 0, 1).times(e), ye = !0, r.minus(t)) : me(new n(r), i);
};
j.naturalExponential = j.exp = function() {
  return ta(this);
};
j.naturalLogarithm = j.ln = function() {
  return Pr(this);
};
j.negated = j.neg = function() {
  var e = new this.constructor(this);
  return e.s = -e.s || 0, e;
};
j.plus = j.add = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? ea(t, e) : ra(t, (e.s = -e.s, e));
};
j.precision = j.sd = function(e) {
  var t, r, n, i = this;
  if (e !== void 0 && e !== !!e && e !== 1 && e !== 0) throw Error(Gt + e);
  if (t = Ee(i) + 1, n = i.d.length - 1, r = n * ve + 1, n = i.d[n], n) {
    for (; n % 10 == 0; n /= 10) r--;
    for (n = i.d[0]; n >= 10; n /= 10) r++;
  }
  return e && t > r ? t : r;
};
j.squareRoot = j.sqrt = function() {
  var e, t, r, n, i, o, s, a = this, c = a.constructor;
  if (a.s < 1) {
    if (!a.s) return new c(0);
    throw Error(dt + "NaN");
  }
  for (e = Ee(a), ye = !1, i = Math.sqrt(+a), i == 0 || i == 1 / 0 ? (t = Ct(a.d), (t.length + e) % 2 == 0 && (t += "0"), i = Math.sqrt(t), e = Sr((e + 1) / 2) - (e < 0 || e % 2), i == 1 / 0 ? t = "5e" + e : (t = i.toExponential(), t = t.slice(0, t.indexOf("e") + 1) + e), n = new c(t)) : n = new c(i.toString()), r = c.precision, i = s = r + 3; ; )
    if (o = n, n = o.plus(Mt(a, o, s + 2)).times(0.5), Ct(o.d).slice(0, s) === (t = Ct(n.d)).slice(0, s)) {
      if (t = t.slice(s - 3, s + 1), i == s && t == "4999") {
        if (me(o, r + 1, 0), o.times(o).eq(a)) {
          n = o;
          break;
        }
      } else if (t != "9999")
        break;
      s += 4;
    }
  return ye = !0, me(n, r);
};
j.times = j.mul = function(e) {
  var t, r, n, i, o, s, a, c, d, u = this, f = u.constructor, p = u.d, h = (e = new f(e)).d;
  if (!u.s || !e.s) return new f(0);
  for (e.s *= u.s, r = u.e + e.e, c = p.length, d = h.length, c < d && (o = p, p = h, h = o, s = c, c = d, d = s), o = [], s = c + d, n = s; n--; ) o.push(0);
  for (n = d; --n >= 0; ) {
    for (t = 0, i = c + n; i > n; )
      a = o[i] + h[n] * p[i - n - 1] + t, o[i--] = a % Be | 0, t = a / Be | 0;
    o[i] = (o[i] + t) % Be | 0;
  }
  for (; !o[--s]; ) o.pop();
  return t ? ++r : o.shift(), e.d = o, e.e = r, ye ? me(e, f.precision) : e;
};
j.toDecimalPlaces = j.todp = function(e, t) {
  var r = this, n = r.constructor;
  return r = new n(r), e === void 0 ? r : (Et(e, 0, kr), t === void 0 ? t = n.rounding : Et(t, 0, 8), me(r, e + Ee(r) + 1, t));
};
j.toExponential = function(e, t) {
  var r, n = this, i = n.constructor;
  return e === void 0 ? r = rr(n, !0) : (Et(e, 0, kr), t === void 0 ? t = i.rounding : Et(t, 0, 8), n = me(new i(n), e + 1, t), r = rr(n, !0, e + 1)), r;
};
j.toFixed = function(e, t) {
  var r, n, i = this, o = i.constructor;
  return e === void 0 ? rr(i) : (Et(e, 0, kr), t === void 0 ? t = o.rounding : Et(t, 0, 8), n = me(new o(i), e + Ee(i) + 1, t), r = rr(n.abs(), !1, e + Ee(n) + 1), i.isneg() && !i.isZero() ? "-" + r : r);
};
j.toInteger = j.toint = function() {
  var e = this, t = e.constructor;
  return me(new t(e), Ee(e) + 1, t.rounding);
};
j.toNumber = function() {
  return +this;
};
j.toPower = j.pow = function(e) {
  var t, r, n, i, o, s, a = this, c = a.constructor, d = 12, u = +(e = new c(e));
  if (!e.s) return new c(et);
  if (a = new c(a), !a.s) {
    if (e.s < 1) throw Error(dt + "Infinity");
    return a;
  }
  if (a.eq(et)) return a;
  if (n = c.precision, e.eq(et)) return me(a, n);
  if (t = e.e, r = e.d.length - 1, s = t >= r, o = a.s, s) {
    if ((r = u < 0 ? -u : u) <= Qs) {
      for (i = new c(et), t = Math.ceil(n / ve + 4), ye = !1; r % 2 && (i = i.times(a), Ro(i.d, t)), r = Sr(r / 2), r !== 0; )
        a = a.times(a), Ro(a.d, t);
      return ye = !0, e.s < 0 ? new c(et).div(i) : me(i, n);
    }
  } else if (o < 0) throw Error(dt + "NaN");
  return o = o < 0 && e.d[Math.max(t, r)] & 1 ? -1 : 1, a.s = 1, ye = !1, i = e.times(Pr(a, n + d)), ye = !0, i = ta(i), i.s = o, i;
};
j.toPrecision = function(e, t) {
  var r, n, i = this, o = i.constructor;
  return e === void 0 ? (r = Ee(i), n = rr(i, r <= o.toExpNeg || r >= o.toExpPos)) : (Et(e, 1, kr), t === void 0 ? t = o.rounding : Et(t, 0, 8), i = me(new o(i), e, t), r = Ee(i), n = rr(i, e <= r || r <= o.toExpNeg, e)), n;
};
j.toSignificantDigits = j.tosd = function(e, t) {
  var r = this, n = r.constructor;
  return e === void 0 ? (e = n.precision, t = n.rounding) : (Et(e, 1, kr), t === void 0 ? t = n.rounding : Et(t, 0, 8)), me(new n(r), e, t);
};
j.toString = j.valueOf = j.val = j.toJSON = j[Symbol.for("nodejs.util.inspect.custom")] = function() {
  var e = this, t = Ee(e), r = e.constructor;
  return rr(e, t <= r.toExpNeg || t >= r.toExpPos);
};
function ea(e, t) {
  var r, n, i, o, s, a, c, d, u = e.constructor, f = u.precision;
  if (!e.s || !t.s)
    return t.s || (t = new u(e)), ye ? me(t, f) : t;
  if (c = e.d, d = t.d, s = e.e, i = t.e, c = c.slice(), o = s - i, o) {
    for (o < 0 ? (n = c, o = -o, a = d.length) : (n = d, i = s, a = c.length), s = Math.ceil(f / ve), a = s > a ? s + 1 : a + 1, o > a && (o = a, n.length = 1), n.reverse(); o--; ) n.push(0);
    n.reverse();
  }
  for (a = c.length, o = d.length, a - o < 0 && (o = a, n = d, d = c, c = n), r = 0; o; )
    r = (c[--o] = c[o] + d[o] + r) / Be | 0, c[o] %= Be;
  for (r && (c.unshift(r), ++i), a = c.length; c[--a] == 0; ) c.pop();
  return t.d = c, t.e = i, ye ? me(t, f) : t;
}
function Et(e, t, r) {
  if (e !== ~~e || e < t || e > r)
    throw Error(Gt + e);
}
function Ct(e) {
  var t, r, n, i = e.length - 1, o = "", s = e[0];
  if (i > 0) {
    for (o += s, t = 1; t < i; t++)
      n = e[t] + "", r = ve - n.length, r && (o += Ft(r)), o += n;
    s = e[t], n = s + "", r = ve - n.length, r && (o += Ft(r));
  } else if (s === 0)
    return "0";
  for (; s % 10 === 0; ) s /= 10;
  return o + s;
}
var Mt = /* @__PURE__ */ function() {
  function e(n, i) {
    var o, s = 0, a = n.length;
    for (n = n.slice(); a--; )
      o = n[a] * i + s, n[a] = o % Be | 0, s = o / Be | 0;
    return s && n.unshift(s), n;
  }
  function t(n, i, o, s) {
    var a, c;
    if (o != s)
      c = o > s ? 1 : -1;
    else
      for (a = c = 0; a < o; a++)
        if (n[a] != i[a]) {
          c = n[a] > i[a] ? 1 : -1;
          break;
        }
    return c;
  }
  function r(n, i, o) {
    for (var s = 0; o--; )
      n[o] -= s, s = n[o] < i[o] ? 1 : 0, n[o] = s * Be + n[o] - i[o];
    for (; !n[0] && n.length > 1; ) n.shift();
  }
  return function(n, i, o, s) {
    var a, c, d, u, f, p, h, m, g, y, A, w, L, N, k, S, E, V, I = n.constructor, H = n.s == i.s ? 1 : -1, W = n.d, O = i.d;
    if (!n.s) return new I(n);
    if (!i.s) throw Error(dt + "Division by zero");
    for (c = n.e - i.e, E = O.length, k = W.length, h = new I(H), m = h.d = [], d = 0; O[d] == (W[d] || 0); ) ++d;
    if (O[d] > (W[d] || 0) && --c, o == null ? w = o = I.precision : s ? w = o + (Ee(n) - Ee(i)) + 1 : w = o, w < 0) return new I(0);
    if (w = w / ve + 2 | 0, d = 0, E == 1)
      for (u = 0, O = O[0], w++; (d < k || u) && w--; d++)
        L = u * Be + (W[d] || 0), m[d] = L / O | 0, u = L % O | 0;
    else {
      for (u = Be / (O[0] + 1) | 0, u > 1 && (O = e(O, u), W = e(W, u), E = O.length, k = W.length), N = E, g = W.slice(0, E), y = g.length; y < E; ) g[y++] = 0;
      V = O.slice(), V.unshift(0), S = O[0], O[1] >= Be / 2 && ++S;
      do
        u = 0, a = t(O, g, E, y), a < 0 ? (A = g[0], E != y && (A = A * Be + (g[1] || 0)), u = A / S | 0, u > 1 ? (u >= Be && (u = Be - 1), f = e(O, u), p = f.length, y = g.length, a = t(f, g, p, y), a == 1 && (u--, r(f, E < p ? V : O, p))) : (u == 0 && (a = u = 1), f = O.slice()), p = f.length, p < y && f.unshift(0), r(g, f, y), a == -1 && (y = g.length, a = t(O, g, E, y), a < 1 && (u++, r(g, E < y ? V : O, y))), y = g.length) : a === 0 && (u++, g = [0]), m[d++] = u, a && g[0] ? g[y++] = W[N] || 0 : (g = [W[N]], y = 1);
      while ((N++ < k || g[0] !== void 0) && w--);
    }
    return m[0] || m.shift(), h.e = c, me(h, s ? o + Ee(h) + 1 : o);
  };
}();
function ta(e, t) {
  var r, n, i, o, s, a, c = 0, d = 0, u = e.constructor, f = u.precision;
  if (Ee(e) > 16) throw Error(Mi + Ee(e));
  if (!e.s) return new u(et);
  for (ye = !1, a = f, s = new u(0.03125); e.abs().gte(0.1); )
    e = e.times(s), d += 5;
  for (n = Math.log(Zt(2, d)) / Math.LN10 * 2 + 5 | 0, a += n, r = i = o = new u(et), u.precision = a; ; ) {
    if (i = me(i.times(e), a), r = r.times(++c), s = o.plus(Mt(i, r, a)), Ct(s.d).slice(0, a) === Ct(o.d).slice(0, a)) {
      for (; d--; ) o = me(o.times(o), a);
      return u.precision = f, t == null ? (ye = !0, me(o, f)) : o;
    }
    o = s;
  }
}
function Ee(e) {
  for (var t = e.e * ve, r = e.d[0]; r >= 10; r /= 10) t++;
  return t;
}
function Xn(e, t, r) {
  if (t > e.LN10.sd())
    throw ye = !0, r && (e.precision = r), Error(dt + "LN10 precision limit exceeded");
  return me(new e(e.LN10), t);
}
function Ft(e) {
  for (var t = ""; e--; ) t += "0";
  return t;
}
function Pr(e, t) {
  var r, n, i, o, s, a, c, d, u, f = 1, p = 10, h = e, m = h.d, g = h.constructor, y = g.precision;
  if (h.s < 1) throw Error(dt + (h.s ? "NaN" : "-Infinity"));
  if (h.eq(et)) return new g(0);
  if (t == null ? (ye = !1, d = y) : d = t, h.eq(10))
    return t == null && (ye = !0), Xn(g, d);
  if (d += p, g.precision = d, r = Ct(m), n = r.charAt(0), o = Ee(h), Math.abs(o) < 15e14) {
    for (; n < 7 && n != 1 || n == 1 && r.charAt(1) > 3; )
      h = h.times(e), r = Ct(h.d), n = r.charAt(0), f++;
    o = Ee(h), n > 1 ? (h = new g("0." + r), o++) : h = new g(n + "." + r.slice(1));
  } else
    return c = Xn(g, d + 2, y).times(o + ""), h = Pr(new g(n + "." + r.slice(1)), d - p).plus(c), g.precision = y, t == null ? (ye = !0, me(h, y)) : h;
  for (a = s = h = Mt(h.minus(et), h.plus(et), d), u = me(h.times(h), d), i = 3; ; ) {
    if (s = me(s.times(u), d), c = a.plus(Mt(s, new g(i), d)), Ct(c.d).slice(0, d) === Ct(a.d).slice(0, d))
      return a = a.times(2), o !== 0 && (a = a.plus(Xn(g, d + 2, y).times(o + ""))), a = Mt(a, new g(f), d), g.precision = y, t == null ? (ye = !0, me(a, y)) : a;
    a = c, i += 2;
  }
}
function Do(e, t) {
  var r, n, i;
  for ((r = t.indexOf(".")) > -1 && (t = t.replace(".", "")), (n = t.search(/e/i)) > 0 ? (r < 0 && (r = n), r += +t.slice(n + 1), t = t.substring(0, n)) : r < 0 && (r = t.length), n = 0; t.charCodeAt(n) === 48; ) ++n;
  for (i = t.length; t.charCodeAt(i - 1) === 48; ) --i;
  if (t = t.slice(n, i), t) {
    if (i -= n, r = r - n - 1, e.e = Sr(r / ve), e.d = [], n = (r + 1) % ve, r < 0 && (n += ve), n < i) {
      for (n && e.d.push(+t.slice(0, n)), i -= ve; n < i; ) e.d.push(+t.slice(n, n += ve));
      t = t.slice(n), n = ve - t.length;
    } else
      n -= i;
    for (; n--; ) t += "0";
    if (e.d.push(+t), ye && (e.e > bn || e.e < -bn)) throw Error(Mi + r);
  } else
    e.s = 0, e.e = 0, e.d = [0];
  return e;
}
function me(e, t, r) {
  var n, i, o, s, a, c, d, u, f = e.d;
  for (s = 1, o = f[0]; o >= 10; o /= 10) s++;
  if (n = t - s, n < 0)
    n += ve, i = t, d = f[u = 0];
  else {
    if (u = Math.ceil((n + 1) / ve), o = f.length, u >= o) return e;
    for (d = o = f[u], s = 1; o >= 10; o /= 10) s++;
    n %= ve, i = n - ve + s;
  }
  if (r !== void 0 && (o = Zt(10, s - i - 1), a = d / o % 10 | 0, c = t < 0 || f[u + 1] !== void 0 || d % o, c = r < 4 ? (a || c) && (r == 0 || r == (e.s < 0 ? 3 : 2)) : a > 5 || a == 5 && (r == 4 || c || r == 6 && // Check whether the digit to the left of the rounding digit is odd.
  (n > 0 ? i > 0 ? d / Zt(10, s - i) : 0 : f[u - 1]) % 10 & 1 || r == (e.s < 0 ? 8 : 7))), t < 1 || !f[0])
    return c ? (o = Ee(e), f.length = 1, t = t - o - 1, f[0] = Zt(10, (ve - t % ve) % ve), e.e = Sr(-t / ve) || 0) : (f.length = 1, f[0] = e.e = e.s = 0), e;
  if (n == 0 ? (f.length = u, o = 1, u--) : (f.length = u + 1, o = Zt(10, ve - n), f[u] = i > 0 ? (d / Zt(10, s - i) % Zt(10, i) | 0) * o : 0), c)
    for (; ; )
      if (u == 0) {
        (f[0] += o) == Be && (f[0] = 1, ++e.e);
        break;
      } else {
        if (f[u] += o, f[u] != Be) break;
        f[u--] = 0, o = 1;
      }
  for (n = f.length; f[--n] === 0; ) f.pop();
  if (ye && (e.e > bn || e.e < -bn))
    throw Error(Mi + Ee(e));
  return e;
}
function ra(e, t) {
  var r, n, i, o, s, a, c, d, u, f, p = e.constructor, h = p.precision;
  if (!e.s || !t.s)
    return t.s ? t.s = -t.s : t = new p(e), ye ? me(t, h) : t;
  if (c = e.d, f = t.d, n = t.e, d = e.e, c = c.slice(), s = d - n, s) {
    for (u = s < 0, u ? (r = c, s = -s, a = f.length) : (r = f, n = d, a = c.length), i = Math.max(Math.ceil(h / ve), a) + 2, s > i && (s = i, r.length = 1), r.reverse(), i = s; i--; ) r.push(0);
    r.reverse();
  } else {
    for (i = c.length, a = f.length, u = i < a, u && (a = i), i = 0; i < a; i++)
      if (c[i] != f[i]) {
        u = c[i] < f[i];
        break;
      }
    s = 0;
  }
  for (u && (r = c, c = f, f = r, t.s = -t.s), a = c.length, i = f.length - a; i > 0; --i) c[a++] = 0;
  for (i = f.length; i > s; ) {
    if (c[--i] < f[i]) {
      for (o = i; o && c[--o] === 0; ) c[o] = Be - 1;
      --c[o], c[i] += Be;
    }
    c[i] -= f[i];
  }
  for (; c[--a] === 0; ) c.pop();
  for (; c[0] === 0; c.shift()) --n;
  return c[0] ? (t.d = c, t.e = n, ye ? me(t, h) : t) : new p(0);
}
function rr(e, t, r) {
  var n, i = Ee(e), o = Ct(e.d), s = o.length;
  return t ? (r && (n = r - s) > 0 ? o = o.charAt(0) + "." + o.slice(1) + Ft(n) : s > 1 && (o = o.charAt(0) + "." + o.slice(1)), o = o + (i < 0 ? "e" : "e+") + i) : i < 0 ? (o = "0." + Ft(-i - 1) + o, r && (n = r - s) > 0 && (o += Ft(n))) : i >= s ? (o += Ft(i + 1 - s), r && (n = r - i - 1) > 0 && (o = o + "." + Ft(n))) : ((n = i + 1) < s && (o = o.slice(0, n) + "." + o.slice(n)), r && (n = r - s) > 0 && (i + 1 === s && (o += "."), o += Ft(n))), e.s < 0 ? "-" + o : o;
}
function Ro(e, t) {
  if (e.length > t)
    return e.length = t, !0;
}
function na(e) {
  var t, r, n;
  function i(o) {
    var s = this;
    if (!(s instanceof i)) return new i(o);
    if (s.constructor = i, o instanceof i) {
      s.s = o.s, s.e = o.e, s.d = (o = o.d) ? o.slice() : o;
      return;
    }
    if (typeof o == "number") {
      if (o * 0 !== 0)
        throw Error(Gt + o);
      if (o > 0)
        s.s = 1;
      else if (o < 0)
        o = -o, s.s = -1;
      else {
        s.s = 0, s.e = 0, s.d = [0];
        return;
      }
      if (o === ~~o && o < 1e7) {
        s.e = 0, s.d = [o];
        return;
      }
      return Do(s, o.toString());
    } else if (typeof o != "string")
      throw Error(Gt + o);
    if (o.charCodeAt(0) === 45 ? (o = o.slice(1), s.s = -1) : s.s = 1, Bu.test(o)) Do(s, o);
    else throw Error(Gt + o);
  }
  if (i.prototype = j, i.ROUND_UP = 0, i.ROUND_DOWN = 1, i.ROUND_CEIL = 2, i.ROUND_FLOOR = 3, i.ROUND_HALF_UP = 4, i.ROUND_HALF_DOWN = 5, i.ROUND_HALF_EVEN = 6, i.ROUND_HALF_CEIL = 7, i.ROUND_HALF_FLOOR = 8, i.clone = na, i.config = i.set = Fu, e === void 0 && (e = {}), e)
    for (n = ["precision", "rounding", "toExpNeg", "toExpPos", "LN10"], t = 0; t < n.length; ) e.hasOwnProperty(r = n[t++]) || (e[r] = this[r]);
  return i.config(e), i;
}
function Fu(e) {
  if (!e || typeof e != "object")
    throw Error(dt + "Object expected");
  var t, r, n, i = [
    "precision",
    1,
    kr,
    "rounding",
    0,
    8,
    "toExpNeg",
    -1 / 0,
    0,
    "toExpPos",
    0,
    1 / 0
  ];
  for (t = 0; t < i.length; t += 3)
    if ((n = e[r = i[t]]) !== void 0)
      if (Sr(n) === n && n >= i[t + 1] && n <= i[t + 2]) this[r] = n;
      else throw Error(Gt + r + ": " + n);
  if ((n = e[r = "LN10"]) !== void 0)
    if (n == Math.LN10) this[r] = new this(n);
    else throw Error(Gt + r + ": " + n);
  return this;
}
var Di = na(Ru);
et = new Di(1);
const Hu = {
  prefix: "$",
  precision: 2,
  zeroDisplay: "-",
  format: {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }
};
function Iu(e, t) {
  const r = (e == null ? void 0 : e.minimumFractionDigits) ?? t;
  return Math.pow(10, -r);
}
function $u(e, t = {}) {
  const { prefix: r, precision: n, zeroDisplay: i, format: o } = {
    ...Hu,
    ...t
  };
  if (e === 0) return i;
  const s = Iu(o, n);
  if (e > 0 && e < s)
    return `< ${r}${s.toFixed((o == null ? void 0 : o.minimumFractionDigits) ?? n)}`;
  const a = e.toLocaleString("en", o ?? { maximumFractionDigits: n });
  return `${r}${a}`;
}
function ia(e, t, r) {
  const n = e * t;
  return $u(n, r);
}
const Bo = (e, t, r) => new Di(e).toDecimalPlaces(t, r).toNumber(), Jd = (e) => {
  let t = "";
  for (let r = 0; r < e.length; r++) {
    const n = e[r].toLowerCase();
    n >= "a" && n <= "z" || n >= "0" && n <= "9" ? t += n : t.length > 0 && t[t.length - 1] !== "-" && (t += "-");
  }
  return t.endsWith("-") && (t = t.slice(0, -1)), t;
};
function Qd(e, t = 8) {
  return (r) => `${r.toLocaleString(void 0, {
    minimumFractionDigits: Math.min(2, t),
    maximumFractionDigits: t
  })} ${e}`;
}
function ef(e, t = 8) {
  return e.toLocaleString(void 0, {
    minimumFractionDigits: 0,
    maximumFractionDigits: t
  });
}
function tf(e) {
  return parseFloat(e.replace(/,/g, "")) || 0;
}
const rf = ({
  fieldName: e,
  currencyIcon: t,
  currencyName: r,
  displayBalance: n,
  placeholder: i = "Enter Amount",
  balanceDetails: o,
  prefix: s,
  min: a = "0",
  step: c = "any",
  autoFocus: d = !0,
  decimals: u,
  enableMaxButton: f
}) => {
  const p = Ws({ name: e, defaultValue: "" }), { setValue: h } = Cr(), m = parseFloat(p || "0"), g = ia(m, (o == null ? void 0 : o.price) ?? 0, {
    zeroDisplay: "$0.00"
  }), y = (N) => {
    let k = N.target.value;
    if (u !== void 0 && u >= 0) {
      const [S, E] = k.split(".", 2);
      E !== void 0 && E.length > u ? k = S + "." + E.slice(0, u) : E !== void 0 ? k = S + "." + E : k.includes(".") && (k = S);
    }
    h(e, k, {
      shouldValidate: !0,
      shouldDirty: !0,
      shouldTouch: !0
    });
  }, A = (N) => {
    (N.key === "ArrowUp" || N.key === "ArrowDown") && N.preventDefault();
  }, w = () => {
    if ((o == null ? void 0 : o.balance) !== void 0) {
      const N = Number(o.balance), k = o.decimals !== void 0 ? Bo(N, o.decimals).toString() : N.toString();
      h(e, k, {
        shouldValidate: !0,
        shouldDirty: !0,
        shouldTouch: !0
      });
    }
  };
  let L;
  return o && (L = `${Bo(Number(o.balance), o.decimals ?? wi)} ${o.symbol}`, s && (L = `${s}: ${L}`)), /* @__PURE__ */ b(Pe, { children: [
    /* @__PURE__ */ l(Eu, { name: e, defaultValue: "" }),
    /* @__PURE__ */ l(zt, { className: "flex w-full flex-col content-center justify-between gap-4", children: /* @__PURE__ */ l(
      Ci,
      {
        amount: p,
        currencyIcon: t,
        currencyName: r,
        placeholder: i,
        displayBalance: n,
        balanceDetails: o,
        min: a,
        step: c,
        autoFocus: d,
        onChange: y,
        onKeyDown: A,
        amountUsd: g,
        subtitle: L,
        ...f && { onMaxClick: w }
      }
    ) })
  ] });
};
function Pu({ items: e, onRemove: t, showChain: r = !0 }) {
  const n = Te(() => e, [e]);
  return n.length === 0 ? null : /* @__PURE__ */ l("div", { className: "flex flex-col gap-8", children: n.map(({ bsnId: i, bsnName: o, bsnLogoUrl: s, provider: a }) => /* @__PURE__ */ l(
    Ms,
    {
      bsnId: i,
      bsnName: o,
      bsnLogoUrl: s,
      provider: a,
      onRemove: t,
      showChain: r
    },
    `${i}-${a.rank}`
  )) });
}
function nf({ max: e, items: t = [], actionText: r, onAdd: n, onRemove: i, showChain: o = !0 }) {
  const s = Te(() => t.length, [t]);
  return /* @__PURE__ */ l(zt, { children: /* @__PURE__ */ b("div", { className: "flex w-full flex-col gap-4", children: [
    /* @__PURE__ */ l("div", { className: "flex flex-row", children: /* @__PURE__ */ b("div", { className: "flex w-full flex-row content-center items-center justify-between font-normal", children: [
      /* @__PURE__ */ l("span", { className: "text-sm sm:text-base", children: r }),
      /* @__PURE__ */ l(Lc, { counter: s, max: e, onAdd: n })
    ] }) }),
    s > 0 && /* @__PURE__ */ l(Pu, { items: t, onRemove: i, showChain: o })
  ] }) });
}
function jr({ title: e, children: t, className: r, hint: n }) {
  return /* @__PURE__ */ b(
    "div",
    {
      className: le(
        "flex flex-row items-center justify-between text-accent-primary",
        n && "items-start",
        r
      ),
      children: [
        /* @__PURE__ */ l(Z, { as: "div", variant: "body1", children: e }),
        n ? /* @__PURE__ */ b("div", { className: "flex flex-col items-end", children: [
          /* @__PURE__ */ l(Z, { as: "div", className: "flex items-center gap-2", children: t }),
          /* @__PURE__ */ l(Z, { as: "div", variant: "body2", className: "text-accent-secondary", children: n })
        ] }) : /* @__PURE__ */ l(Z, { as: "div", className: "flex items-center gap-2", children: t })
      ]
    }
  );
}
function ju({ value: e, onEdit: t, title: r = "Network Fee Rate", className: n }) {
  return /* @__PURE__ */ b(jr, { title: r, className: n, children: [
    /* @__PURE__ */ b("span", { children: [
      e,
      " sats/vB"
    ] }),
    t && /* @__PURE__ */ l(Me, { size: "small", variant: "outlined", className: "h-6 w-6 pl-1 text-secondary-strokeDark", onClick: t, children: /* @__PURE__ */ l(tu, { size: 16, className: "text-secondary-strokeDark" }) })
  ] });
}
function zu({ amount: e, coinSymbol: t, hint: r, title: n, className: i, decimals: o = wi }) {
  let s;
  return typeof e == "number" ? e === 0 ? s = "0" : s = e.toFixed(o).replace(/\.?0+$/, "") : s = e, /* @__PURE__ */ b(jr, { title: n ?? `${t} Network Fee`, hint: r, className: i, children: [
    s,
    " ",
    t
  ] });
}
function Wu({ amount: e, coinSymbol: t, hint: r, title: n, className: i, decimals: o = nc }) {
  const s = typeof e == "number" ? e.toFixed(o) : e;
  return /* @__PURE__ */ b(jr, { title: n ?? `${t} Network Fee`, hint: r, className: i, children: [
    s,
    " ",
    t
  ] });
}
function Uu({ total: e, coinSymbol: t, hint: r, title: n = "Total", className: i, decimals: o = wi }) {
  let s;
  return typeof e == "number" ? e === 0 ? s = "0" : s = e.toFixed(o).replace(/\.?0+$/, "") : s = e, /* @__PURE__ */ b("div", { className: le("flex flex-row items-start justify-between text-accent-primary", i), children: [
    /* @__PURE__ */ l(Z, { variant: "body1", className: "font-bold", children: n }),
    /* @__PURE__ */ b("div", { className: "flex flex-col items-end justify-center", children: [
      /* @__PURE__ */ b(Z, { variant: "body1", className: "font-bold", children: [
        s,
        " ",
        t
      ] }),
      r && /* @__PURE__ */ l(Z, { variant: "body1", className: "text-sm text-accent-secondary", children: r })
    ] })
  ] });
}
function of({
  className: e,
  feeRate: t,
  onFeeRateEdit: r,
  feeAmount: n,
  coinSymbol: i,
  feeAmountHint: o,
  total: s,
  totalHint: a,
  bbnFeeAmount: c,
  bbnCoinSymbol: d,
  bbnFeeAmountHint: u,
  bbnFeeDecimals: f
}) {
  return /* @__PURE__ */ l(zt, { className: le("flex w-full flex-col content-center justify-between gap-4", e), children: /* @__PURE__ */ b("div", { className: "flex flex-col gap-6", children: [
    t !== void 0 && /* @__PURE__ */ l(ju, { value: t, onEdit: r }),
    n !== void 0 && i !== void 0 && /* @__PURE__ */ l(zu, { amount: n, coinSymbol: i, hint: o }),
    c !== void 0 && d ? /* @__PURE__ */ l(
      Wu,
      {
        amount: c,
        coinSymbol: d,
        hint: u,
        decimals: f
      }
    ) : null,
    s !== void 0 && i !== void 0 && /* @__PURE__ */ l("div", { className: "divider my-1" }),
    s !== void 0 && i !== void 0 && /* @__PURE__ */ l(Uu, { total: s, coinSymbol: i, hint: a })
  ] }) });
}
const Zu = ({
  data: e,
  headers: t,
  className: r
}) => {
  const n = Ur(), i = {
    gridTemplateColumns: `repeat(${t.length}, minmax(0, 1fr))`
  };
  return /* @__PURE__ */ l(zt, { className: _("bbn-simple-table-section", r), children: /* @__PURE__ */ b("div", { className: "bbn-simple-table", children: [
    /* @__PURE__ */ l(
      "div",
      {
        className: "bbn-simple-table-header",
        style: i,
        children: t.map((o, s) => /* @__PURE__ */ l(Z, { variant: "caption", className: "bbn-simple-table-header-cell", children: o }, `${n}-header-${o}-${s}`))
      }
    ),
    /* @__PURE__ */ l("div", { className: "bbn-simple-table-body", children: e.map((o, s) => /* @__PURE__ */ l(
      "div",
      {
        className: "bbn-simple-table-row",
        style: i,
        children: t.map((a, c) => /* @__PURE__ */ l(
          "div",
          {
            className: "bbn-simple-table-cell",
            children: o[c]
          },
          `${n}-cell-${s}-${c}`
        ))
      },
      `${n}-row-${s}`
    )) })
  ] }) });
};
function qu({ className: e, ...t }) {
  const n = jt(Kr) ? ir : Xr;
  return /* @__PURE__ */ l(n, { ...t, className: le("w-[41.25rem] max-w-full", e) });
}
const sf = ({
  open: e,
  processing: t = !1,
  onClose: r,
  onProceed: n,
  bsns: i,
  finalityProviders: o,
  details: s,
  visibleFields: a,
  warnings: c,
  proceedLabel: d = "Proceed to Signing"
}) => {
  const u = [
    { label: "Stake Amount", value: s.stakeAmount },
    { label: "Fee Rate", value: s.feeRate },
    { label: "Transaction Fees", value: s.transactionFees },
    {
      label: "Term",
      value: /* @__PURE__ */ b(Pe, { children: [
        s.term.blocks,
        /* @__PURE__ */ l("br", {}),
        /* @__PURE__ */ l("span", { className: "text-md text-secondary", children: s.term.duration })
      ] })
    },
    { label: "Unbonding", value: s.unbonding },
    { label: "Unbonding Fee", value: s.unbondingFee }
  ], f = a && a.length > 0 ? u.filter((m) => a.includes(m.label)) : u, h = !o || o.length === 0 ? [
    ["Validator"],
    ...i.map((m, g) => [
      /* @__PURE__ */ b(
        "div",
        {
          className: "flex w-full items-center gap-2 py-1",
          children: [
            m.icon,
            /* @__PURE__ */ l(Z, { variant: "body2", className: "font-medium", children: m.name })
          ]
        },
        `validator-${g}`
      )
    ])
  ] : [
    ["BSNs", "Finality Provider"],
    ...i.map((m, g) => {
      const y = o[g];
      return [
        /* @__PURE__ */ b(
          "div",
          {
            className: "flex w-full items-center gap-2 py-1",
            children: [
              m.icon,
              /* @__PURE__ */ l(Z, { variant: "body2", className: "font-medium", children: m.name })
            ]
          },
          `bsn-${g}`
        ),
        y ? /* @__PURE__ */ b(
          "div",
          {
            className: "flex w-full items-center gap-2 py-1",
            children: [
              y.icon,
              /* @__PURE__ */ l(Z, { variant: "body2", className: "font-medium", children: y.name })
            ]
          },
          `fp-${g}`
        ) : /* @__PURE__ */ l("div", {}, `fp-${g}`)
      ];
    })
  ];
  return /* @__PURE__ */ b(qu, { open: e, onClose: r, children: [
    /* @__PURE__ */ l(En, { title: "Preview", onClose: r, className: "text-accent-primary" }),
    /* @__PURE__ */ b(On, { className: "no-scrollbar mb-8 mt-4 flex max-h-[calc(100vh-12rem)] flex-col gap-4 overflow-y-auto text-accent-primary", children: [
      /* @__PURE__ */ l(Zu, { headers: h[0], data: h.slice(1) }),
      /* @__PURE__ */ l("div", { className: "flex flex-col", children: f.map((m, g) => /* @__PURE__ */ b("div", { className: "flex flex-row items-center justify-between py-3", children: [
        /* @__PURE__ */ l(Z, { variant: "body1", className: "text-secondary font-normal", children: m.label }),
        /* @__PURE__ */ l(Z, { variant: "body1", className: "text-right font-normal", children: m.value })
      ] }, g)) }),
      /* @__PURE__ */ l("div", { className: "border-divider w-full border-t" }),
      /* @__PURE__ */ b("div", { className: "pt-2", children: [
        /* @__PURE__ */ l(ui, { variant: "h6", className: "text-primary mb-2", children: "Attention!" }),
        c.map((m, g) => /* @__PURE__ */ l(Z, { variant: "body2", className: "text-secondary", children: m }, g))
      ] })
    ] }),
    /* @__PURE__ */ b(_n, { className: "flex flex-col gap-4 pb-8 pt-0 sm:flex-row", children: [
      /* @__PURE__ */ l(Me, { variant: "contained", color: "primary", onClick: n, className: "w-full sm:flex-1 sm:order-2", disabled: t, children: t ? "Processing..." : d }),
      /* @__PURE__ */ l(Me, { variant: "outlined", color: "primary", onClick: r, className: "w-full sm:flex-1 sm:order-1", children: "Cancel" })
    ] })
  ] });
};
function Xu({
  actions: e
}) {
  return /* @__PURE__ */ l("div", { className: "mt-4 sm:mt-6 flex gap-2", children: e.map((t, r) => /* @__PURE__ */ l(
    Me,
    {
      variant: t.variant || "outlined",
      className: `sm:bbn-btn-medium flex-1 ${t.className || ""}`,
      onClick: t.onClick,
      fluid: !0,
      children: t.label
    },
    `${t.label}-${r}`
  )) });
}
function Ku({
  formattedAmount: e,
  icon: t,
  iconAlt: r,
  chainName: n,
  chainIcon: i,
  chainIconAlt: o
}) {
  return /* @__PURE__ */ b("div", { className: "flex items-center justify-between", children: [
    /* @__PURE__ */ b("div", { className: "flex items-center gap-2", children: [
      t && (typeof t == "string" ? /* @__PURE__ */ l(
        "img",
        {
          src: t,
          alt: r || "icon",
          className: "w-6 h-6 sm:w-8 sm:h-8"
        }
      ) : t),
      /* @__PURE__ */ l("span", { className: "text-base sm:text-lg font-medium text-accent-primary", children: e })
    ] }),
    n && /* @__PURE__ */ b("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ l("span", { className: "text-base sm:text-lg font-medium text-accent-primary", children: n }),
      i && (typeof i == "string" ? /* @__PURE__ */ l(
        "img",
        {
          src: i,
          alt: o || "chain icon",
          className: "w-6 h-6 sm:w-8 sm:h-8"
        }
      ) : i)
    ] })
  ] });
}
function Yu({ item: e, className: t }) {
  return /* @__PURE__ */ b("div", { className: le("flex items-center gap-2 min-w-0", t), children: [
    /* @__PURE__ */ l("span", { className: "text-xs sm:text-sm text-accent-primary font-medium truncate flex items-center", children: e.name }),
    e.icon && /* @__PURE__ */ l("div", { className: "flex items-center w-4 h-4 flex-shrink-0 justify-center text-xs sm:text-sm", children: typeof e.icon == "string" ? /* @__PURE__ */ l(
      "img",
      {
        src: e.icon,
        alt: e.iconAlt || e.name,
        className: "w-full h-full rounded-full object-cover"
      }
    ) : e.icon })
  ] });
}
function oi({ label: e, value: t, collapsible: r = !1, nestedDetails: n }) {
  const [i, o] = G(!1), s = () => {
    o(!i);
  };
  return r ? /* @__PURE__ */ b("div", { className: "space-y-3", children: [
    /* @__PURE__ */ b("div", { className: "flex items-center justify-between gap-2 min-w-0 overflow-x-auto", children: [
      /* @__PURE__ */ b("div", { className: "flex items-center gap-2 flex-shrink-0", children: [
        /* @__PURE__ */ l("span", { className: "text-xs sm:text-sm text-accent-secondary", children: e }),
        /* @__PURE__ */ l(
          "button",
          {
            onClick: s,
            className: "w-5 h-5 flex-shrink-0 hover:opacity-70 transition-opacity",
            "aria-label": i ? "Collapse" : "Expand",
            children: i ? /* @__PURE__ */ l(Gl, { size: 20, variant: "secondary" }) : /* @__PURE__ */ l(Jl, { size: 20, variant: "secondary" })
          }
        )
      ] }),
      /* @__PURE__ */ l("span", { className: "text-xs sm:text-sm text-accent-primary font-medium text-right min-w-0 overflow-x-auto whitespace-nowrap", children: t })
    ] }),
    i && n && /* @__PURE__ */ l("div", { className: "bg-surface p-3 sm:p-4 rounded space-y-3 sm:space-y-4 overflow-x-auto", children: n.map((a, c) => /* @__PURE__ */ l(
      oi,
      {
        label: a.label,
        value: a.value,
        collapsible: a.collapsible,
        nestedDetails: a.nestedDetails
      },
      c
    )) })
  ] }) : /* @__PURE__ */ b("div", { className: "flex items-center justify-between gap-2 min-w-0 overflow-x-auto", children: [
    /* @__PURE__ */ l("span", { className: "text-xs sm:text-sm text-accent-secondary flex-shrink-0", children: e }),
    /* @__PURE__ */ l("span", { className: "text-xs sm:text-sm text-accent-primary font-medium text-right min-w-0 overflow-x-auto whitespace-nowrap", children: t })
  ] });
}
function Gu({
  details: e,
  optionalDetails: t,
  listItems: r
}) {
  const n = t && t.length > 0, i = r && r.length > 0;
  return /* @__PURE__ */ b("div", { className: "space-y-3 sm:space-y-4 overflow-x-auto", children: [
    /* @__PURE__ */ l("div", { className: "space-y-4 sm:space-y-6", children: e.map((o, s) => /* @__PURE__ */ l(
      oi,
      {
        label: o.label,
        value: o.value,
        collapsible: o.collapsible,
        nestedDetails: o.nestedDetails
      },
      s
    )) }),
    i && /* @__PURE__ */ l("div", { className: "space-y-3 sm:space-y-4", children: r.map((o, s) => /* @__PURE__ */ l(
      "div",
      {
        className: "bg-surface p-3 sm:p-4 rounded space-y-3 sm:space-y-4 overflow-x-auto",
        children: /* @__PURE__ */ b("div", { className: "flex justify-between items-start gap-2", children: [
          /* @__PURE__ */ l("span", { className: "text-xs sm:text-sm text-accent-secondary", children: o.label }),
          /* @__PURE__ */ l("div", { className: "flex flex-wrap gap-2", children: o.items.map((a, c) => /* @__PURE__ */ l(Yu, { item: a }, a.id || c)) })
        ] })
      },
      s
    )) }),
    n && /* @__PURE__ */ l("div", { className: "bg-surface p-3 sm:p-4 rounded space-y-3 sm:space-y-4 overflow-x-auto", children: t.map((o, s) => /* @__PURE__ */ l(
      oi,
      {
        label: o.label,
        value: o.value,
        collapsible: o.collapsible,
        nestedDetails: o.nestedDetails
      },
      s
    )) })
  ] });
}
function af({ data: e, className: t }) {
  return /* @__PURE__ */ b(
    "div",
    {
      className: `w-full bg-secondary-highlight p-3 sm:p-4 rounded flex flex-col justify-between ${t || ""}`,
      children: [
        /* @__PURE__ */ b("div", { className: "space-y-3 sm:space-y-4", children: [
          /* @__PURE__ */ l(
            Ku,
            {
              formattedAmount: e.formattedAmount,
              icon: e.icon,
              iconAlt: e.iconAlt,
              chainName: e.chainName,
              chainIcon: e.chainIcon,
              chainIconAlt: e.chainIconAlt
            }
          ),
          /* @__PURE__ */ l(
            Gu,
            {
              details: e.details,
              optionalDetails: e.optionalDetails,
              listItems: e.listItems
            }
          ),
          e.secondaryActions && e.secondaryActions.length > 0 && /* @__PURE__ */ l(Xu, { actions: e.secondaryActions })
        ] }),
        e.primaryAction && /* @__PURE__ */ l(
          Me,
          {
            variant: "outlined",
            className: `mt-4 ${e.primaryAction.className || ""}`,
            onClick: e.primaryAction.onClick,
            fluid: e.primaryAction.fullWidth !== !1,
            children: e.primaryAction.label
          }
        )
      ]
    }
  );
}
function Ju({ className: e, ...t }) {
  const n = jt(Kr) ? ir : Xr;
  return /* @__PURE__ */ l(n, { ...t, className: le("w-[41.25rem] max-w-full", e) });
}
const lf = ({
  open: e,
  processing: t = !1,
  title: r,
  onClose: n,
  onProceed: i,
  tokens: o,
  transactionFees: s
}) => /* @__PURE__ */ b(Ju, { open: e, onClose: n, children: [
  /* @__PURE__ */ l(En, { title: r, className: "text-accent-primary" }),
  /* @__PURE__ */ l(On, { className: "no-scrollbar mb-[40px] mt-8 flex max-h-[calc(100vh-12rem)] flex-col overflow-y-auto text-accent-primary", children: /* @__PURE__ */ b("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ l("div", { className: "max-h-[300px] overflow-y-auto", children: o.map((a, c) => {
      var d, u;
      return /* @__PURE__ */ b("div", { children: [
        /* @__PURE__ */ l(jr, { title: a.name, hint: (d = a.amount) == null ? void 0 : d.usd, children: /* @__PURE__ */ b("div", { className: "flex items-center gap-2", children: [
          a.icon,
          (u = a.amount) == null ? void 0 : u.token
        ] }) }),
        c < o.length - 1 && /* @__PURE__ */ l("div", { className: "h-4" })
      ] }, `token-${c}`);
    }) }),
    s.token && (isNaN(parseFloat(s.token)) || parseFloat(s.token) > 0) && /* @__PURE__ */ b(Pe, { children: [
      /* @__PURE__ */ l("div", { className: "py-6", children: /* @__PURE__ */ l("div", { className: "border-divider w-full border-t" }) }),
      /* @__PURE__ */ l(jr, { title: "Transaction Fees", hint: s.usd, children: s.token })
    ] })
  ] }) }),
  /* @__PURE__ */ b(_n, { className: "flex flex-col gap-4 pt-0 sm:flex-row", children: [
    /* @__PURE__ */ l(
      Me,
      {
        variant: "contained",
        color: "primary",
        onClick: i,
        className: "w-full sm:order-2 sm:flex-1",
        disabled: t,
        children: t ? "Processing..." : "Proceed"
      }
    ),
    /* @__PURE__ */ l(Me, { variant: "outlined", color: "primary", onClick: n, className: "w-full sm:order-1 sm:flex-1", children: "Cancel" })
  ] })
] }), cf = ({ rewards: e, onClick: t, disabled: r }) => /* @__PURE__ */ b(zt, { className: "flex w-full flex-col content-center justify-between gap-4", children: [
  e.map((n, i) => {
    var a;
    const o = Number.parseFloat(String(n.amount)), s = ia(
      o,
      ((a = n.balanceDetails) == null ? void 0 : a.price) ?? 0,
      { zeroDisplay: "$0.00" }
    );
    return /* @__PURE__ */ l(
      Ci,
      {
        amount: n.amount,
        currencyIcon: n.currencyIcon,
        currencyName: n.currencyName,
        placeholder: n.placeholder ?? "Enter Amount",
        displayBalance: n.displayBalance,
        balanceDetails: n.balanceDetails,
        min: n.min ?? "0",
        step: n.step ?? "any",
        autoFocus: !1,
        onChange: () => {
        },
        onKeyDown: () => {
        },
        amountUsd: s,
        disabled: !0,
        subtitle: n.chainName
      },
      i
    );
  }),
  /* @__PURE__ */ l(Me, { onClick: t, disabled: r, children: "Claim" })
] }), uf = ({
  totalAmount: e,
  totalSymbol: t,
  btcRewardAmount: r,
  btcSymbol: n,
  babyRewardAmount: i,
  babySymbol: o,
  coStakingAmount: s,
  avatarUrl: a,
  onClaim: c,
  onStakeMore: d,
  claimDisabled: u,
  stakeMoreCta: f
}) => /* @__PURE__ */ b("div", { className: "bbn-co-staking-rewards", children: [
  /* @__PURE__ */ b("div", { className: "bbn-co-staking-rewards-header", children: [
    a && /* @__PURE__ */ l(Jt, { url: a, size: "large", alt: t }),
    e,
    " ",
    t
  ] }),
  /* @__PURE__ */ b("div", { className: "bbn-co-staking-rewards-items", children: [
    /* @__PURE__ */ l(
      Pn,
      {
        title: `${n} staking`,
        amount: r,
        symbol: t,
        caption: `Rewards earned by staking ${n}`
      }
    ),
    /* @__PURE__ */ l(
      Pn,
      {
        title: `${o} staking`,
        amount: i,
        symbol: t,
        caption: `Rewards earned from staking ${o}`
      }
    ),
    s && /* @__PURE__ */ l(
      Pn,
      {
        title: "Co-staking",
        amount: s,
        symbol: t,
        caption: `Bonus rewards for staking both ${n} and ${o} together`
      }
    )
  ] }),
  /* @__PURE__ */ b("div", { className: "bbn-co-staking-rewards-actions", children: [
    /* @__PURE__ */ l(
      Me,
      {
        fluid: !0,
        size: "medium",
        variant: d ? "outlined" : "contained",
        onClick: c,
        disabled: u,
        children: "Claim Rewards"
      }
    ),
    d && /* @__PURE__ */ l(Me, { fluid: !0, size: "medium", onClick: d, children: f })
  ] })
] }), Qu = ({ size: e = "md" }) => /* @__PURE__ */ l("div", { className: {
  sm: "mt-2",
  md: "mt-4",
  lg: "mt-6"
}[e] }), ed = () => /* @__PURE__ */ l("svg", { width: "29", height: "28", viewBox: "0 0 29 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ l(
  "path",
  {
    d: "M24.9127 15.3708C24.9711 14.9333 25.0002 14.4812 25.0002 14C25.0002 13.5333 24.9711 13.0667 24.8982 12.6292L27.8586 10.325C28.1211 10.1208 28.194 9.72708 28.0336 9.43542L25.2336 4.59375C25.0586 4.27292 24.694 4.17083 24.3732 4.27292L20.8877 5.67292C20.1586 5.11875 19.3857 4.65208 18.5252 4.30208L18.0002 0.597916C17.9419 0.247916 17.6502 0 17.3002 0H11.7002C11.3502 0 11.0732 0.247916 11.0148 0.597916L10.4898 4.30208C9.62941 4.65208 8.84191 5.13333 8.12732 5.67292L4.64191 4.27292C4.32107 4.15625 3.95649 4.27292 3.78149 4.59375L0.996075 9.43542C0.821075 9.74167 0.879408 10.1208 1.17107 10.325L4.13149 12.6292C4.05857 13.0667 4.00024 13.5479 4.00024 14C4.00024 14.4521 4.02941 14.9333 4.10232 15.3708L1.14191 17.675C0.879408 17.8792 0.806491 18.2729 0.966908 18.5646L3.76691 23.4062C3.94191 23.7271 4.30649 23.8292 4.62732 23.7271L8.11274 22.3271C8.84191 22.8812 9.61482 23.3479 10.4752 23.6979L11.0002 27.4021C11.0732 27.7521 11.3502 28 11.7002 28H17.3002C17.6502 28 17.9419 27.7521 17.9857 27.4021L18.5107 23.6979C19.3711 23.3479 20.1586 22.8812 20.8732 22.3271L24.3586 23.7271C24.6794 23.8438 25.044 23.7271 25.219 23.4062L28.019 18.5646C28.194 18.2437 28.1211 17.8792 27.844 17.675L24.9127 15.3708ZM14.5002 19.25C11.6127 19.25 9.25024 16.8875 9.25024 14C9.25024 11.1125 11.6127 8.75 14.5002 8.75C17.3877 8.75 19.7502 11.1125 19.7502 14C19.7502 16.8875 17.3877 19.25 14.5002 19.25Z",
    fill: "#9E9E9E"
  }
) }), oa = () => /* @__PURE__ */ l("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ l("path", { d: "M9 18L15 12L9 6", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) }), td = ({ children: e, className: t = "" }) => /* @__PURE__ */ l(Z, { variant: "body1", className: _("px-7 pb-6 text-accent-primary md:hidden", t), children: e }), rd = ({
  background: e = "none",
  backgroundClassName: t = "",
  className: r = "",
  children: n
}) => /* @__PURE__ */ l("div", { className: _((() => {
  switch (e) {
    case "secondary":
      return "mx-[21px] rounded-lg bg-secondary-highlight md:mx-0 md:bg-transparent";
    case "custom":
      return t;
    default:
      return "";
  }
})(), r), children: n }), zr = ({ children: e }) => /* @__PURE__ */ l(Pe, { children: e }), sa = ({
  icon: e,
  suffix: t,
  onClick: r,
  disabled: n = !1,
  selected: i = !1,
  className: o = "",
  toggle: s,
  children: a
}) => {
  const c = q.Children.toArray(a), d = c.find(
    (h) => typeof h == "string" || q.isValidElement(h) && h.type !== zr
  ), u = c.find(
    (h) => q.isValidElement(h) && h.type === zr
  ), f = typeof d == "string" ? d : "", p = r && !s ? /* @__PURE__ */ l(oa, {}) : void 0;
  return /* @__PURE__ */ l(
    vs,
    {
      icon: e,
      name: f,
      description: u ? u.props.children : void 0,
      onClick: r,
      disabled: n,
      selected: i,
      className: o,
      suffix: t || p,
      toggle: s
    }
  );
}, nd = ({ icon: e, className: t = "", children: r }) => {
  const n = q.Children.toArray(r), i = n.find(
    (c) => typeof c == "string" || q.isValidElement(c) && c.type !== zr
  ), o = n.find(
    (c) => q.isValidElement(c) && c.type === zr
  ), s = n.filter((c) => q.isValidElement(c) && c.type === sa);
  return /* @__PURE__ */ l(
    Ec,
    {
      icon: e,
      name: typeof i == "string" ? i : "",
      description: o ? o.props.children : void 0,
      className: t,
      suffix: /* @__PURE__ */ l(oa, {}),
      children: s
    }
  );
}, id = ({ children: e, className: t = "" }) => /* @__PURE__ */ l("div", { className: t, children: e }), od = ({
  trigger: e,
  open: t,
  onOpenChange: r,
  placement: n = "bottom-end",
  className: i,
  offset: o = [0, 8],
  children: s
}) => /* @__PURE__ */ l(
  xi,
  {
    trigger: e || /* @__PURE__ */ l(
      "button",
      {
        className: "flex h-10 w-10 items-center justify-center rounded-lg transition-colors hover:bg-accent-primary/10",
        "aria-label": "Settings menu",
        children: /* @__PURE__ */ l(ed, {})
      }
    ),
    open: t,
    onOpenChange: r,
    placement: n,
    className: _("relative", i),
    offset: o,
    mobileMode: "drawer",
    children: s
  }
), Ue = od;
Ue.Title = td;
Ue.Group = rd;
Ue.Item = sa;
Ue.SubMenu = nd;
Ue.Description = zr;
Ue.CustomContent = id;
Ue.Spacer = Qu;
const df = ({
  theme: e,
  setTheme: t,
  trigger: r,
  open: n,
  onOpenChange: i
}) => {
  const [o, s] = G(
    e || "system"
  );
  J(() => {
    e && s(e);
  }, [e]);
  const a = o === "light", c = (p) => {
    const h = p ? "light" : "dark";
    s(h), t(h);
  }, d = () => {
    window.open(
      "https://babylonlabs.io/terms-of-use",
      "_blank",
      "noopener,noreferrer"
    );
  }, u = () => {
    window.open(
      "https://babylonlabs.io/privacy-policy",
      "_blank",
      "noopener,noreferrer"
    );
  }, f = () => a ? "Light mode" : "Dark mode";
  return /* @__PURE__ */ b(Ue, { trigger: r, open: n, onOpenChange: i, children: [
    /* @__PURE__ */ l(Ue.Title, { children: "Settings" }),
    /* @__PURE__ */ l(Ue.Group, { background: "secondary", children: /* @__PURE__ */ b(
      Ue.Item,
      {
        icon: /* @__PURE__ */ l(Ql, {}),
        toggle: {
          value: a,
          onChange: c
        },
        children: [
          "Theme",
          /* @__PURE__ */ l(Ue.Description, { children: f() })
        ]
      }
    ) }),
    /* @__PURE__ */ b(Ue.Group, { children: [
      /* @__PURE__ */ l(Ue.Item, { onClick: d, children: "Terms of Use" }),
      /* @__PURE__ */ l(Ue.Item, { onClick: u, children: "Privacy Policy" })
    ] })
  ] });
};
function ff({
  amount: e,
  currencyIcon: t,
  currencyName: r,
  onAmountChange: n,
  sliderValue: i,
  sliderMin: o,
  sliderMax: s,
  sliderStep: a = 1,
  sliderSteps: c,
  onSliderChange: d,
  onSliderStepsChange: u,
  sliderVariant: f = "primary",
  sliderActiveColor: p,
  sliderBackgroundColor: h,
  leftField: m,
  rightField: g,
  onMaxClick: y,
  disabled: A = !1,
  readOnly: w = !1,
  className: L
}) {
  var S;
  const N = (E) => {
    (E.key === "ArrowUp" || E.key === "ArrowDown") && E.preventDefault();
  }, k = h || (p ? `color-mix(in srgb, ${p} 20%, white)` : void 0);
  return /* @__PURE__ */ b("div", { className: _("flex w-full flex-col gap-4", L), children: [
    /* @__PURE__ */ b("div", { className: "flex w-full items-center justify-between", children: [
      /* @__PURE__ */ b("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ l("img", { src: t, alt: r, className: "h-10 w-10" }),
        /* @__PURE__ */ l("span", { className: "text-lg text-accent-primary", children: r })
      ] }),
      /* @__PURE__ */ l(
        "input",
        {
          type: "number",
          value: e,
          onChange: n,
          onKeyDown: N,
          disabled: A,
          readOnly: w || !n,
          placeholder: "0",
          className: "w-2/3 bg-transparent text-right text-lg outline-none appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none text-accent-primary"
        }
      )
    ] }),
    /* @__PURE__ */ l(
      "div",
      {
        className: _(
          k && "[&_.bbn-slider]:[--slider-inactive-color:var(--slider-bg-color)] dark:[&_.bbn-slider]:[--slider-inactive-color:#5a5a5a]"
        ),
        style: k ? { "--slider-bg-color": k } : void 0,
        children: /* @__PURE__ */ l(
          wc,
          {
            value: i,
            min: o,
            max: s,
            step: a,
            steps: c,
            onChange: d,
            onStepsChange: u,
            variant: f,
            activeColor: p,
            disabled: A
          }
        )
      }
    ),
    /* @__PURE__ */ b("div", { className: "flex items-center justify-between text-sm", children: [
      m && y && ((S = m.label) == null ? void 0 : S.toLowerCase()) === "max" ? /* @__PURE__ */ b(
        "button",
        {
          type: "button",
          onClick: y,
          disabled: A,
          className: "flex items-center gap-2 text-accent-secondary hover:text-accent-primary transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
          children: [
            /* @__PURE__ */ l("span", { className: "cursor-pointer rounded-[8px] border border-gray-300 bg-transparent px-2 py-0.5 text-xs tracking-[0.4px] hover:opacity-90 dark:border-[#2F2F2F] dark:bg-[#2F2F2F]", children: "Max" }),
            /* @__PURE__ */ l("span", { children: m.value })
          ]
        }
      ) : m && /* @__PURE__ */ b("span", { className: "text-accent-secondary", children: [
        m.label && `${m.label}: `,
        m.value
      ] }),
      g && /* @__PURE__ */ l("span", { className: "text-accent-secondary", children: g.value })
    ] })
  ] });
}
const Kn = ({
  walletType: e,
  walletName: t,
  walletIcon: r,
  address: n,
  isCopied: i,
  onCopy: o,
  className: s,
  balances: a,
  coinSymbol: c,
  isBalanceLoading: d = !1,
  hasUnconfirmedTransactions: u = !1,
  formatBalance: f
}) => {
  const h = f || ((w) => c ? `${w.toLocaleString(void 0, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 8
  })} ${c}` : w.toString()), m = (w, L = !1) => d || L ? /* @__PURE__ */ l(ls, { size: 20, className: "text-accent-primary" }) : w === void 0 ? /* @__PURE__ */ l(Z, { className: "text-accent-secondary text-sm", children: "N/A" }) : /* @__PURE__ */ l(Z, { variant: "body1", className: "text-accent-primary !text-sm", children: h(w) }), g = () => /* @__PURE__ */ b(Pe, { children: [
    (a == null ? void 0 : a.staked) !== void 0 && /* @__PURE__ */ b("div", { className: "flex flex-col mb-1", children: [
      /* @__PURE__ */ l(
        Z,
        {
          variant: "body1",
          className: "text-accent-secondary font-medium !text-xs",
          children: "Staked Balance"
        }
      ),
      /* @__PURE__ */ l("div", { "data-testid": "staked-balance", children: m(a.staked) })
    ] }),
    (a == null ? void 0 : a.stakable) !== void 0 && /* @__PURE__ */ b("div", { className: "flex flex-col", children: [
      /* @__PURE__ */ l(
        Z,
        {
          variant: "body1",
          className: "text-accent-secondary font-medium !text-xs",
          children: "Stakable Balance"
        }
      ),
      /* @__PURE__ */ l("div", { className: "flex items-center gap-2", "data-testid": "stakable-balance", children: m(a.stakable, d || u) })
    ] })
  ] }), y = () => /* @__PURE__ */ l(Pe, { children: (a == null ? void 0 : a.available) !== void 0 && /* @__PURE__ */ b("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ l(
      Z,
      {
        variant: "body1",
        className: "text-accent-secondary font-medium !text-xs",
        children: "Balance"
      }
    ),
    /* @__PURE__ */ l("div", { "data-testid": "babylon-balance", children: m(a.available) })
  ] }) }), A = () => /* @__PURE__ */ l(Pe, { children: (a == null ? void 0 : a.available) !== void 0 && /* @__PURE__ */ b("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ l(
      Z,
      {
        variant: "body1",
        className: "text-accent-secondary font-medium !text-xs",
        children: "Balance"
      }
    ),
    /* @__PURE__ */ l("div", { "data-testid": "ethereum-balance", children: m(a.available) })
  ] }) });
  return /* @__PURE__ */ l("div", { className: _(
    "bg-[#F9F9F9] dark:bg-[#2F2F2F] rounded-[4px] p-3 flex-1 md:p-4",
    s
  ), children: /* @__PURE__ */ b("div", { className: "flex flex-col w-full", children: [
    /* @__PURE__ */ b("div", { className: "flex items-center gap-2.5 mb-2 md:mb-3", children: [
      /* @__PURE__ */ l(
        Jt,
        {
          alt: t || e,
          url: r || "",
          size: "large",
          className: "w-8 h-8 md:w-10 md:h-10 flex-shrink-0"
        }
      ),
      /* @__PURE__ */ b("div", { className: "flex flex-1 flex-col items-start min-w-0", children: [
        /* @__PURE__ */ b(
          Z,
          {
            variant: "body1",
            className: "text-accent-primary font-medium text-xs",
            children: [
              e,
              " Wallet"
            ]
          }
        ),
        /* @__PURE__ */ b("div", { className: "flex items-center gap-1", children: [
          i ? /* @__PURE__ */ l(Z, { className: "text-accent-secondary text-xs", children: "Copied ✓" }) : /* @__PURE__ */ l(
            gs,
            {
              className: "text-accent-secondary text-xs",
              value: n,
              symbols: 6
            }
          ),
          /* @__PURE__ */ l(
            "button",
            {
              onClick: o,
              className: "flex-shrink-0 p-1 rounded hover:bg-[#d7e1e7] dark:hover:bg-[#252525] transition-colors h-6 w-6 flex items-center justify-center hover:opacity-80",
              children: /* @__PURE__ */ l(Ln, { size: 14, className: "md:w-4 md:h-4" })
            }
          )
        ] })
      ] })
    ] }),
    a && c && /* @__PURE__ */ b("div", { className: "space-y-2", children: [
      e === "Bitcoin" && g(),
      e === "Babylon" && y(),
      e === "Ethereum" && A()
    ] })
  ] }) });
}, Ri = ({
  trigger: e,
  btcAddress: t,
  bbnAddress: r,
  ethAddress: n,
  selectedWallets: i,
  onDisconnect: o,
  forceOpen: s = !1,
  onOpenChange: a,
  btcBalances: c,
  bbnBalances: d,
  ethBalances: u,
  btcCoinSymbol: f,
  bbnCoinSymbol: p,
  ethCoinSymbol: h,
  balancesLoading: m = !1,
  hasUnconfirmedTransactions: g = !1,
  formatBalance: y,
  settingsSection: A,
  className: w,
  mobileMode: L = "dialog",
  copy: N
}) => {
  var U, te, ie, oe, se, pe;
  const { copyToClipboard: k, isCopied: S } = Vn({ timeout: N == null ? void 0 : N.timeout }), E = (N == null ? void 0 : N.isCopied) ?? S, V = (N == null ? void 0 : N.copyToClipboard) ?? k, [I, H] = G(s), W = ge((de) => {
    H(de), a == null || a(de);
  }, [a]), O = ge(() => {
    H(!1), o();
  }, [o]), T = (de) => {
    if (!(!y || !de))
      return (Se) => y(Se, de);
  }, $ = f || "BTC", X = p || "BABY", K = h || "ETH";
  return /* @__PURE__ */ l(
    xi,
    {
      trigger: e,
      open: I,
      onOpenChange: W,
      mobileMode: L,
      className: _(
        "shadow-lg border border-[#38708533] bg-surface dark:border-[#404040] rounded-lg",
        w
      ),
      children: /* @__PURE__ */ b("div", { className: "p-4 space-y-6 w-full text-primary-main", children: [
        /* @__PURE__ */ b("div", { className: "flex flex-row gap-2 w-full md:flex-col", children: [
          t && /* @__PURE__ */ l(
            Kn,
            {
              walletType: "Bitcoin",
              walletName: (U = i.BTC) == null ? void 0 : U.name,
              walletIcon: (te = i.BTC) == null ? void 0 : te.icon,
              address: t,
              isCopied: E("btc"),
              onCopy: () => V("btc", t),
              balances: c,
              coinSymbol: $,
              isBalanceLoading: m,
              hasUnconfirmedTransactions: g,
              formatBalance: T($)
            }
          ),
          r && /* @__PURE__ */ l(
            Kn,
            {
              walletType: "Babylon",
              walletName: (ie = i.BBN) == null ? void 0 : ie.name,
              walletIcon: (oe = i.BBN) == null ? void 0 : oe.icon,
              address: r,
              isCopied: E("bbn"),
              onCopy: () => V("bbn", r),
              balances: d,
              coinSymbol: X,
              isBalanceLoading: m,
              formatBalance: T(X)
            }
          ),
          n && /* @__PURE__ */ l(
            Kn,
            {
              walletType: "Ethereum",
              walletName: (se = i.ETH) == null ? void 0 : se.name,
              walletIcon: (pe = i.ETH) == null ? void 0 : pe.icon,
              address: n,
              isCopied: E("eth"),
              onCopy: () => V("eth", n),
              balances: u,
              coinSymbol: K,
              isBalanceLoading: m,
              formatBalance: T(K)
            }
          )
        ] }),
        A,
        /* @__PURE__ */ l("div", { className: "pt-2", children: /* @__PURE__ */ l(
          Io,
          {
            onClick: O,
            fluid: !0,
            children: "Disconnect Wallets"
          }
        ) })
      ] })
    }
  );
}, si = ({
  icon: e,
  title: t,
  status: r,
  value: n,
  onChange: i,
  className: o,
  tooltip: s,
  infoIcon: a
}) => /* @__PURE__ */ b("div", { className: _(
  "flex items-center justify-between w-full p-3 md:p-0 md:mb-0",
  o
), children: [
  /* @__PURE__ */ b("div", { className: "flex items-center gap-4", children: [
    e,
    /* @__PURE__ */ b("div", { className: "flex flex-col", children: [
      a && s ? /* @__PURE__ */ b(
        Z,
        {
          as: "span",
          variant: "body2",
          className: "text-accent-primary font-medium",
          children: [
            t,
            /* @__PURE__ */ l(
              xo,
              {
                tooltip: s,
                placement: "bottom",
                attachToChildren: !0,
                offset: [20, 8],
                children: /* @__PURE__ */ l("span", { className: "inline-block align-middle text-secondary-strokeDark cursor-pointer ml-1", children: a })
              }
            )
          ]
        }
      ) : /* @__PURE__ */ l(
        xo,
        {
          tooltip: s,
          attachToChildren: !!s,
          placement: "bottom",
          children: /* @__PURE__ */ l(
            Z,
            {
              as: "span",
              variant: "body2",
              className: "text-accent-primary font-medium",
              children: t
            }
          )
        }
      ),
      /* @__PURE__ */ l(Z, { className: "text-accent-secondary !text-xs", children: r })
    ] })
  ] }),
  /* @__PURE__ */ l(
    fs,
    {
      value: n,
      onChange: i
    }
  )
] }), aa = ({
  title: e,
  value: t,
  isCopied: r,
  onCopy: n,
  className: i,
  icon: o
}) => /* @__PURE__ */ l("div", { className: _(
  "flex items-center justify-between w-full p-3 md:p-0 md:mb-0",
  i
), children: /* @__PURE__ */ l("div", { className: "flex flex-col w-full", children: /* @__PURE__ */ b("div", { className: "flex items-center gap-4", children: [
  o && /* @__PURE__ */ l("div", { className: "flex-shrink-0", children: o }),
  /* @__PURE__ */ b("div", { className: "flex w-full", children: [
    /* @__PURE__ */ b("div", { className: "flex flex-col w-full", children: [
      /* @__PURE__ */ l(
        Z,
        {
          variant: "body2",
          className: "text-accent-primary font-medium text-sm",
          children: e
        }
      ),
      /* @__PURE__ */ l("div", { className: "flex items-center justify-between w-full", children: /* @__PURE__ */ l("div", { className: "flex-1 min-w-0", children: r ? /* @__PURE__ */ l(Z, { className: "text-accent-secondary !text-xs truncate whitespace-nowrap", children: "Copied ✓" }) : /* @__PURE__ */ l(
        gs,
        {
          className: "text-accent-secondary !text-xs",
          value: t,
          symbols: 6
        }
      ) }) })
    ] }),
    /* @__PURE__ */ l(
      "button",
      {
        onClick: n,
        className: "flex-shrink-0 ml-3 p-1 rounded hover:bg-surface-tertiary transition-colors h-6 w-6 flex items-center justify-center hover:opacity-80 self-center",
        children: /* @__PURE__ */ l(Ln, { size: 16 })
      }
    )
  ] })
] }) }) }), hf = ({
  ordinalsExcluded: e,
  onIncludeOrdinals: t,
  onExcludeOrdinals: r,
  publicKeyNoCoord: n,
  copy: i,
  ...o
}) => {
  const { copyToClipboard: s, isCopied: a } = Vn({ timeout: i == null ? void 0 : i.timeout }), c = (i == null ? void 0 : i.isCopied) ?? a, d = (i == null ? void 0 : i.copyToClipboard) ?? s, u = /* @__PURE__ */ b("div", { className: "flex flex-col w-full bg-neutral-100 rounded-lg md:bg-transparent md:border-none md:gap-8", children: [
    /* @__PURE__ */ l(
      si,
      {
        icon: /* @__PURE__ */ l(Rr, { variant: "primary", background: !0, rounded: !0, children: /* @__PURE__ */ l(os, {}) }),
        title: "Using Inscriptions",
        status: e ? "Off" : "On",
        value: !e,
        onChange: (f) => f ? t() : r()
      }
    ),
    /* @__PURE__ */ l(
      aa,
      {
        title: "Bitcoin Public Key",
        value: n,
        isCopied: c("publicKey"),
        onCopy: () => d("publicKey", n),
        icon: /* @__PURE__ */ l(Rr, { variant: "primary", background: !0, rounded: !0, children: /* @__PURE__ */ l(is, {}) }),
        className: "rounded-b-lg rounded-t-none md:rounded-none"
      }
    )
  ] });
  return /* @__PURE__ */ l(
    Ri,
    {
      ...o,
      copy: i,
      settingsSection: u
    }
  );
}, mf = ({
  ordinalsExcluded: e,
  onIncludeOrdinals: t,
  onExcludeOrdinals: r,
  linkedDelegationsVisibility: n,
  onDisplayLinkedDelegations: i,
  publicKeyNoCoord: o,
  copy: s,
  ...a
}) => {
  const { copyToClipboard: c, isCopied: d } = Vn({ timeout: s == null ? void 0 : s.timeout }), u = (s == null ? void 0 : s.isCopied) ?? d, f = (s == null ? void 0 : s.copyToClipboard) ?? c, p = /* @__PURE__ */ b("div", { className: "flex flex-col w-full bg-neutral-100 rounded-lg md:bg-transparent md:border-none md:gap-8", children: [
    /* @__PURE__ */ l(
      si,
      {
        icon: /* @__PURE__ */ l(Rr, { variant: "primary", background: !0, rounded: !0, children: /* @__PURE__ */ l(os, {}) }),
        title: "Using Inscriptions",
        status: e ? "Off" : "On",
        value: !e,
        onChange: (h) => h ? t() : r()
      }
    ),
    /* @__PURE__ */ l(
      si,
      {
        icon: /* @__PURE__ */ l(Rr, { variant: "primary", background: !0, rounded: !0, children: /* @__PURE__ */ l(Kl, {}) }),
        title: /* @__PURE__ */ b(Pe, { children: [
          "Linked Wallet",
          /* @__PURE__ */ l("br", { className: "hidden md:block" }),
          /* @__PURE__ */ l("span", { className: "md:hidden", children: " " }),
          "Stakes"
        ] }),
        status: n ? "On" : "Off",
        value: n,
        onChange: i,
        tooltip: "Linked Wallet Stakes show all stakes created with the same Bitcoin wallet, even if different BABY wallets were used. It helps you track and manage them in one place.",
        infoIcon: /* @__PURE__ */ l(ss, { size: 14, variant: "secondary" })
      }
    ),
    /* @__PURE__ */ l(
      aa,
      {
        title: "Bitcoin Public Key",
        value: o,
        isCopied: u("publicKey"),
        onCopy: () => f("publicKey", o),
        icon: /* @__PURE__ */ l(Rr, { variant: "primary", background: !0, rounded: !0, children: /* @__PURE__ */ l(is, {}) }),
        className: "rounded-b-lg rounded-t-none md:rounded-none"
      }
    )
  ] });
  return /* @__PURE__ */ l(
    Ri,
    {
      ...a,
      copy: s,
      settingsSection: p
    }
  );
}, pf = (e) => /* @__PURE__ */ l(Ri, { ...e, settingsSection: null });
function sd({ className: e, ...t }) {
  const n = jt(Kr) ? ir : Xr;
  return /* @__PURE__ */ l(n, { ...t, className: le("w-[41.25rem] max-w-full", e) });
}
const vf = ({
  open: e,
  onClose: t,
  title: r = "Unbonding",
  description: n,
  reward: i,
  amountUsd: o = "",
  onChange: s = () => {
  },
  onKeyDown: a = () => {
  },
  disabled: c = !1,
  warningText: d,
  actionButtonText: u = "Unbond",
  onActionClick: f
}) => /* @__PURE__ */ b(sd, { open: e, onClose: t, children: [
  /* @__PURE__ */ l(En, { title: r, onClose: t, className: "text-accent-primary" }),
  /* @__PURE__ */ b(
    On,
    {
      style: { maxHeight: ic },
      className: "no-scrollbar mt-4 flex flex-col gap-6 overflow-y-auto text-accent-primary",
      children: [
        n && /* @__PURE__ */ l("div", { children: /* @__PURE__ */ l(Z, { variant: "body2", className: "text-accent-secondary whitespace-pre-line", children: n }) }),
        /* @__PURE__ */ l(zt, { className: "flex w-full flex-col content-center justify-between gap-4", children: /* @__PURE__ */ l(
          Ci,
          {
            amount: i.amount,
            currencyIcon: i.currencyIcon,
            currencyName: i.currencyName,
            placeholder: i.placeholder ?? "Enter Amount",
            displayBalance: i.displayBalance,
            balanceDetails: i.balanceDetails,
            min: i.min ?? "0",
            step: i.step ?? "any",
            autoFocus: !1,
            onChange: s,
            onKeyDown: a,
            amountUsd: o,
            disabled: c,
            subtitle: `Staked: ${i.stakedAmount || 0} ${i.stakedTokenName || i.currencyName}`
          }
        ) }),
        d && /* @__PURE__ */ l(Oc, { children: d })
      ]
    }
  ),
  u && /* @__PURE__ */ l(_n, { className: "flex justify-end mt-[80px]", children: /* @__PURE__ */ l(
    Me,
    {
      onClick: f,
      children: u
    }
  ) })
] });
export {
  dd as Accordion,
  hd as AccordionDetails,
  fd as AccordionSummary,
  af as ActivityCard,
  Xu as ActivityCardActionSection,
  Ku as ActivityCardAmountSection,
  Gu as ActivityCardDetailsSection,
  Yu as ActivityListItem,
  Ci as AmountItem,
  ff as AmountSlider,
  rf as AmountSubsection,
  Nd as AttributeList,
  Jt as Avatar,
  pa as AvatarGroup,
  Wu as BBNFeeAmount,
  nc as BBN_DECIMAL_PLACES,
  zu as BTCFeeAmount,
  ju as BTCFeeRate,
  wi as BTC_DECIMAL_PLACES,
  pf as BabyWalletMenu,
  Sc as Badge,
  is as BitcoinPublicKeyIcon,
  mf as BtcBabyWalletMenu,
  hf as BtcEthWalletMenu,
  yd as BugReportIcon,
  Me as Button,
  gc as Card,
  uc as Cell,
  wd as CheckIcon,
  ya as Checkbox,
  Xd as CheckboxField,
  gd as ChevronLeftIcon,
  bd as ChevronRightIcon,
  kd as Chip,
  An as CloseIcon,
  Pn as CoStakingAmountItem,
  uf as CoStakingRewardsSubsection,
  Gl as CollapseIcon,
  ac as Column,
  Id as ConnectButton,
  _s as Container,
  us as Copy,
  Ln as CopyIcon,
  pd as CoreUIProvider,
  Lc as CounterButton,
  iu as DEFAULT_SOCIAL_LINKS,
  Xr as Dialog,
  On as DialogBody,
  _n as DialogFooter,
  En as DialogHeader,
  _d as DismissibleSubSection,
  gs as DisplayHash,
  jr as FeeItem,
  of as FeesSection,
  xd as FilterIcon,
  Ms as FinalityProviderItem,
  Co as FinalityProviderLogo,
  nf as FinalityProviderSubsection,
  Hd as Footer,
  Wd as Form,
  Sn as FormControl,
  Fd as Header,
  ui as Heading,
  Eu as HiddenField,
  xo as Hint,
  Dd as Icon,
  li as IconButton,
  ss as InfoIcon,
  kn as Input,
  Sd as KeyValueList,
  Kl as LinkWalletIcon,
  Ld as List,
  Cc as ListItem,
  ls as Loader,
  P1 as Logo,
  ic as MAX_WINDOW_HEIGHT,
  jd as MarketStatCard,
  xi as Menu,
  ps as MenuDrawer,
  vs as MenuItem,
  ir as MobileDialog,
  Ts as MobileLogo,
  X1 as MobileNavOverlay,
  Rd as Nav,
  Bd as NavItem,
  Zd as NumberField,
  Jl as OpenIcon,
  Nn as Popover,
  Cn as Portal,
  sf as PreviewModal,
  zd as ProviderCard,
  xa as Radio,
  Kd as RadioField,
  Cd as ResponsiveDialog,
  lf as RewardsPreviewModal,
  cf as RewardsSubsection,
  vd as ScrollLocker,
  yi as Select,
  Yd as SelectField,
  Xl as SelectWithIcon,
  Ue as SettingMenu,
  id as SettingMenuCustomContent,
  zr as SettingMenuDescription,
  rd as SettingMenuGroup,
  sa as SettingMenuItem,
  nd as SettingMenuSubMenu,
  td as SettingMenuTitle,
  wc as Slider,
  Vs as SmallLogo,
  df as StandardSettingsMenu,
  Ad as StatItem,
  $d as StatusBadge,
  Md as Step,
  Ec as SubMenu,
  Ed as SubMenuItem,
  zt as SubSection,
  lc as TABLE_STYLE_PRESETS,
  vc as Table,
  Ou as TableElement,
  Od as Tabs,
  Td as TestingBanner,
  Z as Text,
  qd as TextField,
  Ql as ThemeIcon,
  Rr as ThemedIcon,
  ec as ThreeDotsMenuIcon,
  fs as Toggle,
  Vd as TopBanner,
  Uu as Total,
  vf as UnbondingModal,
  os as UsingInscriptionIcon,
  md as ValidatorAvatar,
  Gd as ValidatorSelector,
  Pd as VaultDetailCard,
  Kr as WINDOW_BREAKPOINT,
  Io as WalletDisconnectButton,
  Ri as WalletMenu,
  Kn as WalletMenuCard,
  aa as WalletMenuInfoItem,
  si as WalletMenuSettingItem,
  Oc as Warning,
  Yl as WarningIcon,
  ia as calculateTokenValueInCurrency,
  Qd as createBalanceFormatter,
  ef as formatAmount,
  $u as formatCurrency,
  je as iconColorVariants,
  Bo as maxDecimals,
  tf as parseAmount,
  su as splitAmountUnit,
  Jd as toKebabCase,
  ci as toPixels,
  ds as trim,
  Zl as useClickOutside,
  St as useControlledState,
  Vn as useCopy,
  zl as useCoreUI,
  kc as useDrawerAnimation,
  Nr as useField,
  Ud as useFieldState,
  Cr as useFormContext,
  js as useFormState,
  sc as useFrozenColumns,
  jt as useIsMobile,
  Ul as useMemoizedArray,
  ms as useMenuContext,
  rs as useModalManager,
  es as useResizeObserver,
  oc as useTableScroll,
  cc as useTableSort,
  Ws as useWatch
};
//# sourceMappingURL=index.es.js.map
